/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * blabla
 * blabla
 * OpenAPI spec version: 1.0.59
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import {
  useCallback
} from 'react'
import type {
  AbsenceRequest,
  ActiveEmployees,
  ActiveJobs,
  Address,
  AdminOperationResponse,
  AllowedAddressesType,
  AllowedAttendanceTypes,
  AresResponse,
  AttachmentList,
  AttendanceEnding,
  AuditLogWithDiff,
  BankAccount,
  BatchUpdateTime,
  BatchUpdateTimeResponse,
  BestAndWorstEmployees,
  BestAndWorstJobs,
  ChangeRequestState,
  CheckAdminAccessResponse,
  Comment,
  CommentWithEmployee,
  ConfirmQrCodeScanRequest,
  ContactPerson,
  CoordinateExtend,
  CoordinateFilterValues,
  CoordinatesQueryResult,
  CopyJob,
  CopyTask,
  CountPayload,
  CreateAbsenceRequest,
  CreateAddress,
  CreateAttachmentResponse,
  CreateAttachmentServer,
  CreateBankAccount,
  CreateComment,
  CreateContactPerson,
  CreateCoordinate,
  CreateCustomer,
  CreateEmail,
  CreateEmployee,
  CreateGlobalSetting,
  CreateInvitation,
  CreateJob,
  CreateNotification,
  CreateOwner,
  CreateReaction,
  CreateRequest,
  CreateTask,
  CreateTempNativeLog,
  CreateTime,
  CreateUser,
  CreateUserRole,
  CreateWorkSchedule,
  CreateWorkplace,
  Customer,
  DailyEarningsWithTotalEarnings,
  DailyHoursWithTotalHours,
  DefaultAttendanceType,
  DeleteAttachmentResponse,
  EcomailUpload,
  EcomailUploadResponse,
  Employee,
  EmployeeCoordinates,
  EmployeeImportRequest,
  EmployeeImportResponse,
  EmployeeWithWorkSchedule,
  EmployeesCount,
  EmployeesTimeSheetsResponse,
  EntryWithoutEndResponse,
  ErrorPayload,
  FeatureFlag,
  FeatureFlagsResponse,
  FieldArrayTimeParams,
  GeneratePinForEmployee,
  GeneratePinForEmployees,
  GeofenceResponse,
  GetActiveEmployeesParams,
  GetAddressesParams,
  GetAllowedAddressesTypesParams,
  GetBankAccountsParams,
  GetBestAndWorstJobsByProductivityParams,
  GetCommentsParams,
  GetContactPersonsParams,
  GetCoordinateEmployeesParams,
  GetCoordinateJobsParams,
  GetCoordinateTasksParams,
  GetCoordinateTimeParams,
  GetCoordinatesParams,
  GetCustomersParams,
  GetDataForReviewTableParams,
  GetDataForTaskTableParams,
  GetDataForWorkplaceTableParams,
  GetDayModalTimesParams,
  GetEmployeeCoordinatesParams,
  GetEmployeeTimeSheetParams,
  GetEmployeeWithRelationsPaginatedResponse,
  GetEmployeesParams,
  GetEmployeesTimeSheetsParams,
  GetEmployeesWithPinAttendanceResponse,
  GetEmployeesWithScheduleParams,
  GetGroupedEmployeeTimesParams,
  GetJobByCoordinateIdParams,
  GetJobEmployeesResponse,
  GetJobRankingParams,
  GetJobRankingResponse,
  GetJobWithRelationsPaginatedResponse,
  GetJobsCostsParams,
  GetJobsParams,
  GetJobsProfitabilityPercentageParams,
  GetJobsWithEmployeesParams,
  GetJobsWithEmployeesResponse,
  GetJobsWithTimesParams,
  GetLastCoordinatesParams,
  GetMonthlyHoursOfAllEmployeesParams,
  GetMonthlySpendsParams,
  GetNotificationsParams,
  GetOwnerEmployeesInfo,
  GetOwnerEmployeesInfoParams,
  GetRequestsParams,
  GetSearchResultsParams,
  GetSuspiciousTimesParams,
  GetSuspiciousTimesResponse,
  GetTaskDetails,
  GetTasksCostsStats,
  GetTasksParams,
  GetTasksStats,
  GetTasksTimeStats,
  GetTimeReportsParams,
  GetTimeReportsResponse,
  GetTimeResponse,
  GetTimeTasksStats,
  GetTimesOverviewParams,
  GetTimesPaginatedResponse,
  GetTimesParams,
  GetUiSettingsByIdParams,
  GetUserRoleSettingsByOwnerIdParams,
  GetUserRolesByOwnerIdParams,
  GetUsersParams,
  GetWhisperAddressParams,
  GetWorkSchedulesParams,
  GlobalSetting,
  GroupedEmployeeTimes,
  GroupedNotifications,
  GroupedTimes,
  IcoRequest,
  Invitation,
  InviteEmployee,
  Job,
  JobId,
  JobImportRequest,
  JobImportResponse,
  JobWithRelations,
  JobsProfitabilityPercentage,
  JobsWithCosts,
  NearestCoordinatesResponse,
  Notification,
  NotificationWithRelations,
  Owner,
  OwnerCardStats,
  OwnerUpdate,
  OwnerWithRoles,
  Payload,
  PayloadId,
  PinGenerationPayload,
  QRCodeResponse,
  Reaction,
  RegisterQrResponse,
  RegisterQrTransmitterRequest,
  Request,
  RequestWithRelations,
  ReviewTableResponse,
  Search,
  SendEmailResponse,
  Settings,
  StripeAddEmployeeRequest,
  StripeAddEmployeeResponse,
  StripeCheckoutRequest,
  StripeCheckoutResponse,
  StripePortalRequest,
  StripePortalResponse,
  Task,
  TaskId,
  TaskTableResponse,
  TaskWithRelations,
  Time,
  TimeOverview,
  TimeOverviewPaginatedResponse,
  TimeReportingParams,
  TransformMessages,
  UiSettings,
  UpdateAddress,
  UpdateAttendance,
  UpdateAttendanceEnding,
  UpdateBankAccount,
  UpdateComment,
  UpdateContactPerson,
  UpdateCustomer,
  UpdateEmployee,
  UpdateInvitation,
  UpdateJob,
  UpdateJobsBatch,
  UpdateNotification,
  UpdateOwner,
  UpdatePinDefaultReportSettings,
  UpdatePinEventType,
  UpdatePinRequiredOnResponse,
  UpdateRequest,
  UpdateTask,
  UpdateTasksBatch,
  UpdateTime,
  UpdateUiSettings,
  UpdateUser,
  UpdateUserRole,
  UpdateWorkSchedule,
  UpdateWorkSchedulesBatch,
  UpdateWorkplace,
  UploadAvatar,
  UploadAvatarResponse,
  UploadOwnerAvatar,
  User,
  UserBaseData,
  UserRole,
  UserRoleWithRelations,
  WhisperAddress,
  WorkSchedule,
  Workplace,
  WorkplaceTableResponse,
  WorkplaceWithRelations
} from '@shared/zod-schemas'
import { useCustomInstance } from '../use-fetch-instance';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const useGetAllAbsenceRequestsHook = () => {
        const getAllAbsenceRequests = useCustomInstance<AbsenceRequest[]>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getAllAbsenceRequests(
          {url: `/api/${ownerId}/absence/requests/all`, method: 'GET', signal
    },
          options);
        }, [getAllAbsenceRequests])
      }
    

export const getGetAllAbsenceRequestsQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/absence/requests/all`] as const;
    }

    
export const useGetAllAbsenceRequestsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAbsenceRequestsQueryKey(ownerId);

  const getAllAbsenceRequests =  useGetAllAbsenceRequestsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>> = ({ signal }) => getAllAbsenceRequests(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllAbsenceRequestsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>>
export type GetAllAbsenceRequestsQueryError = ErrorPayload


export function useGetAllAbsenceRequests<TData = Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAllAbsenceRequests<TData = Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAllAbsenceRequests<TData = Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetAllAbsenceRequests<TData = Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllAbsenceRequestsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetAllAbsenceRequestsQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetAddressesByCustomerIdHook = () => {
        const getAddressesByCustomerId = useCustomInstance<Address[]>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getAddressesByCustomerId(
          {url: `/api/${ownerId}/addresses/customer/${id}`, method: 'GET', signal
    },
          options);
        }, [getAddressesByCustomerId])
      }
    

export const getGetAddressesByCustomerIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/addresses/customer/${id}`] as const;
    }

    
export const useGetAddressesByCustomerIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesByCustomerIdQueryKey(ownerId,id);

  const getAddressesByCustomerId =  useGetAddressesByCustomerIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>> = ({ signal }) => getAddressesByCustomerId(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddressesByCustomerIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>>
export type GetAddressesByCustomerIdQueryError = ErrorPayload


export function useGetAddressesByCustomerId<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAddressesByCustomerId<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAddressesByCustomerId<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetAddressesByCustomerId<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCustomerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetAddressesByCustomerIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetAuditLogTimeEntityByIdHook = () => {
        const getAuditLogTimeEntityById = useCustomInstance<AuditLogWithDiff[]>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getAuditLogTimeEntityById(
          {url: `/api/${ownerId}/auditLog/timeEntity/${id}`, method: 'GET', signal
    },
          options);
        }, [getAuditLogTimeEntityById])
      }
    

export const getGetAuditLogTimeEntityByIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/auditLog/timeEntity/${id}`] as const;
    }

    
export const useGetAuditLogTimeEntityByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditLogTimeEntityByIdQueryKey(ownerId,id);

  const getAuditLogTimeEntityById =  useGetAuditLogTimeEntityByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>> = ({ signal }) => getAuditLogTimeEntityById(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuditLogTimeEntityByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>>
export type GetAuditLogTimeEntityByIdQueryError = ErrorPayload


export function useGetAuditLogTimeEntityById<TData = Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAuditLogTimeEntityById<TData = Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAuditLogTimeEntityById<TData = Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetAuditLogTimeEntityById<TData = Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuditLogTimeEntityByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetAuditLogTimeEntityByIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostOwnerAvatarHook = () => {
        const postOwnerAvatar = useCustomInstance<Payload>();

        return useCallback((
    ownerId: string,
    uploadOwnerAvatar: UploadOwnerAvatar,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postOwnerAvatar(
          {url: `/api/${ownerId}/avatar`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: uploadOwnerAvatar
    },
          options);
        }, [postOwnerAvatar])
      }
    


export const usePostOwnerAvatarMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOwnerAvatarHook>>>, TError,{ownerId: string;data: UploadOwnerAvatar}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOwnerAvatarHook>>>, TError,{ownerId: string;data: UploadOwnerAvatar}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postOwnerAvatar =  usePostOwnerAvatarHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostOwnerAvatarHook>>>, {ownerId: string;data: UploadOwnerAvatar}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postOwnerAvatar(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostOwnerAvatarMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostOwnerAvatarHook>>>>
    export type PostOwnerAvatarMutationBody = UploadOwnerAvatar
    export type PostOwnerAvatarMutationError = ErrorPayload

    export const usePostOwnerAvatar = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOwnerAvatarHook>>>, TError,{ownerId: string;data: UploadOwnerAvatar}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostOwnerAvatarHook>>>,
        TError,
        {ownerId: string;data: UploadOwnerAvatar},
        TContext
      > => {

      const mutationOptions = usePostOwnerAvatarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetBestAndWorstJobsByProductivityHook = () => {
        const getBestAndWorstJobsByProductivity = useCustomInstance<BestAndWorstJobs>();

        return useCallback((
    ownerId: string,
    params: GetBestAndWorstJobsByProductivityParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getBestAndWorstJobsByProductivity(
          {url: `/api/${ownerId}/bestAndWorstJobs`, method: 'GET',
        params, signal
    },
          options);
        }, [getBestAndWorstJobsByProductivity])
      }
    

export const getGetBestAndWorstJobsByProductivityQueryKey = (ownerId: string,
    params: GetBestAndWorstJobsByProductivityParams,) => {
    return [`/api/${ownerId}/bestAndWorstJobs`, ...(params ? [params]: [])] as const;
    }

    
export const useGetBestAndWorstJobsByProductivityQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetBestAndWorstJobsByProductivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBestAndWorstJobsByProductivityQueryKey(ownerId,params);

  const getBestAndWorstJobsByProductivity =  useGetBestAndWorstJobsByProductivityHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>> = ({ signal }) => getBestAndWorstJobsByProductivity(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBestAndWorstJobsByProductivityQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>>
export type GetBestAndWorstJobsByProductivityQueryError = ErrorPayload


export function useGetBestAndWorstJobsByProductivity<TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetBestAndWorstJobsByProductivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetBestAndWorstJobsByProductivity<TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetBestAndWorstJobsByProductivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetBestAndWorstJobsByProductivity<TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetBestAndWorstJobsByProductivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetBestAndWorstJobsByProductivity<TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetBestAndWorstJobsByProductivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstJobsByProductivityHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetBestAndWorstJobsByProductivityQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetBestAndWorstEmployeesHook = () => {
        const getBestAndWorstEmployees = useCustomInstance<BestAndWorstEmployees>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getBestAndWorstEmployees(
          {url: `/api/${ownerId}/bestAndWorst`, method: 'GET', signal
    },
          options);
        }, [getBestAndWorstEmployees])
      }
    

export const getGetBestAndWorstEmployeesQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/bestAndWorst`] as const;
    }

    
export const useGetBestAndWorstEmployeesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBestAndWorstEmployeesQueryKey(ownerId);

  const getBestAndWorstEmployees =  useGetBestAndWorstEmployeesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>> = ({ signal }) => getBestAndWorstEmployees(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBestAndWorstEmployeesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>>
export type GetBestAndWorstEmployeesQueryError = ErrorPayload


export function useGetBestAndWorstEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetBestAndWorstEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetBestAndWorstEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetBestAndWorstEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBestAndWorstEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetBestAndWorstEmployeesQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateCommentByIdHook = () => {
        const updateCommentById = useCustomInstance<Comment>();

        return useCallback((
    ownerId: string,
    id: string,
    updateComment: UpdateComment,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateCommentById(
          {url: `/api/${ownerId}/comments/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateComment
    },
          options);
        }, [updateCommentById])
      }
    


export const useUpdateCommentByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateCommentByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateComment}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateCommentByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateComment}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateCommentById =  useUpdateCommentByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateCommentByIdHook>>>, {ownerId: string;id: string;data: UpdateComment}> = (props) => {
          const {ownerId,id,data} = props ?? {};

          return  updateCommentById(ownerId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCommentByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateCommentByIdHook>>>>
    export type UpdateCommentByIdMutationBody = UpdateComment
    export type UpdateCommentByIdMutationError = ErrorPayload

    export const useUpdateCommentById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateCommentByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateComment}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateCommentByIdHook>>>,
        TError,
        {ownerId: string;id: string;data: UpdateComment},
        TContext
      > => {

      const mutationOptions = useUpdateCommentByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteCommentByIdHook = () => {
        const deleteCommentById = useCustomInstance<Comment>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteCommentById(
          {url: `/api/${ownerId}/comments/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteCommentById])
      }
    


export const useDeleteCommentByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteCommentByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteCommentByIdHook>>>, TError,{ownerId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteCommentById =  useDeleteCommentByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteCommentByIdHook>>>, {ownerId: string;id: string}> = (props) => {
          const {ownerId,id} = props ?? {};

          return  deleteCommentById(ownerId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommentByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteCommentByIdHook>>>>
    
    export type DeleteCommentByIdMutationError = ErrorPayload

    export const useDeleteCommentById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteCommentByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteCommentByIdHook>>>,
        TError,
        {ownerId: string;id: string},
        TContext
      > => {

      const mutationOptions = useDeleteCommentByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetCommentByIdHook = () => {
        const getCommentById = useCustomInstance<Comment>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCommentById(
          {url: `/api/${ownerId}/comments/${id}`, method: 'GET', signal
    },
          options);
        }, [getCommentById])
      }
    

export const getGetCommentByIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/comments/${id}`] as const;
    }

    
export const useGetCommentByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommentByIdQueryKey(ownerId,id);

  const getCommentById =  useGetCommentByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>> = ({ signal }) => getCommentById(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCommentByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>>
export type GetCommentByIdQueryError = ErrorPayload


export function useGetCommentById<TData = Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCommentById<TData = Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCommentById<TData = Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCommentById<TData = Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCommentByIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetCommentsHook = () => {
        const getComments = useCustomInstance<CommentWithEmployee[]>();

        return useCallback((
    ownerId: string,
    params: GetCommentsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getComments(
          {url: `/api/${ownerId}/comments`, method: 'GET',
        params, signal
    },
          options);
        }, [getComments])
      }
    

export const getGetCommentsQueryKey = (ownerId: string,
    params: GetCommentsParams,) => {
    return [`/api/${ownerId}/comments`, ...(params ? [params]: [])] as const;
    }

    
export const useGetCommentsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommentsQueryKey(ownerId,params);

  const getComments =  useGetCommentsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>> = ({ signal }) => getComments(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCommentsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>>
export type GetCommentsQueryError = ErrorPayload


export function useGetComments<TData = Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetComments<TData = Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetComments<TData = Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetComments<TData = Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCommentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCommentsQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostCommentHook = () => {
        const postComment = useCustomInstance<Comment>();

        return useCallback((
    ownerId: string,
    createComment: CreateComment,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postComment(
          {url: `/api/${ownerId}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createComment
    },
          options);
        }, [postComment])
      }
    


export const usePostCommentMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCommentHook>>>, TError,{ownerId: string;data: CreateComment}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCommentHook>>>, TError,{ownerId: string;data: CreateComment}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postComment =  usePostCommentHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostCommentHook>>>, {ownerId: string;data: CreateComment}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postComment(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostCommentHook>>>>
    export type PostCommentMutationBody = CreateComment
    export type PostCommentMutationError = ErrorPayload

    export const usePostComment = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCommentHook>>>, TError,{ownerId: string;data: CreateComment}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostCommentHook>>>,
        TError,
        {ownerId: string;data: CreateComment},
        TContext
      > => {

      const mutationOptions = usePostCommentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetCoordinateEmployeesHook = () => {
        const getCoordinateEmployees = useCustomInstance<CoordinateFilterValues>();

        return useCallback((
    ownerId: string,
    params: GetCoordinateEmployeesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCoordinateEmployees(
          {url: `/api/${ownerId}/coordinates/employees`, method: 'GET',
        params, signal
    },
          options);
        }, [getCoordinateEmployees])
      }
    

export const getGetCoordinateEmployeesQueryKey = (ownerId: string,
    params: GetCoordinateEmployeesParams,) => {
    return [`/api/${ownerId}/coordinates/employees`, ...(params ? [params]: [])] as const;
    }

    
export const useGetCoordinateEmployeesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetCoordinateEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoordinateEmployeesQueryKey(ownerId,params);

  const getCoordinateEmployees =  useGetCoordinateEmployeesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>> = ({ signal }) => getCoordinateEmployees(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoordinateEmployeesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>>
export type GetCoordinateEmployeesQueryError = ErrorPayload


export function useGetCoordinateEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinateEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinateEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCoordinateEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCoordinateEmployeesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetCoordinateJobsHook = () => {
        const getCoordinateJobs = useCustomInstance<CoordinateFilterValues>();

        return useCallback((
    ownerId: string,
    params: GetCoordinateJobsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCoordinateJobs(
          {url: `/api/${ownerId}/coordinates/jobs`, method: 'GET',
        params, signal
    },
          options);
        }, [getCoordinateJobs])
      }
    

export const getGetCoordinateJobsQueryKey = (ownerId: string,
    params: GetCoordinateJobsParams,) => {
    return [`/api/${ownerId}/coordinates/jobs`, ...(params ? [params]: [])] as const;
    }

    
export const useGetCoordinateJobsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetCoordinateJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoordinateJobsQueryKey(ownerId,params);

  const getCoordinateJobs =  useGetCoordinateJobsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>> = ({ signal }) => getCoordinateJobs(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoordinateJobsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>>
export type GetCoordinateJobsQueryError = ErrorPayload


export function useGetCoordinateJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinateJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinateJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCoordinateJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCoordinateJobsQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetLastCoordinatesHook = () => {
        const getLastCoordinates = useCustomInstance<CoordinateExtend[]>();

        return useCallback((
    ownerId: string,
    params: GetLastCoordinatesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getLastCoordinates(
          {url: `/api/${ownerId}/coordinates/last`, method: 'GET',
        params, signal
    },
          options);
        }, [getLastCoordinates])
      }
    

export const getGetLastCoordinatesQueryKey = (ownerId: string,
    params: GetLastCoordinatesParams,) => {
    return [`/api/${ownerId}/coordinates/last`, ...(params ? [params]: [])] as const;
    }

    
export const useGetLastCoordinatesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetLastCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLastCoordinatesQueryKey(ownerId,params);

  const getLastCoordinates =  useGetLastCoordinatesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>> = ({ signal }) => getLastCoordinates(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLastCoordinatesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>>
export type GetLastCoordinatesQueryError = ErrorPayload


export function useGetLastCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetLastCoordinatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetLastCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetLastCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetLastCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetLastCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetLastCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetLastCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLastCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetLastCoordinatesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostCoordinateHook = () => {
        const postCoordinate = useCustomInstance<GeofenceResponse>();

        return useCallback((
    ownerId: string,
    createCoordinate: CreateCoordinate,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postCoordinate(
          {url: `/api/${ownerId}/coordinates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCoordinate
    },
          options);
        }, [postCoordinate])
      }
    


export const usePostCoordinateMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCoordinateHook>>>, TError,{ownerId: string;data: CreateCoordinate}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCoordinateHook>>>, TError,{ownerId: string;data: CreateCoordinate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postCoordinate =  usePostCoordinateHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostCoordinateHook>>>, {ownerId: string;data: CreateCoordinate}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postCoordinate(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoordinateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostCoordinateHook>>>>
    export type PostCoordinateMutationBody = CreateCoordinate
    export type PostCoordinateMutationError = ErrorPayload

    export const usePostCoordinate = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCoordinateHook>>>, TError,{ownerId: string;data: CreateCoordinate}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostCoordinateHook>>>,
        TError,
        {ownerId: string;data: CreateCoordinate},
        TContext
      > => {

      const mutationOptions = usePostCoordinateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetCoordinatesHook = () => {
        const getCoordinates = useCustomInstance<CoordinatesQueryResult[]>();

        return useCallback((
    ownerId: string,
    params: GetCoordinatesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCoordinates(
          {url: `/api/${ownerId}/coordinates`, method: 'GET',
        params, signal
    },
          options);
        }, [getCoordinates])
      }
    

export const getGetCoordinatesQueryKey = (ownerId: string,
    params: GetCoordinatesParams,) => {
    return [`/api/${ownerId}/coordinates`, ...(params ? [params]: [])] as const;
    }

    
export const useGetCoordinatesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoordinatesQueryKey(ownerId,params);

  const getCoordinates =  useGetCoordinatesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>> = ({ signal }) => getCoordinates(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoordinatesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>>
export type GetCoordinatesQueryError = ErrorPayload


export function useGetCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCoordinatesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetCoordinateTasksHook = () => {
        const getCoordinateTasks = useCustomInstance<CoordinateFilterValues>();

        return useCallback((
    ownerId: string,
    params: GetCoordinateTasksParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCoordinateTasks(
          {url: `/api/${ownerId}/coordinates/tasks`, method: 'GET',
        params, signal
    },
          options);
        }, [getCoordinateTasks])
      }
    

export const getGetCoordinateTasksQueryKey = (ownerId: string,
    params: GetCoordinateTasksParams,) => {
    return [`/api/${ownerId}/coordinates/tasks`, ...(params ? [params]: [])] as const;
    }

    
export const useGetCoordinateTasksQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetCoordinateTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoordinateTasksQueryKey(ownerId,params);

  const getCoordinateTasks =  useGetCoordinateTasksHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>> = ({ signal }) => getCoordinateTasks(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoordinateTasksQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>>
export type GetCoordinateTasksQueryError = ErrorPayload


export function useGetCoordinateTasks<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinateTasks<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinateTasks<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCoordinateTasks<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTasksHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCoordinateTasksQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetCoordinateTimeHook = () => {
        const getCoordinateTime = useCustomInstance<Time>();

        return useCallback((
    ownerId: string,
    params: GetCoordinateTimeParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCoordinateTime(
          {url: `/api/${ownerId}/coordinates/time`, method: 'GET',
        params, signal
    },
          options);
        }, [getCoordinateTime])
      }
    

export const getGetCoordinateTimeQueryKey = (ownerId: string,
    params: GetCoordinateTimeParams,) => {
    return [`/api/${ownerId}/coordinates/time`, ...(params ? [params]: [])] as const;
    }

    
export const useGetCoordinateTimeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetCoordinateTimeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoordinateTimeQueryKey(ownerId,params);

  const getCoordinateTime =  useGetCoordinateTimeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>> = ({ signal }) => getCoordinateTime(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoordinateTimeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>>
export type GetCoordinateTimeQueryError = ErrorPayload


export function useGetCoordinateTime<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateTimeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinateTime<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateTimeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCoordinateTime<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateTimeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCoordinateTime<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetCoordinateTimeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinateTimeHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCoordinateTimeQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateCustomerByIdHook = () => {
        const updateCustomerById = useCustomInstance<Customer>();

        return useCallback((
    ownerId: string,
    id: string,
    updateCustomer: UpdateCustomer,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateCustomerById(
          {url: `/api/${ownerId}/customers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomer
    },
          options);
        }, [updateCustomerById])
      }
    


export const useUpdateCustomerByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateCustomerByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateCustomer}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateCustomerByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateCustomer}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateCustomerById =  useUpdateCustomerByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateCustomerByIdHook>>>, {ownerId: string;id: string;data: UpdateCustomer}> = (props) => {
          const {ownerId,id,data} = props ?? {};

          return  updateCustomerById(ownerId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateCustomerByIdHook>>>>
    export type UpdateCustomerByIdMutationBody = UpdateCustomer
    export type UpdateCustomerByIdMutationError = ErrorPayload

    export const useUpdateCustomerById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateCustomerByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateCustomer}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateCustomerByIdHook>>>,
        TError,
        {ownerId: string;id: string;data: UpdateCustomer},
        TContext
      > => {

      const mutationOptions = useUpdateCustomerByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteCustomerByIdHook = () => {
        const deleteCustomerById = useCustomInstance<Customer>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteCustomerById(
          {url: `/api/${ownerId}/customers/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteCustomerById])
      }
    


export const useDeleteCustomerByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteCustomerByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteCustomerByIdHook>>>, TError,{ownerId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteCustomerById =  useDeleteCustomerByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteCustomerByIdHook>>>, {ownerId: string;id: string}> = (props) => {
          const {ownerId,id} = props ?? {};

          return  deleteCustomerById(ownerId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteCustomerByIdHook>>>>
    
    export type DeleteCustomerByIdMutationError = ErrorPayload

    export const useDeleteCustomerById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteCustomerByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteCustomerByIdHook>>>,
        TError,
        {ownerId: string;id: string},
        TContext
      > => {

      const mutationOptions = useDeleteCustomerByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetCustomerByIdHook = () => {
        const getCustomerById = useCustomInstance<Customer>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCustomerById(
          {url: `/api/${ownerId}/customers/${id}`, method: 'GET', signal
    },
          options);
        }, [getCustomerById])
      }
    

export const getGetCustomerByIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/customers/${id}`] as const;
    }

    
export const useGetCustomerByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerByIdQueryKey(ownerId,id);

  const getCustomerById =  useGetCustomerByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>> = ({ signal }) => getCustomerById(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>>
export type GetCustomerByIdQueryError = ErrorPayload


export function useGetCustomerById<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomerById<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomerById<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCustomerById<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCustomerByIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostCustomerHook = () => {
        const postCustomer = useCustomInstance<Customer>();

        return useCallback((
    ownerId: string,
    createCustomer: CreateCustomer,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postCustomer(
          {url: `/api/${ownerId}/customers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomer
    },
          options);
        }, [postCustomer])
      }
    


export const usePostCustomerMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCustomerHook>>>, TError,{ownerId: string;data: CreateCustomer}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCustomerHook>>>, TError,{ownerId: string;data: CreateCustomer}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postCustomer =  usePostCustomerHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostCustomerHook>>>, {ownerId: string;data: CreateCustomer}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postCustomer(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostCustomerHook>>>>
    export type PostCustomerMutationBody = CreateCustomer
    export type PostCustomerMutationError = ErrorPayload

    export const usePostCustomer = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCustomerHook>>>, TError,{ownerId: string;data: CreateCustomer}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostCustomerHook>>>,
        TError,
        {ownerId: string;data: CreateCustomer},
        TContext
      > => {

      const mutationOptions = usePostCustomerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetCustomersHook = () => {
        const getCustomers = useCustomInstance<Customer[]>();

        return useCallback((
    ownerId: string,
    params?: GetCustomersParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCustomers(
          {url: `/api/${ownerId}/customers`, method: 'GET',
        params, signal
    },
          options);
        }, [getCustomers])
      }
    

export const getGetCustomersQueryKey = (ownerId: string,
    params?: GetCustomersParams,) => {
    return [`/api/${ownerId}/customers`, ...(params ? [params]: [])] as const;
    }

    
export const useGetCustomersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersQueryKey(ownerId,params);

  const getCustomers =  useGetCustomersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>> = ({ signal }) => getCustomers(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>>
export type GetCustomersQueryError = ErrorPayload


export function useGetCustomers<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomers<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomers<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCustomers<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCustomersQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetOwnerEmployeesInfoHook = () => {
        const getOwnerEmployeesInfo = useCustomInstance<GetOwnerEmployeesInfo[]>();

        return useCallback((
    ownerId: string,
    params: GetOwnerEmployeesInfoParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getOwnerEmployeesInfo(
          {url: `/api/${ownerId}/employeesInfo`, method: 'GET',
        params, signal
    },
          options);
        }, [getOwnerEmployeesInfo])
      }
    

export const getGetOwnerEmployeesInfoQueryKey = (ownerId: string,
    params: GetOwnerEmployeesInfoParams,) => {
    return [`/api/${ownerId}/employeesInfo`, ...(params ? [params]: [])] as const;
    }

    
export const useGetOwnerEmployeesInfoQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetOwnerEmployeesInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerEmployeesInfoQueryKey(ownerId,params);

  const getOwnerEmployeesInfo =  useGetOwnerEmployeesInfoHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>> = ({ signal }) => getOwnerEmployeesInfo(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerEmployeesInfoQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>>
export type GetOwnerEmployeesInfoQueryError = ErrorPayload


export function useGetOwnerEmployeesInfo<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetOwnerEmployeesInfoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwnerEmployeesInfo<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetOwnerEmployeesInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwnerEmployeesInfo<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetOwnerEmployeesInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetOwnerEmployeesInfo<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetOwnerEmployeesInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerEmployeesInfoHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetOwnerEmployeesInfoQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetAbsenceRequestsByEmployeeIdHook = () => {
        const getAbsenceRequestsByEmployeeId = useCustomInstance<AbsenceRequest[]>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getAbsenceRequestsByEmployeeId(
          {url: `/api/${ownerId}/employees/${id}/absence/requests`, method: 'GET', signal
    },
          options);
        }, [getAbsenceRequestsByEmployeeId])
      }
    

export const getGetAbsenceRequestsByEmployeeIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/employees/${id}/absence/requests`] as const;
    }

    
export const useGetAbsenceRequestsByEmployeeIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAbsenceRequestsByEmployeeIdQueryKey(ownerId,id);

  const getAbsenceRequestsByEmployeeId =  useGetAbsenceRequestsByEmployeeIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>> = ({ signal }) => getAbsenceRequestsByEmployeeId(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAbsenceRequestsByEmployeeIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>>
export type GetAbsenceRequestsByEmployeeIdQueryError = ErrorPayload


export function useGetAbsenceRequestsByEmployeeId<TData = Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAbsenceRequestsByEmployeeId<TData = Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAbsenceRequestsByEmployeeId<TData = Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetAbsenceRequestsByEmployeeId<TData = Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAbsenceRequestsByEmployeeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetAbsenceRequestsByEmployeeIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useCreateAbsenceRequestForEmployeeHook = () => {
        const createAbsenceRequestForEmployee = useCustomInstance<Payload>();

        return useCallback((
    ownerId: string,
    id: string,
    createAbsenceRequest: CreateAbsenceRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return createAbsenceRequestForEmployee(
          {url: `/api/${ownerId}/employees/${id}/absence/requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAbsenceRequest
    },
          options);
        }, [createAbsenceRequestForEmployee])
      }
    


export const useCreateAbsenceRequestForEmployeeMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAbsenceRequestForEmployeeHook>>>, TError,{ownerId: string;id: string;data: CreateAbsenceRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAbsenceRequestForEmployeeHook>>>, TError,{ownerId: string;id: string;data: CreateAbsenceRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const createAbsenceRequestForEmployee =  useCreateAbsenceRequestForEmployeeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateAbsenceRequestForEmployeeHook>>>, {ownerId: string;id: string;data: CreateAbsenceRequest}> = (props) => {
          const {ownerId,id,data} = props ?? {};

          return  createAbsenceRequestForEmployee(ownerId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAbsenceRequestForEmployeeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateAbsenceRequestForEmployeeHook>>>>
    export type CreateAbsenceRequestForEmployeeMutationBody = CreateAbsenceRequest
    export type CreateAbsenceRequestForEmployeeMutationError = ErrorPayload

    export const useCreateAbsenceRequestForEmployee = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAbsenceRequestForEmployeeHook>>>, TError,{ownerId: string;id: string;data: CreateAbsenceRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateAbsenceRequestForEmployeeHook>>>,
        TError,
        {ownerId: string;id: string;data: CreateAbsenceRequest},
        TContext
      > => {

      const mutationOptions = useCreateAbsenceRequestForEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetEmployeeCoordinatesHook = () => {
        const getEmployeeCoordinates = useCustomInstance<EmployeeCoordinates>();

        return useCallback((
    ownerId: string,
    id: string,
    params: GetEmployeeCoordinatesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEmployeeCoordinates(
          {url: `/api/${ownerId}/employees/${id}/coordinates`, method: 'GET',
        params, signal
    },
          options);
        }, [getEmployeeCoordinates])
      }
    

export const getGetEmployeeCoordinatesQueryKey = (ownerId: string,
    id: string,
    params: GetEmployeeCoordinatesParams,) => {
    return [`/api/${ownerId}/employees/${id}/coordinates`, ...(params ? [params]: [])] as const;
    }

    
export const useGetEmployeeCoordinatesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string,
    params: GetEmployeeCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeCoordinatesQueryKey(ownerId,id,params);

  const getEmployeeCoordinates =  useGetEmployeeCoordinatesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>> = ({ signal }) => getEmployeeCoordinates(ownerId,id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeeCoordinatesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>>
export type GetEmployeeCoordinatesQueryError = ErrorPayload


export function useGetEmployeeCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: GetEmployeeCoordinatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeeCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: GetEmployeeCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeeCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: GetEmployeeCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEmployeeCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: GetEmployeeCoordinatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEmployeeCoordinatesQueryOptions(ownerId,id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostGeneratePinForEmployeeHook = () => {
        const postGeneratePinForEmployee = useCustomInstance<Payload>();

        return useCallback((
    ownerId: string,
    id: string,
    generatePinForEmployee: GeneratePinForEmployee,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postGeneratePinForEmployee(
          {url: `/api/${ownerId}/employees/${id}/pin/generatePinForEmployee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generatePinForEmployee
    },
          options);
        }, [postGeneratePinForEmployee])
      }
    


export const usePostGeneratePinForEmployeeMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeeHook>>>, TError,{ownerId: string;id: string;data: GeneratePinForEmployee}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeeHook>>>, TError,{ownerId: string;id: string;data: GeneratePinForEmployee}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postGeneratePinForEmployee =  usePostGeneratePinForEmployeeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeeHook>>>, {ownerId: string;id: string;data: GeneratePinForEmployee}> = (props) => {
          const {ownerId,id,data} = props ?? {};

          return  postGeneratePinForEmployee(ownerId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGeneratePinForEmployeeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeeHook>>>>
    export type PostGeneratePinForEmployeeMutationBody = GeneratePinForEmployee
    export type PostGeneratePinForEmployeeMutationError = ErrorPayload

    export const usePostGeneratePinForEmployee = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeeHook>>>, TError,{ownerId: string;id: string;data: GeneratePinForEmployee}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeeHook>>>,
        TError,
        {ownerId: string;id: string;data: GeneratePinForEmployee},
        TContext
      > => {

      const mutationOptions = usePostGeneratePinForEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateEmployeeByIdHook = () => {
        const updateEmployeeById = useCustomInstance<Employee>();

        return useCallback((
    ownerId: string,
    id: string,
    updateEmployee: UpdateEmployee,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateEmployeeById(
          {url: `/api/${ownerId}/employees/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateEmployee
    },
          options);
        }, [updateEmployeeById])
      }
    


export const useUpdateEmployeeByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateEmployee}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateEmployee}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateEmployeeById =  useUpdateEmployeeByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeByIdHook>>>, {ownerId: string;id: string;data: UpdateEmployee}> = (props) => {
          const {ownerId,id,data} = props ?? {};

          return  updateEmployeeById(ownerId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeByIdHook>>>>
    export type UpdateEmployeeByIdMutationBody = UpdateEmployee
    export type UpdateEmployeeByIdMutationError = ErrorPayload

    export const useUpdateEmployeeById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateEmployee}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeByIdHook>>>,
        TError,
        {ownerId: string;id: string;data: UpdateEmployee},
        TContext
      > => {

      const mutationOptions = useUpdateEmployeeByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteEmployeeByIdHook = () => {
        const deleteEmployeeById = useCustomInstance<Employee>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteEmployeeById(
          {url: `/api/${ownerId}/employees/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteEmployeeById])
      }
    


export const useDeleteEmployeeByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeByIdHook>>>, TError,{ownerId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteEmployeeById =  useDeleteEmployeeByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeByIdHook>>>, {ownerId: string;id: string}> = (props) => {
          const {ownerId,id} = props ?? {};

          return  deleteEmployeeById(ownerId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeByIdHook>>>>
    
    export type DeleteEmployeeByIdMutationError = ErrorPayload

    export const useDeleteEmployeeById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeByIdHook>>>,
        TError,
        {ownerId: string;id: string},
        TContext
      > => {

      const mutationOptions = useDeleteEmployeeByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetEmployeeByIdHook = () => {
        const getEmployeeById = useCustomInstance<Employee>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEmployeeById(
          {url: `/api/${ownerId}/employees/${id}`, method: 'GET', signal
    },
          options);
        }, [getEmployeeById])
      }
    

export const getGetEmployeeByIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/employees/${id}`] as const;
    }

    
export const useGetEmployeeByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeByIdQueryKey(ownerId,id);

  const getEmployeeById =  useGetEmployeeByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>> = ({ signal }) => getEmployeeById(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeeByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>>
export type GetEmployeeByIdQueryError = ErrorPayload


export function useGetEmployeeById<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeeById<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeeById<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEmployeeById<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEmployeeByIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetEmployeeTimeSheetHook = () => {
        const getEmployeeTimeSheet = useCustomInstance<EmployeesTimeSheetsResponse>();

        return useCallback((
    ownerId: string,
    id: string,
    params: GetEmployeeTimeSheetParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEmployeeTimeSheet(
          {url: `/api/${ownerId}/employees/${id}/timeSheet`, method: 'GET',
        params, signal
    },
          options);
        }, [getEmployeeTimeSheet])
      }
    

export const getGetEmployeeTimeSheetQueryKey = (ownerId: string,
    id: string,
    params: GetEmployeeTimeSheetParams,) => {
    return [`/api/${ownerId}/employees/${id}/timeSheet`, ...(params ? [params]: [])] as const;
    }

    
export const useGetEmployeeTimeSheetQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string,
    params: GetEmployeeTimeSheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeTimeSheetQueryKey(ownerId,id,params);

  const getEmployeeTimeSheet =  useGetEmployeeTimeSheetHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>> = ({ signal }) => getEmployeeTimeSheet(ownerId,id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeeTimeSheetQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>>
export type GetEmployeeTimeSheetQueryError = ErrorPayload


export function useGetEmployeeTimeSheet<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: GetEmployeeTimeSheetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeeTimeSheet<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: GetEmployeeTimeSheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeeTimeSheet<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: GetEmployeeTimeSheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEmployeeTimeSheet<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: GetEmployeeTimeSheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeeTimeSheetHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEmployeeTimeSheetQueryOptions(ownerId,id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetActiveEmployeesHook = () => {
        const getActiveEmployees = useCustomInstance<ActiveEmployees>();

        return useCallback((
    ownerId: string,
    params: GetActiveEmployeesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getActiveEmployees(
          {url: `/api/${ownerId}/employees/activeEmployees`, method: 'GET',
        params, signal
    },
          options);
        }, [getActiveEmployees])
      }
    

export const getGetActiveEmployeesQueryKey = (ownerId: string,
    params: GetActiveEmployeesParams,) => {
    return [`/api/${ownerId}/employees/activeEmployees`, ...(params ? [params]: [])] as const;
    }

    
export const useGetActiveEmployeesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetActiveEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveEmployeesQueryKey(ownerId,params);

  const getActiveEmployees =  useGetActiveEmployeesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>> = ({ signal }) => getActiveEmployees(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetActiveEmployeesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>>
export type GetActiveEmployeesQueryError = ErrorPayload


export function useGetActiveEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetActiveEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetActiveEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetActiveEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetActiveEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetActiveEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetActiveEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetActiveEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetActiveEmployeesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostWorkScheduleBatchHook = () => {
        const postWorkScheduleBatch = useCustomInstance<Payload>();

        return useCallback((
    ownerId: string,
    updateWorkSchedulesBatch: UpdateWorkSchedulesBatch,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postWorkScheduleBatch(
          {url: `/api/${ownerId}/employees/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkSchedulesBatch
    },
          options);
        }, [postWorkScheduleBatch])
      }
    


export const usePostWorkScheduleBatchMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleBatchHook>>>, TError,{ownerId: string;data: UpdateWorkSchedulesBatch}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleBatchHook>>>, TError,{ownerId: string;data: UpdateWorkSchedulesBatch}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postWorkScheduleBatch =  usePostWorkScheduleBatchHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleBatchHook>>>, {ownerId: string;data: UpdateWorkSchedulesBatch}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postWorkScheduleBatch(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWorkScheduleBatchMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleBatchHook>>>>
    export type PostWorkScheduleBatchMutationBody = UpdateWorkSchedulesBatch
    export type PostWorkScheduleBatchMutationError = ErrorPayload

    export const usePostWorkScheduleBatch = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleBatchHook>>>, TError,{ownerId: string;data: UpdateWorkSchedulesBatch}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleBatchHook>>>,
        TError,
        {ownerId: string;data: UpdateWorkSchedulesBatch},
        TContext
      > => {

      const mutationOptions = usePostWorkScheduleBatchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetEmployeesCountHook = () => {
        const getEmployeesCount = useCustomInstance<EmployeesCount>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEmployeesCount(
          {url: `/api/${ownerId}/employees/employeeCount`, method: 'GET', signal
    },
          options);
        }, [getEmployeesCount])
      }
    

export const getGetEmployeesCountQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/employees/employeeCount`] as const;
    }

    
export const useGetEmployeesCountQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeesCountQueryKey(ownerId);

  const getEmployeesCount =  useGetEmployeesCountHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>> = ({ signal }) => getEmployeesCount(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeesCountQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>>
export type GetEmployeesCountQueryError = ErrorPayload


export function useGetEmployeesCount<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeesCount<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeesCount<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEmployeesCount<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesCountHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEmployeesCountQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostEmployeeImportHook = () => {
        const postEmployeeImport = useCustomInstance<EmployeeImportResponse[]>();

        return useCallback((
    ownerId: string,
    employeeImportRequest: EmployeeImportRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postEmployeeImport(
          {url: `/api/${ownerId}/employees/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employeeImportRequest
    },
          options);
        }, [postEmployeeImport])
      }
    


export const usePostEmployeeImportMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostEmployeeImportHook>>>, TError,{ownerId: string;data: EmployeeImportRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostEmployeeImportHook>>>, TError,{ownerId: string;data: EmployeeImportRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postEmployeeImport =  usePostEmployeeImportHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostEmployeeImportHook>>>, {ownerId: string;data: EmployeeImportRequest}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postEmployeeImport(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployeeImportMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostEmployeeImportHook>>>>
    export type PostEmployeeImportMutationBody = EmployeeImportRequest
    export type PostEmployeeImportMutationError = ErrorPayload

    export const usePostEmployeeImport = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostEmployeeImportHook>>>, TError,{ownerId: string;data: EmployeeImportRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostEmployeeImportHook>>>,
        TError,
        {ownerId: string;data: EmployeeImportRequest},
        TContext
      > => {

      const mutationOptions = usePostEmployeeImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostInviteEmployeeHook = () => {
        const postInviteEmployee = useCustomInstance<Payload>();

        return useCallback((
    ownerId: string,
    inviteEmployee: InviteEmployee,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postInviteEmployee(
          {url: `/api/${ownerId}/employees/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteEmployee
    },
          options);
        }, [postInviteEmployee])
      }
    


export const usePostInviteEmployeeMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostInviteEmployeeHook>>>, TError,{ownerId: string;data: InviteEmployee}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostInviteEmployeeHook>>>, TError,{ownerId: string;data: InviteEmployee}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postInviteEmployee =  usePostInviteEmployeeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostInviteEmployeeHook>>>, {ownerId: string;data: InviteEmployee}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postInviteEmployee(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInviteEmployeeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostInviteEmployeeHook>>>>
    export type PostInviteEmployeeMutationBody = InviteEmployee
    export type PostInviteEmployeeMutationError = ErrorPayload

    export const usePostInviteEmployee = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostInviteEmployeeHook>>>, TError,{ownerId: string;data: InviteEmployee}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostInviteEmployeeHook>>>,
        TError,
        {ownerId: string;data: InviteEmployee},
        TContext
      > => {

      const mutationOptions = usePostInviteEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetMonthlyHoursOfAllEmployeesHook = () => {
        const getMonthlyHoursOfAllEmployees = useCustomInstance<DailyHoursWithTotalHours>();

        return useCallback((
    ownerId: string,
    params?: GetMonthlyHoursOfAllEmployeesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getMonthlyHoursOfAllEmployees(
          {url: `/api/${ownerId}/employees/monthlyHours`, method: 'GET',
        params, signal
    },
          options);
        }, [getMonthlyHoursOfAllEmployees])
      }
    

export const getGetMonthlyHoursOfAllEmployeesQueryKey = (ownerId: string,
    params?: GetMonthlyHoursOfAllEmployeesParams,) => {
    return [`/api/${ownerId}/employees/monthlyHours`, ...(params ? [params]: [])] as const;
    }

    
export const useGetMonthlyHoursOfAllEmployeesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetMonthlyHoursOfAllEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMonthlyHoursOfAllEmployeesQueryKey(ownerId,params);

  const getMonthlyHoursOfAllEmployees =  useGetMonthlyHoursOfAllEmployeesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>> = ({ signal }) => getMonthlyHoursOfAllEmployees(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMonthlyHoursOfAllEmployeesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>>
export type GetMonthlyHoursOfAllEmployeesQueryError = ErrorPayload


export function useGetMonthlyHoursOfAllEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetMonthlyHoursOfAllEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetMonthlyHoursOfAllEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetMonthlyHoursOfAllEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetMonthlyHoursOfAllEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetMonthlyHoursOfAllEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetMonthlyHoursOfAllEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetMonthlyHoursOfAllEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlyHoursOfAllEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetMonthlyHoursOfAllEmployeesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetMonthlySpendsHook = () => {
        const getMonthlySpends = useCustomInstance<DailyEarningsWithTotalEarnings>();

        return useCallback((
    ownerId: string,
    params?: GetMonthlySpendsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getMonthlySpends(
          {url: `/api/${ownerId}/employees/monthlySpends`, method: 'GET',
        params, signal
    },
          options);
        }, [getMonthlySpends])
      }
    

export const getGetMonthlySpendsQueryKey = (ownerId: string,
    params?: GetMonthlySpendsParams,) => {
    return [`/api/${ownerId}/employees/monthlySpends`, ...(params ? [params]: [])] as const;
    }

    
export const useGetMonthlySpendsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetMonthlySpendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMonthlySpendsQueryKey(ownerId,params);

  const getMonthlySpends =  useGetMonthlySpendsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>> = ({ signal }) => getMonthlySpends(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMonthlySpendsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>>
export type GetMonthlySpendsQueryError = ErrorPayload


export function useGetMonthlySpends<TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetMonthlySpendsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetMonthlySpends<TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetMonthlySpendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetMonthlySpends<TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetMonthlySpendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetMonthlySpends<TData = Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetMonthlySpendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMonthlySpendsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetMonthlySpendsQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetEmployeesWithPinAttendanceHook = () => {
        const getEmployeesWithPinAttendance = useCustomInstance<GetEmployeesWithPinAttendanceResponse>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEmployeesWithPinAttendance(
          {url: `/api/${ownerId}/employees/pinAttendance`, method: 'GET', signal
    },
          options);
        }, [getEmployeesWithPinAttendance])
      }
    

export const getGetEmployeesWithPinAttendanceQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/employees/pinAttendance`] as const;
    }

    
export const useGetEmployeesWithPinAttendanceQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeesWithPinAttendanceQueryKey(ownerId);

  const getEmployeesWithPinAttendance =  useGetEmployeesWithPinAttendanceHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>> = ({ signal }) => getEmployeesWithPinAttendance(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeesWithPinAttendanceQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>>
export type GetEmployeesWithPinAttendanceQueryError = ErrorPayload


export function useGetEmployeesWithPinAttendance<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeesWithPinAttendance<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeesWithPinAttendance<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEmployeesWithPinAttendance<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithPinAttendanceHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEmployeesWithPinAttendanceQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetDataForReviewTableHook = () => {
        const getDataForReviewTable = useCustomInstance<ReviewTableResponse>();

        return useCallback((
    ownerId: string,
    params: GetDataForReviewTableParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getDataForReviewTable(
          {url: `/api/${ownerId}/employees/reviewTable`, method: 'GET',
        params, signal
    },
          options);
        }, [getDataForReviewTable])
      }
    

export const getGetDataForReviewTableQueryKey = (ownerId: string,
    params: GetDataForReviewTableParams,) => {
    return [`/api/${ownerId}/employees/reviewTable`, ...(params ? [params]: [])] as const;
    }

    
export const useGetDataForReviewTableQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetDataForReviewTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataForReviewTableQueryKey(ownerId,params);

  const getDataForReviewTable =  useGetDataForReviewTableHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>> = ({ signal }) => getDataForReviewTable(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDataForReviewTableQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>>
export type GetDataForReviewTableQueryError = ErrorPayload


export function useGetDataForReviewTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetDataForReviewTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDataForReviewTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetDataForReviewTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDataForReviewTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetDataForReviewTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetDataForReviewTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetDataForReviewTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForReviewTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetDataForReviewTableQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostEmployeeHook = () => {
        const postEmployee = useCustomInstance<Employee>();

        return useCallback((
    ownerId: string,
    createEmployee: CreateEmployee,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postEmployee(
          {url: `/api/${ownerId}/employees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEmployee
    },
          options);
        }, [postEmployee])
      }
    


export const usePostEmployeeMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostEmployeeHook>>>, TError,{ownerId: string;data: CreateEmployee}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostEmployeeHook>>>, TError,{ownerId: string;data: CreateEmployee}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postEmployee =  usePostEmployeeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostEmployeeHook>>>, {ownerId: string;data: CreateEmployee}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postEmployee(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployeeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostEmployeeHook>>>>
    export type PostEmployeeMutationBody = CreateEmployee
    export type PostEmployeeMutationError = ErrorPayload

    export const usePostEmployee = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostEmployeeHook>>>, TError,{ownerId: string;data: CreateEmployee}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostEmployeeHook>>>,
        TError,
        {ownerId: string;data: CreateEmployee},
        TContext
      > => {

      const mutationOptions = usePostEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetEmployeesHook = () => {
        const getEmployees = useCustomInstance<EmployeeWithWorkSchedule[]>();

        return useCallback((
    ownerId: string,
    params?: GetEmployeesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEmployees(
          {url: `/api/${ownerId}/employees`, method: 'GET',
        params, signal
    },
          options);
        }, [getEmployees])
      }
    

export const getGetEmployeesQueryKey = (ownerId: string,
    params?: GetEmployeesParams,) => {
    return [`/api/${ownerId}/employees`, ...(params ? [params]: [])] as const;
    }

    
export const useGetEmployeesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeesQueryKey(ownerId,params);

  const getEmployees =  useGetEmployeesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>> = ({ signal }) => getEmployees(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>>
export type GetEmployeesQueryError = ErrorPayload


export function useGetEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEmployeesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetEmployeesWithScheduleHook = () => {
        const getEmployeesWithSchedule = useCustomInstance<GetEmployeeWithRelationsPaginatedResponse>();

        return useCallback((
    ownerId: string,
    params?: GetEmployeesWithScheduleParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEmployeesWithSchedule(
          {url: `/api/${ownerId}/employees/withSchedule`, method: 'GET',
        params, signal
    },
          options);
        }, [getEmployeesWithSchedule])
      }
    

export const getGetEmployeesWithScheduleQueryKey = (ownerId: string,
    params?: GetEmployeesWithScheduleParams,) => {
    return [`/api/${ownerId}/employees/withSchedule`, ...(params ? [params]: [])] as const;
    }

    
export const useGetEmployeesWithScheduleQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetEmployeesWithScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeesWithScheduleQueryKey(ownerId,params);

  const getEmployeesWithSchedule =  useGetEmployeesWithScheduleHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>> = ({ signal }) => getEmployeesWithSchedule(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeesWithScheduleQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>>
export type GetEmployeesWithScheduleQueryError = ErrorPayload


export function useGetEmployeesWithSchedule<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetEmployeesWithScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeesWithSchedule<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetEmployeesWithScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeesWithSchedule<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetEmployeesWithScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEmployeesWithSchedule<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetEmployeesWithScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesWithScheduleHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEmployeesWithScheduleQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetUserRolesInvitationsHook = () => {
        const getUserRolesInvitations = useCustomInstance<Invitation[]>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUserRolesInvitations(
          {url: `/api/${ownerId}/invitations/userRoles`, method: 'GET', signal
    },
          options);
        }, [getUserRolesInvitations])
      }
    

export const getGetUserRolesInvitationsQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/invitations/userRoles`] as const;
    }

    
export const useGetUserRolesInvitationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRolesInvitationsQueryKey(ownerId);

  const getUserRolesInvitations =  useGetUserRolesInvitationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>> = ({ signal }) => getUserRolesInvitations(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRolesInvitationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>>
export type GetUserRolesInvitationsQueryError = ErrorPayload


export function useGetUserRolesInvitations<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRolesInvitations<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRolesInvitations<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUserRolesInvitations<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesInvitationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUserRolesInvitationsQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetJobAttachmentsHook = () => {
        const getJobAttachments = useCustomInstance<AttachmentList>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobAttachments(
          {url: `/api/${ownerId}/jobs/${id}/attachments`, method: 'GET', signal
    },
          options);
        }, [getJobAttachments])
      }
    

export const getGetJobAttachmentsQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/jobs/${id}/attachments`] as const;
    }

    
export const useGetJobAttachmentsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobAttachmentsQueryKey(ownerId,id);

  const getJobAttachments =  useGetJobAttachmentsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>> = ({ signal }) => getJobAttachments(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobAttachmentsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>>
export type GetJobAttachmentsQueryError = ErrorPayload


export function useGetJobAttachments<TData = Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobAttachments<TData = Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobAttachments<TData = Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobAttachments<TData = Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobAttachmentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobAttachmentsQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateJobByIdHook = () => {
        const updateJobById = useCustomInstance<Job>();

        return useCallback((
    ownerId: string,
    id: string,
    updateJob: UpdateJob,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateJobById(
          {url: `/api/${ownerId}/jobs/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateJob
    },
          options);
        }, [updateJobById])
      }
    


export const useUpdateJobByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateJobByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateJob}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateJobByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateJob}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateJobById =  useUpdateJobByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateJobByIdHook>>>, {ownerId: string;id: string;data: UpdateJob}> = (props) => {
          const {ownerId,id,data} = props ?? {};

          return  updateJobById(ownerId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateJobByIdHook>>>>
    export type UpdateJobByIdMutationBody = UpdateJob
    export type UpdateJobByIdMutationError = ErrorPayload

    export const useUpdateJobById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateJobByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateJob}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateJobByIdHook>>>,
        TError,
        {ownerId: string;id: string;data: UpdateJob},
        TContext
      > => {

      const mutationOptions = useUpdateJobByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteJobByIdHook = () => {
        const deleteJobById = useCustomInstance<Job>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteJobById(
          {url: `/api/${ownerId}/jobs/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteJobById])
      }
    


export const useDeleteJobByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteJobByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteJobByIdHook>>>, TError,{ownerId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteJobById =  useDeleteJobByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteJobByIdHook>>>, {ownerId: string;id: string}> = (props) => {
          const {ownerId,id} = props ?? {};

          return  deleteJobById(ownerId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteJobByIdHook>>>>
    
    export type DeleteJobByIdMutationError = ErrorPayload

    export const useDeleteJobById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteJobByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteJobByIdHook>>>,
        TError,
        {ownerId: string;id: string},
        TContext
      > => {

      const mutationOptions = useDeleteJobByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetJobByIdHook = () => {
        const getJobById = useCustomInstance<Job>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobById(
          {url: `/api/${ownerId}/jobs/${id}`, method: 'GET', signal
    },
          options);
        }, [getJobById])
      }
    

export const getGetJobByIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/jobs/${id}`] as const;
    }

    
export const useGetJobByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobByIdQueryKey(ownerId,id);

  const getJobById =  useGetJobByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>> = ({ signal }) => getJobById(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>>
export type GetJobByIdQueryError = ErrorPayload


export function useGetJobById<TData = Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobById<TData = Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobById<TData = Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobById<TData = Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobByIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetActiveJobsHook = () => {
        const getActiveJobs = useCustomInstance<ActiveJobs>();

        return useCallback((
    ownerId: string,
    limit: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getActiveJobs(
          {url: `/api/${ownerId}/jobs/active/${limit}`, method: 'GET', signal
    },
          options);
        }, [getActiveJobs])
      }
    

export const getGetActiveJobsQueryKey = (ownerId: string,
    limit: string,) => {
    return [`/api/${ownerId}/jobs/active/${limit}`] as const;
    }

    
export const useGetActiveJobsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError = ErrorPayload>(ownerId: string,
    limit: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveJobsQueryKey(ownerId,limit);

  const getActiveJobs =  useGetActiveJobsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>> = ({ signal }) => getActiveJobs(ownerId,limit, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && limit), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetActiveJobsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>>
export type GetActiveJobsQueryError = ErrorPayload


export function useGetActiveJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    limit: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetActiveJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    limit: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetActiveJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    limit: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetActiveJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    limit: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetActiveJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetActiveJobsQueryOptions(ownerId,limit,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostJobsBatchHook = () => {
        const postJobsBatch = useCustomInstance<Job[]>();

        return useCallback((
    ownerId: string,
    updateJobsBatch: UpdateJobsBatch,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postJobsBatch(
          {url: `/api/${ownerId}/jobs/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateJobsBatch
    },
          options);
        }, [postJobsBatch])
      }
    


export const usePostJobsBatchMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobsBatchHook>>>, TError,{ownerId: string;data: UpdateJobsBatch}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobsBatchHook>>>, TError,{ownerId: string;data: UpdateJobsBatch}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postJobsBatch =  usePostJobsBatchHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostJobsBatchHook>>>, {ownerId: string;data: UpdateJobsBatch}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postJobsBatch(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobsBatchMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostJobsBatchHook>>>>
    export type PostJobsBatchMutationBody = UpdateJobsBatch
    export type PostJobsBatchMutationError = ErrorPayload

    export const usePostJobsBatch = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobsBatchHook>>>, TError,{ownerId: string;data: UpdateJobsBatch}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostJobsBatchHook>>>,
        TError,
        {ownerId: string;data: UpdateJobsBatch},
        TContext
      > => {

      const mutationOptions = usePostJobsBatchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteJobsBatchHook = () => {
        const deleteJobsBatch = useCustomInstance<Job[]>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteJobsBatch(
          {url: `/api/${ownerId}/jobs/batch`, method: 'DELETE'
    },
          options);
        }, [deleteJobsBatch])
      }
    


export const useDeleteJobsBatchMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteJobsBatchHook>>>, TError,{ownerId: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteJobsBatchHook>>>, TError,{ownerId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteJobsBatch =  useDeleteJobsBatchHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteJobsBatchHook>>>, {ownerId: string}> = (props) => {
          const {ownerId} = props ?? {};

          return  deleteJobsBatch(ownerId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobsBatchMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteJobsBatchHook>>>>
    
    export type DeleteJobsBatchMutationError = ErrorPayload

    export const useDeleteJobsBatch = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteJobsBatchHook>>>, TError,{ownerId: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteJobsBatchHook>>>,
        TError,
        {ownerId: string},
        TContext
      > => {

      const mutationOptions = useDeleteJobsBatchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetJobByCoordinateIdHook = () => {
        const getJobByCoordinateId = useCustomInstance<Job>();

        return useCallback((
    ownerId: string,
    params: GetJobByCoordinateIdParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobByCoordinateId(
          {url: `/api/${ownerId}/jobs/byCoordinate`, method: 'GET',
        params, signal
    },
          options);
        }, [getJobByCoordinateId])
      }
    

export const getGetJobByCoordinateIdQueryKey = (ownerId: string,
    params: GetJobByCoordinateIdParams,) => {
    return [`/api/${ownerId}/jobs/byCoordinate`, ...(params ? [params]: [])] as const;
    }

    
export const useGetJobByCoordinateIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetJobByCoordinateIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobByCoordinateIdQueryKey(ownerId,params);

  const getJobByCoordinateId =  useGetJobByCoordinateIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>> = ({ signal }) => getJobByCoordinateId(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobByCoordinateIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>>
export type GetJobByCoordinateIdQueryError = ErrorPayload


export function useGetJobByCoordinateId<TData = Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobByCoordinateIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobByCoordinateId<TData = Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobByCoordinateIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobByCoordinateId<TData = Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobByCoordinateIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobByCoordinateId<TData = Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobByCoordinateIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobByCoordinateIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobByCoordinateIdQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostJobCopyByIdHook = () => {
        const postJobCopyById = useCustomInstance<JobId>();

        return useCallback((
    ownerId: string,
    copyJob: CopyJob,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postJobCopyById(
          {url: `/api/${ownerId}/jobs/copy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: copyJob
    },
          options);
        }, [postJobCopyById])
      }
    


export const usePostJobCopyByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobCopyByIdHook>>>, TError,{ownerId: string;data: CopyJob}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobCopyByIdHook>>>, TError,{ownerId: string;data: CopyJob}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postJobCopyById =  usePostJobCopyByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostJobCopyByIdHook>>>, {ownerId: string;data: CopyJob}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postJobCopyById(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobCopyByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostJobCopyByIdHook>>>>
    export type PostJobCopyByIdMutationBody = CopyJob
    export type PostJobCopyByIdMutationError = ErrorPayload

    export const usePostJobCopyById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobCopyByIdHook>>>, TError,{ownerId: string;data: CopyJob}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostJobCopyByIdHook>>>,
        TError,
        {ownerId: string;data: CopyJob},
        TContext
      > => {

      const mutationOptions = usePostJobCopyByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetJobsCostsHook = () => {
        const getJobsCosts = useCustomInstance<JobsWithCosts>();

        return useCallback((
    ownerId: string,
    params: GetJobsCostsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobsCosts(
          {url: `/api/${ownerId}/jobs/costs`, method: 'GET',
        params, signal
    },
          options);
        }, [getJobsCosts])
      }
    

export const getGetJobsCostsQueryKey = (ownerId: string,
    params: GetJobsCostsParams,) => {
    return [`/api/${ownerId}/jobs/costs`, ...(params ? [params]: [])] as const;
    }

    
export const useGetJobsCostsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetJobsCostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsCostsQueryKey(ownerId,params);

  const getJobsCosts =  useGetJobsCostsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>> = ({ signal }) => getJobsCosts(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobsCostsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>>
export type GetJobsCostsQueryError = ErrorPayload


export function useGetJobsCosts<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobsCostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsCosts<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobsCostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsCosts<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobsCostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobsCosts<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobsCostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsCostsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobsCostsQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostJobImportHook = () => {
        const postJobImport = useCustomInstance<JobImportResponse[]>();

        return useCallback((
    ownerId: string,
    jobImportRequest: JobImportRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postJobImport(
          {url: `/api/${ownerId}/jobs/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobImportRequest
    },
          options);
        }, [postJobImport])
      }
    


export const usePostJobImportMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobImportHook>>>, TError,{ownerId: string;data: JobImportRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobImportHook>>>, TError,{ownerId: string;data: JobImportRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postJobImport =  usePostJobImportHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostJobImportHook>>>, {ownerId: string;data: JobImportRequest}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postJobImport(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobImportMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostJobImportHook>>>>
    export type PostJobImportMutationBody = JobImportRequest
    export type PostJobImportMutationError = ErrorPayload

    export const usePostJobImport = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobImportHook>>>, TError,{ownerId: string;data: JobImportRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostJobImportHook>>>,
        TError,
        {ownerId: string;data: JobImportRequest},
        TContext
      > => {

      const mutationOptions = usePostJobImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetJobsProfitabilityPercentageHook = () => {
        const getJobsProfitabilityPercentage = useCustomInstance<JobsProfitabilityPercentage>();

        return useCallback((
    ownerId: string,
    params: GetJobsProfitabilityPercentageParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobsProfitabilityPercentage(
          {url: `/api/${ownerId}/jobs/profitability`, method: 'GET',
        params, signal
    },
          options);
        }, [getJobsProfitabilityPercentage])
      }
    

export const getGetJobsProfitabilityPercentageQueryKey = (ownerId: string,
    params: GetJobsProfitabilityPercentageParams,) => {
    return [`/api/${ownerId}/jobs/profitability`, ...(params ? [params]: [])] as const;
    }

    
export const useGetJobsProfitabilityPercentageQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetJobsProfitabilityPercentageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsProfitabilityPercentageQueryKey(ownerId,params);

  const getJobsProfitabilityPercentage =  useGetJobsProfitabilityPercentageHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>> = ({ signal }) => getJobsProfitabilityPercentage(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobsProfitabilityPercentageQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>>
export type GetJobsProfitabilityPercentageQueryError = ErrorPayload


export function useGetJobsProfitabilityPercentage<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobsProfitabilityPercentageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsProfitabilityPercentage<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobsProfitabilityPercentageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsProfitabilityPercentage<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobsProfitabilityPercentageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobsProfitabilityPercentage<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetJobsProfitabilityPercentageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsProfitabilityPercentageHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobsProfitabilityPercentageQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetJobRankingHook = () => {
        const getJobRanking = useCustomInstance<GetJobRankingResponse>();

        return useCallback((
    ownerId: string,
    params?: GetJobRankingParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobRanking(
          {url: `/api/${ownerId}/jobs/ranking`, method: 'GET',
        params, signal
    },
          options);
        }, [getJobRanking])
      }
    

export const getGetJobRankingQueryKey = (ownerId: string,
    params?: GetJobRankingParams,) => {
    return [`/api/${ownerId}/jobs/ranking`, ...(params ? [params]: [])] as const;
    }

    
export const useGetJobRankingQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetJobRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobRankingQueryKey(ownerId,params);

  const getJobRanking =  useGetJobRankingHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>> = ({ signal }) => getJobRanking(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobRankingQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>>
export type GetJobRankingQueryError = ErrorPayload


export function useGetJobRanking<TData = Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetJobRankingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobRanking<TData = Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobRanking<TData = Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobRanking<TData = Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobRankingHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobRankingQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostJobHook = () => {
        const postJob = useCustomInstance<Job>();

        return useCallback((
    ownerId: string,
    createJob: CreateJob,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postJob(
          {url: `/api/${ownerId}/jobs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createJob
    },
          options);
        }, [postJob])
      }
    


export const usePostJobMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobHook>>>, TError,{ownerId: string;data: CreateJob}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobHook>>>, TError,{ownerId: string;data: CreateJob}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postJob =  usePostJobHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostJobHook>>>, {ownerId: string;data: CreateJob}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postJob(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostJobHook>>>>
    export type PostJobMutationBody = CreateJob
    export type PostJobMutationError = ErrorPayload

    export const usePostJob = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostJobHook>>>, TError,{ownerId: string;data: CreateJob}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostJobHook>>>,
        TError,
        {ownerId: string;data: CreateJob},
        TContext
      > => {

      const mutationOptions = usePostJobMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetJobsHook = () => {
        const getJobs = useCustomInstance<JobWithRelations[]>();

        return useCallback((
    ownerId: string,
    params?: GetJobsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobs(
          {url: `/api/${ownerId}/jobs`, method: 'GET',
        params, signal
    },
          options);
        }, [getJobs])
      }
    

export const getGetJobsQueryKey = (ownerId: string,
    params?: GetJobsParams,) => {
    return [`/api/${ownerId}/jobs`, ...(params ? [params]: [])] as const;
    }

    
export const useGetJobsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsQueryKey(ownerId,params);

  const getJobs =  useGetJobsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>> = ({ signal }) => getJobs(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>>
export type GetJobsQueryError = ErrorPayload


export function useGetJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobs<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobsQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetJobsWithTimesHook = () => {
        const getJobsWithTimes = useCustomInstance<GetJobWithRelationsPaginatedResponse>();

        return useCallback((
    ownerId: string,
    params?: GetJobsWithTimesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobsWithTimes(
          {url: `/api/${ownerId}/jobs/table`, method: 'GET',
        params, signal
    },
          options);
        }, [getJobsWithTimes])
      }
    

export const getGetJobsWithTimesQueryKey = (ownerId: string,
    params?: GetJobsWithTimesParams,) => {
    return [`/api/${ownerId}/jobs/table`, ...(params ? [params]: [])] as const;
    }

    
export const useGetJobsWithTimesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, GetJobsWithTimesParams['cursor']>, TError = ErrorPayload>(ownerId: string,
    params?: GetJobsWithTimesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, QueryKey, GetJobsWithTimesParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsWithTimesQueryKey(ownerId,params);

  const getJobsWithTimes =  useGetJobsWithTimesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, QueryKey, GetJobsWithTimesParams['cursor']> = ({ signal, pageParam }) => getJobsWithTimes(ownerId,{...params, cursor: pageParam || params?.['cursor']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId),  keepPreviousData: true,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, QueryKey, GetJobsWithTimesParams['cursor']> & { queryKey: QueryKey }
}

export type GetJobsWithTimesInfiniteQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>>
export type GetJobsWithTimesInfiniteQueryError = ErrorPayload


export function useGetJobsWithTimesInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, GetJobsWithTimesParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetJobsWithTimesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, QueryKey, GetJobsWithTimesParams['cursor']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>,
          TError,
          TData, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsWithTimesInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, GetJobsWithTimesParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithTimesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, QueryKey, GetJobsWithTimesParams['cursor']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>,
          TError,
          TData, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsWithTimesInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, GetJobsWithTimesParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithTimesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, QueryKey, GetJobsWithTimesParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobsWithTimesInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, GetJobsWithTimesParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithTimesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, QueryKey, GetJobsWithTimesParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobsWithTimesInfiniteQueryOptions(ownerId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useGetJobsWithTimesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetJobsWithTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsWithTimesQueryKey(ownerId,params);

  const getJobsWithTimes =  useGetJobsWithTimesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>> = ({ signal }) => getJobsWithTimes(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId),  keepPreviousData: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobsWithTimesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>>
export type GetJobsWithTimesQueryError = ErrorPayload


export function useGetJobsWithTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetJobsWithTimesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsWithTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsWithTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobsWithTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobsWithTimesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetJobEmployeesHook = () => {
        const getJobEmployees = useCustomInstance<GetJobEmployeesResponse>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobEmployees(
          {url: `/api/${ownerId}/jobs/uniqueEmployees`, method: 'GET', signal
    },
          options);
        }, [getJobEmployees])
      }
    

export const getGetJobEmployeesQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/jobs/uniqueEmployees`] as const;
    }

    
export const useGetJobEmployeesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobEmployeesQueryKey(ownerId);

  const getJobEmployees =  useGetJobEmployeesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>> = ({ signal }) => getJobEmployees(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobEmployeesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>>
export type GetJobEmployeesQueryError = ErrorPayload


export function useGetJobEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobEmployeesQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetJobsWithEmployeesHook = () => {
        const getJobsWithEmployees = useCustomInstance<GetJobsWithEmployeesResponse>();

        return useCallback((
    ownerId: string,
    params?: GetJobsWithEmployeesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobsWithEmployees(
          {url: `/api/${ownerId}/jobs/with-employees`, method: 'GET',
        params, signal
    },
          options);
        }, [getJobsWithEmployees])
      }
    

export const getGetJobsWithEmployeesQueryKey = (ownerId: string,
    params?: GetJobsWithEmployeesParams,) => {
    return [`/api/${ownerId}/jobs/with-employees`, ...(params ? [params]: [])] as const;
    }

    
export const useGetJobsWithEmployeesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetJobsWithEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsWithEmployeesQueryKey(ownerId,params);

  const getJobsWithEmployees =  useGetJobsWithEmployeesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>> = ({ signal }) => getJobsWithEmployees(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobsWithEmployeesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>>
export type GetJobsWithEmployeesQueryError = ErrorPayload


export function useGetJobsWithEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetJobsWithEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsWithEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobsWithEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobsWithEmployees<TData = Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetJobsWithEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobsWithEmployeesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobsWithEmployeesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useDeleteReactionByIdHook = () => {
        const deleteReactionById = useCustomInstance<Reaction>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteReactionById(
          {url: `/api/${ownerId}/reactions/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteReactionById])
      }
    


export const useDeleteReactionByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReactionByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReactionByIdHook>>>, TError,{ownerId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteReactionById =  useDeleteReactionByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteReactionByIdHook>>>, {ownerId: string;id: string}> = (props) => {
          const {ownerId,id} = props ?? {};

          return  deleteReactionById(ownerId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteReactionByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteReactionByIdHook>>>>
    
    export type DeleteReactionByIdMutationError = ErrorPayload

    export const useDeleteReactionById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReactionByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteReactionByIdHook>>>,
        TError,
        {ownerId: string;id: string},
        TContext
      > => {

      const mutationOptions = useDeleteReactionByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostReactionHook = () => {
        const postReaction = useCustomInstance<Reaction>();

        return useCallback((
    ownerId: string,
    createReaction: CreateReaction,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postReaction(
          {url: `/api/${ownerId}/reactions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createReaction
    },
          options);
        }, [postReaction])
      }
    


export const usePostReactionMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostReactionHook>>>, TError,{ownerId: string;data: CreateReaction}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostReactionHook>>>, TError,{ownerId: string;data: CreateReaction}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postReaction =  usePostReactionHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostReactionHook>>>, {ownerId: string;data: CreateReaction}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postReaction(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostReactionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostReactionHook>>>>
    export type PostReactionMutationBody = CreateReaction
    export type PostReactionMutationError = ErrorPayload

    export const usePostReaction = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostReactionHook>>>, TError,{ownerId: string;data: CreateReaction}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostReactionHook>>>,
        TError,
        {ownerId: string;data: CreateReaction},
        TContext
      > => {

      const mutationOptions = usePostReactionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateAllowedAttendanceTypesHook = () => {
        const updateAllowedAttendanceTypes = useCustomInstance<Settings>();

        return useCallback((
    ownerId: string,
    updateAttendance: UpdateAttendance,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateAllowedAttendanceTypes(
          {url: `/api/${ownerId}/settings/allowedAttendanceTypes`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAttendance
    },
          options);
        }, [updateAllowedAttendanceTypes])
      }
    


export const useUpdateAllowedAttendanceTypesMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAllowedAttendanceTypesHook>>>, TError,{ownerId: string;data: UpdateAttendance}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAllowedAttendanceTypesHook>>>, TError,{ownerId: string;data: UpdateAttendance}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateAllowedAttendanceTypes =  useUpdateAllowedAttendanceTypesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateAllowedAttendanceTypesHook>>>, {ownerId: string;data: UpdateAttendance}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  updateAllowedAttendanceTypes(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAllowedAttendanceTypesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateAllowedAttendanceTypesHook>>>>
    export type UpdateAllowedAttendanceTypesMutationBody = UpdateAttendance
    export type UpdateAllowedAttendanceTypesMutationError = ErrorPayload

    export const useUpdateAllowedAttendanceTypes = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAllowedAttendanceTypesHook>>>, TError,{ownerId: string;data: UpdateAttendance}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateAllowedAttendanceTypesHook>>>,
        TError,
        {ownerId: string;data: UpdateAttendance},
        TContext
      > => {

      const mutationOptions = useUpdateAllowedAttendanceTypesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetAllowedAttendanceTypesHook = () => {
        const getAllowedAttendanceTypes = useCustomInstance<AllowedAttendanceTypes>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getAllowedAttendanceTypes(
          {url: `/api/${ownerId}/settings/allowedAttendanceTypes`, method: 'GET', signal
    },
          options);
        }, [getAllowedAttendanceTypes])
      }
    

export const getGetAllowedAttendanceTypesQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/settings/allowedAttendanceTypes`] as const;
    }

    
export const useGetAllowedAttendanceTypesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowedAttendanceTypesQueryKey(ownerId);

  const getAllowedAttendanceTypes =  useGetAllowedAttendanceTypesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>> = ({ signal }) => getAllowedAttendanceTypes(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllowedAttendanceTypesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>>
export type GetAllowedAttendanceTypesQueryError = ErrorPayload


export function useGetAllowedAttendanceTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAllowedAttendanceTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAllowedAttendanceTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetAllowedAttendanceTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAttendanceTypesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetAllowedAttendanceTypesQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateDefaultAttendanceEndingHook = () => {
        const updateDefaultAttendanceEnding = useCustomInstance<Settings>();

        return useCallback((
    ownerId: string,
    updateAttendanceEnding: UpdateAttendanceEnding,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateDefaultAttendanceEnding(
          {url: `/api/${ownerId}/settings/defaultAttendanceEnding`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAttendanceEnding
    },
          options);
        }, [updateDefaultAttendanceEnding])
      }
    


export const useUpdateDefaultAttendanceEndingMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceEndingHook>>>, TError,{ownerId: string;data: UpdateAttendanceEnding}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceEndingHook>>>, TError,{ownerId: string;data: UpdateAttendanceEnding}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateDefaultAttendanceEnding =  useUpdateDefaultAttendanceEndingHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceEndingHook>>>, {ownerId: string;data: UpdateAttendanceEnding}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  updateDefaultAttendanceEnding(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDefaultAttendanceEndingMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceEndingHook>>>>
    export type UpdateDefaultAttendanceEndingMutationBody = UpdateAttendanceEnding
    export type UpdateDefaultAttendanceEndingMutationError = ErrorPayload

    export const useUpdateDefaultAttendanceEnding = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceEndingHook>>>, TError,{ownerId: string;data: UpdateAttendanceEnding}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceEndingHook>>>,
        TError,
        {ownerId: string;data: UpdateAttendanceEnding},
        TContext
      > => {

      const mutationOptions = useUpdateDefaultAttendanceEndingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetDefaultAttendanceEndingHook = () => {
        const getDefaultAttendanceEnding = useCustomInstance<AttendanceEnding>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getDefaultAttendanceEnding(
          {url: `/api/${ownerId}/settings/defaultAttendanceEnding`, method: 'GET', signal
    },
          options);
        }, [getDefaultAttendanceEnding])
      }
    

export const getGetDefaultAttendanceEndingQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/settings/defaultAttendanceEnding`] as const;
    }

    
export const useGetDefaultAttendanceEndingQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultAttendanceEndingQueryKey(ownerId);

  const getDefaultAttendanceEnding =  useGetDefaultAttendanceEndingHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>> = ({ signal }) => getDefaultAttendanceEnding(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDefaultAttendanceEndingQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>>
export type GetDefaultAttendanceEndingQueryError = ErrorPayload


export function useGetDefaultAttendanceEnding<TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDefaultAttendanceEnding<TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDefaultAttendanceEnding<TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetDefaultAttendanceEnding<TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceEndingHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetDefaultAttendanceEndingQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateDefaultAttendanceTypeHook = () => {
        const updateDefaultAttendanceType = useCustomInstance<DefaultAttendanceType>();

        return useCallback((
    ownerId: string,
    defaultAttendanceType: DefaultAttendanceType,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateDefaultAttendanceType(
          {url: `/api/${ownerId}/settings/defaultAttendanceType`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: defaultAttendanceType
    },
          options);
        }, [updateDefaultAttendanceType])
      }
    


export const useUpdateDefaultAttendanceTypeMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceTypeHook>>>, TError,{ownerId: string;data: DefaultAttendanceType}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceTypeHook>>>, TError,{ownerId: string;data: DefaultAttendanceType}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateDefaultAttendanceType =  useUpdateDefaultAttendanceTypeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceTypeHook>>>, {ownerId: string;data: DefaultAttendanceType}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  updateDefaultAttendanceType(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDefaultAttendanceTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceTypeHook>>>>
    export type UpdateDefaultAttendanceTypeMutationBody = DefaultAttendanceType
    export type UpdateDefaultAttendanceTypeMutationError = ErrorPayload

    export const useUpdateDefaultAttendanceType = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceTypeHook>>>, TError,{ownerId: string;data: DefaultAttendanceType}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateDefaultAttendanceTypeHook>>>,
        TError,
        {ownerId: string;data: DefaultAttendanceType},
        TContext
      > => {

      const mutationOptions = useUpdateDefaultAttendanceTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetDefaultAttendanceTypeHook = () => {
        const getDefaultAttendanceType = useCustomInstance<DefaultAttendanceType>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getDefaultAttendanceType(
          {url: `/api/${ownerId}/settings/defaultAttendanceType`, method: 'GET', signal
    },
          options);
        }, [getDefaultAttendanceType])
      }
    

export const getGetDefaultAttendanceTypeQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/settings/defaultAttendanceType`] as const;
    }

    
export const useGetDefaultAttendanceTypeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultAttendanceTypeQueryKey(ownerId);

  const getDefaultAttendanceType =  useGetDefaultAttendanceTypeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>> = ({ signal }) => getDefaultAttendanceType(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDefaultAttendanceTypeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>>
export type GetDefaultAttendanceTypeQueryError = ErrorPayload


export function useGetDefaultAttendanceType<TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDefaultAttendanceType<TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDefaultAttendanceType<TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetDefaultAttendanceType<TData = Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDefaultAttendanceTypeHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetDefaultAttendanceTypeQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateDefaultPinReportHook = () => {
        const updateDefaultPinReport = useCustomInstance<Settings>();

        return useCallback((
    ownerId: string,
    updatePinDefaultReportSettings: UpdatePinDefaultReportSettings,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateDefaultPinReport(
          {url: `/api/${ownerId}/settings/pin/defaultPinReport`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePinDefaultReportSettings
    },
          options);
        }, [updateDefaultPinReport])
      }
    


export const useUpdateDefaultPinReportMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultPinReportHook>>>, TError,{ownerId: string;data: UpdatePinDefaultReportSettings}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultPinReportHook>>>, TError,{ownerId: string;data: UpdatePinDefaultReportSettings}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateDefaultPinReport =  useUpdateDefaultPinReportHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultPinReportHook>>>, {ownerId: string;data: UpdatePinDefaultReportSettings}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  updateDefaultPinReport(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDefaultPinReportMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultPinReportHook>>>>
    export type UpdateDefaultPinReportMutationBody = UpdatePinDefaultReportSettings
    export type UpdateDefaultPinReportMutationError = ErrorPayload

    export const useUpdateDefaultPinReport = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateDefaultPinReportHook>>>, TError,{ownerId: string;data: UpdatePinDefaultReportSettings}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateDefaultPinReportHook>>>,
        TError,
        {ownerId: string;data: UpdatePinDefaultReportSettings},
        TContext
      > => {

      const mutationOptions = useUpdateDefaultPinReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdatePinRequiredOnHook = () => {
        const updatePinRequiredOn = useCustomInstance<UpdatePinRequiredOnResponse>();

        return useCallback((
    ownerId: string,
    updatePinEventType: UpdatePinEventType,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updatePinRequiredOn(
          {url: `/api/${ownerId}/settings/pin/pinRequiredOn`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePinEventType
    },
          options);
        }, [updatePinRequiredOn])
      }
    


export const useUpdatePinRequiredOnMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdatePinRequiredOnHook>>>, TError,{ownerId: string;data: UpdatePinEventType}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdatePinRequiredOnHook>>>, TError,{ownerId: string;data: UpdatePinEventType}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updatePinRequiredOn =  useUpdatePinRequiredOnHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdatePinRequiredOnHook>>>, {ownerId: string;data: UpdatePinEventType}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  updatePinRequiredOn(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePinRequiredOnMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdatePinRequiredOnHook>>>>
    export type UpdatePinRequiredOnMutationBody = UpdatePinEventType
    export type UpdatePinRequiredOnMutationError = ErrorPayload

    export const useUpdatePinRequiredOn = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdatePinRequiredOnHook>>>, TError,{ownerId: string;data: UpdatePinEventType}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdatePinRequiredOnHook>>>,
        TError,
        {ownerId: string;data: UpdatePinEventType},
        TContext
      > => {

      const mutationOptions = useUpdatePinRequiredOnMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostGeneratePinForEmployeesHook = () => {
        const postGeneratePinForEmployees = useCustomInstance<PinGenerationPayload>();

        return useCallback((
    ownerId: string,
    generatePinForEmployees: GeneratePinForEmployees,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postGeneratePinForEmployees(
          {url: `/api/${ownerId}/settings/pin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generatePinForEmployees
    },
          options);
        }, [postGeneratePinForEmployees])
      }
    


export const usePostGeneratePinForEmployeesMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeesHook>>>, TError,{ownerId: string;data: GeneratePinForEmployees}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeesHook>>>, TError,{ownerId: string;data: GeneratePinForEmployees}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postGeneratePinForEmployees =  usePostGeneratePinForEmployeesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeesHook>>>, {ownerId: string;data: GeneratePinForEmployees}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postGeneratePinForEmployees(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGeneratePinForEmployeesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeesHook>>>>
    export type PostGeneratePinForEmployeesMutationBody = GeneratePinForEmployees
    export type PostGeneratePinForEmployeesMutationError = ErrorPayload

    export const usePostGeneratePinForEmployees = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeesHook>>>, TError,{ownerId: string;data: GeneratePinForEmployees}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostGeneratePinForEmployeesHook>>>,
        TError,
        {ownerId: string;data: GeneratePinForEmployees},
        TContext
      > => {

      const mutationOptions = usePostGeneratePinForEmployeesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetOwnerCardStatsHook = () => {
        const getOwnerCardStats = useCustomInstance<OwnerCardStats>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getOwnerCardStats(
          {url: `/api/${ownerId}/stats`, method: 'GET', signal
    },
          options);
        }, [getOwnerCardStats])
      }
    

export const getGetOwnerCardStatsQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/stats`] as const;
    }

    
export const useGetOwnerCardStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerCardStatsQueryKey(ownerId);

  const getOwnerCardStats =  useGetOwnerCardStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>> = ({ signal }) => getOwnerCardStats(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerCardStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>>
export type GetOwnerCardStatsQueryError = ErrorPayload


export function useGetOwnerCardStats<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwnerCardStats<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwnerCardStats<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetOwnerCardStats<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerCardStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetOwnerCardStatsQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTaskAttachmentsHook = () => {
        const getTaskAttachments = useCustomInstance<AttachmentList>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTaskAttachments(
          {url: `/api/${ownerId}/tasks/${id}/attachments`, method: 'GET', signal
    },
          options);
        }, [getTaskAttachments])
      }
    

export const getGetTaskAttachmentsQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/tasks/${id}/attachments`] as const;
    }

    
export const useGetTaskAttachmentsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskAttachmentsQueryKey(ownerId,id);

  const getTaskAttachments =  useGetTaskAttachmentsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>> = ({ signal }) => getTaskAttachments(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskAttachmentsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>>
export type GetTaskAttachmentsQueryError = ErrorPayload


export function useGetTaskAttachments<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskAttachments<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskAttachments<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTaskAttachments<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskAttachmentsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTaskAttachmentsQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTaskDetailsHook = () => {
        const getTaskDetails = useCustomInstance<GetTaskDetails>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTaskDetails(
          {url: `/api/${ownerId}/tasks/${id}/detail`, method: 'GET', signal
    },
          options);
        }, [getTaskDetails])
      }
    

export const getGetTaskDetailsQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/tasks/${id}/detail`] as const;
    }

    
export const useGetTaskDetailsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskDetailsQueryKey(ownerId,id);

  const getTaskDetails =  useGetTaskDetailsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>> = ({ signal }) => getTaskDetails(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskDetailsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>>
export type GetTaskDetailsQueryError = ErrorPayload


export function useGetTaskDetails<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskDetails<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskDetails<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTaskDetails<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTaskDetailsQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTaskDetailTasksCostsStatsHook = () => {
        const getTaskDetailTasksCostsStats = useCustomInstance<GetTasksCostsStats>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTaskDetailTasksCostsStats(
          {url: `/api/${ownerId}/tasks/${id}/stats/costs`, method: 'GET', signal
    },
          options);
        }, [getTaskDetailTasksCostsStats])
      }
    

export const getGetTaskDetailTasksCostsStatsQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/tasks/${id}/stats/costs`] as const;
    }

    
export const useGetTaskDetailTasksCostsStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskDetailTasksCostsStatsQueryKey(ownerId,id);

  const getTaskDetailTasksCostsStats =  useGetTaskDetailTasksCostsStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>> = ({ signal }) => getTaskDetailTasksCostsStats(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskDetailTasksCostsStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>>
export type GetTaskDetailTasksCostsStatsQueryError = ErrorPayload


export function useGetTaskDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTaskDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTaskDetailTasksCostsStatsQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTaskDetailTimeTasksStatsHook = () => {
        const getTaskDetailTimeTasksStats = useCustomInstance<GetTimeTasksStats>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTaskDetailTimeTasksStats(
          {url: `/api/${ownerId}/tasks/${id}/stats/tasks`, method: 'GET', signal
    },
          options);
        }, [getTaskDetailTimeTasksStats])
      }
    

export const getGetTaskDetailTimeTasksStatsQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/tasks/${id}/stats/tasks`] as const;
    }

    
export const useGetTaskDetailTimeTasksStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskDetailTimeTasksStatsQueryKey(ownerId,id);

  const getTaskDetailTimeTasksStats =  useGetTaskDetailTimeTasksStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>> = ({ signal }) => getTaskDetailTimeTasksStats(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskDetailTimeTasksStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>>
export type GetTaskDetailTimeTasksStatsQueryError = ErrorPayload


export function useGetTaskDetailTimeTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskDetailTimeTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskDetailTimeTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTaskDetailTimeTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTimeTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTaskDetailTimeTasksStatsQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTaskDetailTasksTimeStatsHook = () => {
        const getTaskDetailTasksTimeStats = useCustomInstance<GetTasksTimeStats>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTaskDetailTasksTimeStats(
          {url: `/api/${ownerId}/tasks/${id}/stats/time`, method: 'GET', signal
    },
          options);
        }, [getTaskDetailTasksTimeStats])
      }
    

export const getGetTaskDetailTasksTimeStatsQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/tasks/${id}/stats/time`] as const;
    }

    
export const useGetTaskDetailTasksTimeStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskDetailTasksTimeStatsQueryKey(ownerId,id);

  const getTaskDetailTasksTimeStats =  useGetTaskDetailTasksTimeStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>> = ({ signal }) => getTaskDetailTasksTimeStats(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskDetailTasksTimeStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>>
export type GetTaskDetailTasksTimeStatsQueryError = ErrorPayload


export function useGetTaskDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTaskDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTaskDetailTasksTimeStatsQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetCustomerDetailTasksCostsStatsHook = () => {
        const getCustomerDetailTasksCostsStats = useCustomInstance<GetTasksCostsStats>();

        return useCallback((
    ownerId: string,
    customerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCustomerDetailTasksCostsStats(
          {url: `/api/${ownerId}/tasks/stats/customer/${customerId}/costs`, method: 'GET', signal
    },
          options);
        }, [getCustomerDetailTasksCostsStats])
      }
    

export const getGetCustomerDetailTasksCostsStatsQueryKey = (ownerId: string,
    customerId: string,) => {
    return [`/api/${ownerId}/tasks/stats/customer/${customerId}/costs`] as const;
    }

    
export const useGetCustomerDetailTasksCostsStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerDetailTasksCostsStatsQueryKey(ownerId,customerId);

  const getCustomerDetailTasksCostsStats =  useGetCustomerDetailTasksCostsStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>> = ({ signal }) => getCustomerDetailTasksCostsStats(ownerId,customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerDetailTasksCostsStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>>
export type GetCustomerDetailTasksCostsStatsQueryError = ErrorPayload


export function useGetCustomerDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomerDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomerDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCustomerDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCustomerDetailTasksCostsStatsQueryOptions(ownerId,customerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetCustomerDetailTasksStatsHook = () => {
        const getCustomerDetailTasksStats = useCustomInstance<GetTasksStats>();

        return useCallback((
    ownerId: string,
    customerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCustomerDetailTasksStats(
          {url: `/api/${ownerId}/tasks/stats/customer/${customerId}/tasks`, method: 'GET', signal
    },
          options);
        }, [getCustomerDetailTasksStats])
      }
    

export const getGetCustomerDetailTasksStatsQueryKey = (ownerId: string,
    customerId: string,) => {
    return [`/api/${ownerId}/tasks/stats/customer/${customerId}/tasks`] as const;
    }

    
export const useGetCustomerDetailTasksStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerDetailTasksStatsQueryKey(ownerId,customerId);

  const getCustomerDetailTasksStats =  useGetCustomerDetailTasksStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>> = ({ signal }) => getCustomerDetailTasksStats(ownerId,customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerDetailTasksStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>>
export type GetCustomerDetailTasksStatsQueryError = ErrorPayload


export function useGetCustomerDetailTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomerDetailTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomerDetailTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCustomerDetailTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCustomerDetailTasksStatsQueryOptions(ownerId,customerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetCustomerDetailTasksTimeStatsHook = () => {
        const getCustomerDetailTasksTimeStats = useCustomInstance<GetTasksTimeStats>();

        return useCallback((
    ownerId: string,
    customerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getCustomerDetailTasksTimeStats(
          {url: `/api/${ownerId}/tasks/stats/customer/${customerId}/time`, method: 'GET', signal
    },
          options);
        }, [getCustomerDetailTasksTimeStats])
      }
    

export const getGetCustomerDetailTasksTimeStatsQueryKey = (ownerId: string,
    customerId: string,) => {
    return [`/api/${ownerId}/tasks/stats/customer/${customerId}/time`] as const;
    }

    
export const useGetCustomerDetailTasksTimeStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerDetailTasksTimeStatsQueryKey(ownerId,customerId);

  const getCustomerDetailTasksTimeStats =  useGetCustomerDetailTasksTimeStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>> = ({ signal }) => getCustomerDetailTasksTimeStats(ownerId,customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerDetailTasksTimeStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>>
export type GetCustomerDetailTasksTimeStatsQueryError = ErrorPayload


export function useGetCustomerDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomerDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetCustomerDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetCustomerDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomerDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetCustomerDetailTasksTimeStatsQueryOptions(ownerId,customerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetJobDetailTasksCostsStatsHook = () => {
        const getJobDetailTasksCostsStats = useCustomInstance<GetTasksCostsStats>();

        return useCallback((
    ownerId: string,
    jobId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobDetailTasksCostsStats(
          {url: `/api/${ownerId}/tasks/stats/job/${jobId}/costs`, method: 'GET', signal
    },
          options);
        }, [getJobDetailTasksCostsStats])
      }
    

export const getGetJobDetailTasksCostsStatsQueryKey = (ownerId: string,
    jobId: string,) => {
    return [`/api/${ownerId}/tasks/stats/job/${jobId}/costs`] as const;
    }

    
export const useGetJobDetailTasksCostsStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobDetailTasksCostsStatsQueryKey(ownerId,jobId);

  const getJobDetailTasksCostsStats =  useGetJobDetailTasksCostsStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>> = ({ signal }) => getJobDetailTasksCostsStats(ownerId,jobId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobDetailTasksCostsStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>>
export type GetJobDetailTasksCostsStatsQueryError = ErrorPayload


export function useGetJobDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobDetailTasksCostsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksCostsStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobDetailTasksCostsStatsQueryOptions(ownerId,jobId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetJobDetailTasksStatsHook = () => {
        const getJobDetailTasksStats = useCustomInstance<GetTasksStats>();

        return useCallback((
    ownerId: string,
    jobId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobDetailTasksStats(
          {url: `/api/${ownerId}/tasks/stats/job/${jobId}/tasks`, method: 'GET', signal
    },
          options);
        }, [getJobDetailTasksStats])
      }
    

export const getGetJobDetailTasksStatsQueryKey = (ownerId: string,
    jobId: string,) => {
    return [`/api/${ownerId}/tasks/stats/job/${jobId}/tasks`] as const;
    }

    
export const useGetJobDetailTasksStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobDetailTasksStatsQueryKey(ownerId,jobId);

  const getJobDetailTasksStats =  useGetJobDetailTasksStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>> = ({ signal }) => getJobDetailTasksStats(ownerId,jobId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobDetailTasksStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>>
export type GetJobDetailTasksStatsQueryError = ErrorPayload


export function useGetJobDetailTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobDetailTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobDetailTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobDetailTasksStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobDetailTasksStatsQueryOptions(ownerId,jobId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetJobDetailTasksTimeStatsHook = () => {
        const getJobDetailTasksTimeStats = useCustomInstance<GetTasksTimeStats>();

        return useCallback((
    ownerId: string,
    jobId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getJobDetailTasksTimeStats(
          {url: `/api/${ownerId}/tasks/stats/job/${jobId}/time`, method: 'GET', signal
    },
          options);
        }, [getJobDetailTasksTimeStats])
      }
    

export const getGetJobDetailTasksTimeStatsQueryKey = (ownerId: string,
    jobId: string,) => {
    return [`/api/${ownerId}/tasks/stats/job/${jobId}/time`] as const;
    }

    
export const useGetJobDetailTasksTimeStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobDetailTasksTimeStatsQueryKey(ownerId,jobId);

  const getJobDetailTasksTimeStats =  useGetJobDetailTasksTimeStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>> = ({ signal }) => getJobDetailTasksTimeStats(ownerId,jobId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobDetailTasksTimeStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>>
export type GetJobDetailTasksTimeStatsQueryError = ErrorPayload


export function useGetJobDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetJobDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetJobDetailTasksTimeStats<TData = Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobDetailTasksTimeStatsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetJobDetailTasksTimeStatsQueryOptions(ownerId,jobId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetDataForTaskTableHook = () => {
        const getDataForTaskTable = useCustomInstance<TaskTableResponse>();

        return useCallback((
    ownerId: string,
    jobId: string,
    params?: GetDataForTaskTableParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getDataForTaskTable(
          {url: `/api/${ownerId}/tasks/table/${jobId}`, method: 'GET',
        params, signal
    },
          options);
        }, [getDataForTaskTable])
      }
    

export const getGetDataForTaskTableQueryKey = (ownerId: string,
    jobId: string,
    params?: GetDataForTaskTableParams,) => {
    return [`/api/${ownerId}/tasks/table/${jobId}`, ...(params ? [params]: [])] as const;
    }

    
export const useGetDataForTaskTableQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError = ErrorPayload>(ownerId: string,
    jobId: string,
    params?: GetDataForTaskTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataForTaskTableQueryKey(ownerId,jobId,params);

  const getDataForTaskTable =  useGetDataForTaskTableHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>> = ({ signal }) => getDataForTaskTable(ownerId,jobId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDataForTaskTableQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>>
export type GetDataForTaskTableQueryError = ErrorPayload


export function useGetDataForTaskTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string,
    params: undefined |  GetDataForTaskTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDataForTaskTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string,
    params?: GetDataForTaskTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDataForTaskTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string,
    params?: GetDataForTaskTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetDataForTaskTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    jobId: string,
    params?: GetDataForTaskTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForTaskTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetDataForTaskTableQueryOptions(ownerId,jobId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostTimeReportingHook = () => {
        const postTimeReporting = useCustomInstance<PayloadId>();

        return useCallback((
    ownerId: string,
    timeReportingParams: TimeReportingParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postTimeReporting(
          {url: `/api/${ownerId}/timeReporting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timeReportingParams
    },
          options);
        }, [postTimeReporting])
      }
    


export const usePostTimeReportingMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimeReportingHook>>>, TError,{ownerId: string;data: TimeReportingParams}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimeReportingHook>>>, TError,{ownerId: string;data: TimeReportingParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postTimeReporting =  usePostTimeReportingHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTimeReportingHook>>>, {ownerId: string;data: TimeReportingParams}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postTimeReporting(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTimeReportingMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTimeReportingHook>>>>
    export type PostTimeReportingMutationBody = TimeReportingParams
    export type PostTimeReportingMutationError = ErrorPayload

    export const usePostTimeReporting = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimeReportingHook>>>, TError,{ownerId: string;data: TimeReportingParams}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTimeReportingHook>>>,
        TError,
        {ownerId: string;data: TimeReportingParams},
        TContext
      > => {

      const mutationOptions = usePostTimeReportingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetEmployeesTimeSheetsHook = () => {
        const getEmployeesTimeSheets = useCustomInstance<EmployeesTimeSheetsResponse>();

        return useCallback((
    ownerId: string,
    params: GetEmployeesTimeSheetsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEmployeesTimeSheets(
          {url: `/api/${ownerId}/timeSheets`, method: 'GET',
        params, signal
    },
          options);
        }, [getEmployeesTimeSheets])
      }
    

export const getGetEmployeesTimeSheetsQueryKey = (ownerId: string,
    params: GetEmployeesTimeSheetsParams,) => {
    return [`/api/${ownerId}/timeSheets`, ...(params ? [params]: [])] as const;
    }

    
export const useGetEmployeesTimeSheetsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError = ErrorPayload>(ownerId: string,
    params: GetEmployeesTimeSheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeesTimeSheetsQueryKey(ownerId,params);

  const getEmployeesTimeSheets =  useGetEmployeesTimeSheetsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>> = ({ signal }) => getEmployeesTimeSheets(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployeesTimeSheetsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>>
export type GetEmployeesTimeSheetsQueryError = ErrorPayload


export function useGetEmployeesTimeSheets<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetEmployeesTimeSheetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeesTimeSheets<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetEmployeesTimeSheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEmployeesTimeSheets<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetEmployeesTimeSheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEmployeesTimeSheets<TData = Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: GetEmployeesTimeSheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmployeesTimeSheetsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEmployeesTimeSheetsQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateTimeByIdHook = () => {
        const updateTimeById = useCustomInstance<GetTimeResponse>();

        return useCallback((
    ownerId: string,
    id: string,
    updateTime: UpdateTime,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateTimeById(
          {url: `/api/${ownerId}/times/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTime
    },
          options);
        }, [updateTimeById])
      }
    


export const useUpdateTimeByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTimeByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateTime}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTimeByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateTime}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateTimeById =  useUpdateTimeByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateTimeByIdHook>>>, {ownerId: string;id: string;data: UpdateTime}> = (props) => {
          const {ownerId,id,data} = props ?? {};

          return  updateTimeById(ownerId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTimeByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateTimeByIdHook>>>>
    export type UpdateTimeByIdMutationBody = UpdateTime
    export type UpdateTimeByIdMutationError = ErrorPayload

    export const useUpdateTimeById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTimeByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateTime}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateTimeByIdHook>>>,
        TError,
        {ownerId: string;id: string;data: UpdateTime},
        TContext
      > => {

      const mutationOptions = useUpdateTimeByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteTimeByIdHook = () => {
        const deleteTimeById = useCustomInstance<GetTimeResponse>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteTimeById(
          {url: `/api/${ownerId}/times/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteTimeById])
      }
    


export const useDeleteTimeByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteTimeByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteTimeByIdHook>>>, TError,{ownerId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteTimeById =  useDeleteTimeByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteTimeByIdHook>>>, {ownerId: string;id: string}> = (props) => {
          const {ownerId,id} = props ?? {};

          return  deleteTimeById(ownerId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTimeByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteTimeByIdHook>>>>
    
    export type DeleteTimeByIdMutationError = ErrorPayload

    export const useDeleteTimeById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteTimeByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteTimeByIdHook>>>,
        TError,
        {ownerId: string;id: string},
        TContext
      > => {

      const mutationOptions = useDeleteTimeByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetTimeByIdHook = () => {
        const getTimeById = useCustomInstance<GetTimeResponse>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTimeById(
          {url: `/api/${ownerId}/times/${id}`, method: 'GET', signal
    },
          options);
        }, [getTimeById])
      }
    

export const getGetTimeByIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/times/${id}`] as const;
    }

    
export const useGetTimeByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimeByIdQueryKey(ownerId,id);

  const getTimeById =  useGetTimeByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>> = ({ signal }) => getTimeById(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTimeByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>>
export type GetTimeByIdQueryError = ErrorPayload


export function useGetTimeById<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimeById<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimeById<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTimeById<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTimeByIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useBatchUpdateTimesHook = () => {
        const batchUpdateTimes = useCustomInstance<BatchUpdateTimeResponse>();

        return useCallback((
    ownerId: string,
    batchUpdateTime: BatchUpdateTime,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return batchUpdateTimes(
          {url: `/api/${ownerId}/times/batch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: batchUpdateTime
    },
          options);
        }, [batchUpdateTimes])
      }
    


export const useBatchUpdateTimesMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useBatchUpdateTimesHook>>>, TError,{ownerId: string;data: BatchUpdateTime}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useBatchUpdateTimesHook>>>, TError,{ownerId: string;data: BatchUpdateTime}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const batchUpdateTimes =  useBatchUpdateTimesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useBatchUpdateTimesHook>>>, {ownerId: string;data: BatchUpdateTime}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  batchUpdateTimes(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BatchUpdateTimesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBatchUpdateTimesHook>>>>
    export type BatchUpdateTimesMutationBody = BatchUpdateTime
    export type BatchUpdateTimesMutationError = ErrorPayload

    export const useBatchUpdateTimes = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useBatchUpdateTimesHook>>>, TError,{ownerId: string;data: BatchUpdateTime}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useBatchUpdateTimesHook>>>,
        TError,
        {ownerId: string;data: BatchUpdateTime},
        TContext
      > => {

      const mutationOptions = useBatchUpdateTimesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetDayModalTimesHook = () => {
        const getDayModalTimes = useCustomInstance<Time[]>();

        return useCallback((
    ownerId: string,
    employeeId: string,
    taskId: string,
    params?: GetDayModalTimesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getDayModalTimes(
          {url: `/api/${ownerId}/times/dayModal/${employeeId}/${taskId}`, method: 'GET',
        params, signal
    },
          options);
        }, [getDayModalTimes])
      }
    

export const getGetDayModalTimesQueryKey = (ownerId: string,
    employeeId: string,
    taskId: string,
    params?: GetDayModalTimesParams,) => {
    return [`/api/${ownerId}/times/dayModal/${employeeId}/${taskId}`, ...(params ? [params]: [])] as const;
    }

    
export const useGetDayModalTimesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError = ErrorPayload>(ownerId: string,
    employeeId: string,
    taskId: string,
    params?: GetDayModalTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDayModalTimesQueryKey(ownerId,employeeId,taskId,params);

  const getDayModalTimes =  useGetDayModalTimesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>> = ({ signal }) => getDayModalTimes(ownerId,employeeId,taskId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && employeeId && taskId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDayModalTimesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>>
export type GetDayModalTimesQueryError = ErrorPayload


export function useGetDayModalTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    employeeId: string,
    taskId: string,
    params: undefined |  GetDayModalTimesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDayModalTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    employeeId: string,
    taskId: string,
    params?: GetDayModalTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDayModalTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    employeeId: string,
    taskId: string,
    params?: GetDayModalTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetDayModalTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    employeeId: string,
    taskId: string,
    params?: GetDayModalTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDayModalTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetDayModalTimesQueryOptions(ownerId,employeeId,taskId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetEntryWithoutEndHook = () => {
        const getEntryWithoutEnd = useCustomInstance<EntryWithoutEndResponse>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getEntryWithoutEnd(
          {url: `/api/${ownerId}/times/entryWithoutEnd`, method: 'GET', signal
    },
          options);
        }, [getEntryWithoutEnd])
      }
    

export const getGetEntryWithoutEndQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/times/entryWithoutEnd`] as const;
    }

    
export const useGetEntryWithoutEndQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntryWithoutEndQueryKey(ownerId);

  const getEntryWithoutEnd =  useGetEntryWithoutEndHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>> = ({ signal }) => getEntryWithoutEnd(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEntryWithoutEndQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>>
export type GetEntryWithoutEndQueryError = ErrorPayload


export function useGetEntryWithoutEnd<TData = Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEntryWithoutEnd<TData = Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetEntryWithoutEnd<TData = Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetEntryWithoutEnd<TData = Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntryWithoutEndHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetEntryWithoutEndQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostTimesArrayFieldHook = () => {
        const postTimesArrayField = useCustomInstance<Time[]>();

        return useCallback((
    ownerId: string,
    fieldArrayTimeParams: FieldArrayTimeParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postTimesArrayField(
          {url: `/api/${ownerId}/times/fieldArray`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fieldArrayTimeParams
    },
          options);
        }, [postTimesArrayField])
      }
    


export const usePostTimesArrayFieldMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimesArrayFieldHook>>>, TError,{ownerId: string;data: FieldArrayTimeParams}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimesArrayFieldHook>>>, TError,{ownerId: string;data: FieldArrayTimeParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postTimesArrayField =  usePostTimesArrayFieldHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTimesArrayFieldHook>>>, {ownerId: string;data: FieldArrayTimeParams}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postTimesArrayField(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTimesArrayFieldMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTimesArrayFieldHook>>>>
    export type PostTimesArrayFieldMutationBody = FieldArrayTimeParams
    export type PostTimesArrayFieldMutationError = ErrorPayload

    export const usePostTimesArrayField = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimesArrayFieldHook>>>, TError,{ownerId: string;data: FieldArrayTimeParams}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTimesArrayFieldHook>>>,
        TError,
        {ownerId: string;data: FieldArrayTimeParams},
        TContext
      > => {

      const mutationOptions = usePostTimesArrayFieldMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetGroupedEmployeeTimesHook = () => {
        const getGroupedEmployeeTimes = useCustomInstance<GroupedEmployeeTimes>();

        return useCallback((
    ownerId: string,
    id: string,
    params?: GetGroupedEmployeeTimesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getGroupedEmployeeTimes(
          {url: `/api/${ownerId}/times/groupedEmployeeTimes/${id}`, method: 'GET',
        params, signal
    },
          options);
        }, [getGroupedEmployeeTimes])
      }
    

export const getGetGroupedEmployeeTimesQueryKey = (ownerId: string,
    id: string,
    params?: GetGroupedEmployeeTimesParams,) => {
    return [`/api/${ownerId}/times/groupedEmployeeTimes/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const useGetGroupedEmployeeTimesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string,
    params?: GetGroupedEmployeeTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupedEmployeeTimesQueryKey(ownerId,id,params);

  const getGroupedEmployeeTimes =  useGetGroupedEmployeeTimesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>> = ({ signal }) => getGroupedEmployeeTimes(ownerId,id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGroupedEmployeeTimesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>>
export type GetGroupedEmployeeTimesQueryError = ErrorPayload


export function useGetGroupedEmployeeTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params: undefined |  GetGroupedEmployeeTimesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupedEmployeeTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params?: GetGroupedEmployeeTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupedEmployeeTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params?: GetGroupedEmployeeTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetGroupedEmployeeTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string,
    params?: GetGroupedEmployeeTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedEmployeeTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetGroupedEmployeeTimesQueryOptions(ownerId,id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetGroupedTimesHook = () => {
        const getGroupedTimes = useCustomInstance<GroupedTimes[]>();

        return useCallback((
    ownerId: string,
    taskId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getGroupedTimes(
          {url: `/api/${ownerId}/times/groupedTimes/${taskId}`, method: 'GET', signal
    },
          options);
        }, [getGroupedTimes])
      }
    

export const getGetGroupedTimesQueryKey = (ownerId: string,
    taskId: string,) => {
    return [`/api/${ownerId}/times/groupedTimes/${taskId}`] as const;
    }

    
export const useGetGroupedTimesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError = ErrorPayload>(ownerId: string,
    taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupedTimesQueryKey(ownerId,taskId);

  const getGroupedTimes =  useGetGroupedTimesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>> = ({ signal }) => getGroupedTimes(ownerId,taskId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && taskId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGroupedTimesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>>
export type GetGroupedTimesQueryError = ErrorPayload


export function useGetGroupedTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    taskId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupedTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupedTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetGroupedTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetGroupedTimesQueryOptions(ownerId,taskId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTimeReportsHook = () => {
        const getTimeReports = useCustomInstance<GetTimeReportsResponse>();

        return useCallback((
    ownerId: string,
    params?: GetTimeReportsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTimeReports(
          {url: `/api/${ownerId}/times/reports`, method: 'GET',
        params, signal
    },
          options);
        }, [getTimeReports])
      }
    

export const getGetTimeReportsQueryKey = (ownerId: string,
    params?: GetTimeReportsParams,) => {
    return [`/api/${ownerId}/times/reports`, ...(params ? [params]: [])] as const;
    }

    
export const useGetTimeReportsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetTimeReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimeReportsQueryKey(ownerId,params);

  const getTimeReports =  useGetTimeReportsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>> = ({ signal }) => getTimeReports(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTimeReportsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>>
export type GetTimeReportsQueryError = ErrorPayload


export function useGetTimeReports<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetTimeReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimeReports<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimeReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimeReports<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimeReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTimeReports<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimeReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeReportsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTimeReportsQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostTimeHook = () => {
        const postTime = useCustomInstance<Time>();

        return useCallback((
    ownerId: string,
    createTime: CreateTime,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postTime(
          {url: `/api/${ownerId}/times`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTime
    },
          options);
        }, [postTime])
      }
    


export const usePostTimeMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimeHook>>>, TError,{ownerId: string;data: CreateTime}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimeHook>>>, TError,{ownerId: string;data: CreateTime}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postTime =  usePostTimeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTimeHook>>>, {ownerId: string;data: CreateTime}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postTime(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTimeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTimeHook>>>>
    export type PostTimeMutationBody = CreateTime
    export type PostTimeMutationError = ErrorPayload

    export const usePostTime = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTimeHook>>>, TError,{ownerId: string;data: CreateTime}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTimeHook>>>,
        TError,
        {ownerId: string;data: CreateTime},
        TContext
      > => {

      const mutationOptions = usePostTimeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetTimesHook = () => {
        const getTimes = useCustomInstance<GetTimesPaginatedResponse>();

        return useCallback((
    ownerId: string,
    params?: GetTimesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTimes(
          {url: `/api/${ownerId}/times`, method: 'GET',
        params, signal
    },
          options);
        }, [getTimes])
      }
    

export const getGetTimesQueryKey = (ownerId: string,
    params?: GetTimesParams,) => {
    return [`/api/${ownerId}/times`, ...(params ? [params]: [])] as const;
    }

    
export const useGetTimesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, GetTimesParams['cursor']>, TError = ErrorPayload>(ownerId: string,
    params?: GetTimesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, QueryKey, GetTimesParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimesQueryKey(ownerId,params);

  const getTimes =  useGetTimesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, QueryKey, GetTimesParams['cursor']> = ({ signal, pageParam }) => getTimes(ownerId,{...params, cursor: pageParam || params?.['cursor']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId),  keepPreviousData: true,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, QueryKey, GetTimesParams['cursor']> & { queryKey: QueryKey }
}

export type GetTimesInfiniteQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>>
export type GetTimesInfiniteQueryError = ErrorPayload


export function useGetTimesInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, GetTimesParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetTimesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, QueryKey, GetTimesParams['cursor']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>,
          TError,
          TData, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimesInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, GetTimesParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, QueryKey, GetTimesParams['cursor']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>,
          TError,
          TData, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimesInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, GetTimesParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, QueryKey, GetTimesParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTimesInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, GetTimesParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, QueryKey, GetTimesParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTimesInfiniteQueryOptions(ownerId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useGetTimesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimesQueryKey(ownerId,params);

  const getTimes =  useGetTimesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>> = ({ signal }) => getTimes(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId),  keepPreviousData: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTimesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>>
export type GetTimesQueryError = ErrorPayload


export function useGetTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetTimesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTimesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetSuspiciousTimesHook = () => {
        const getSuspiciousTimes = useCustomInstance<GetSuspiciousTimesResponse>();

        return useCallback((
    ownerId: string,
    params?: GetSuspiciousTimesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getSuspiciousTimes(
          {url: `/api/${ownerId}/times/suspicious`, method: 'GET',
        params, signal
    },
          options);
        }, [getSuspiciousTimes])
      }
    

export const getGetSuspiciousTimesQueryKey = (ownerId: string,
    params?: GetSuspiciousTimesParams,) => {
    return [`/api/${ownerId}/times/suspicious`, ...(params ? [params]: [])] as const;
    }

    
export const useGetSuspiciousTimesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetSuspiciousTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuspiciousTimesQueryKey(ownerId,params);

  const getSuspiciousTimes =  useGetSuspiciousTimesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>> = ({ signal }) => getSuspiciousTimes(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSuspiciousTimesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>>
export type GetSuspiciousTimesQueryError = ErrorPayload


export function useGetSuspiciousTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetSuspiciousTimesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetSuspiciousTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetSuspiciousTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetSuspiciousTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetSuspiciousTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetSuspiciousTimes<TData = Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetSuspiciousTimesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuspiciousTimesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetSuspiciousTimesQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTimeOverviewByEmployeeIdHook = () => {
        const getTimeOverviewByEmployeeId = useCustomInstance<TimeOverview>();

        return useCallback((
    ownerId: string,
    employeeId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTimeOverviewByEmployeeId(
          {url: `/api/${ownerId}/times/timesOverview/employee/${employeeId}`, method: 'GET', signal
    },
          options);
        }, [getTimeOverviewByEmployeeId])
      }
    

export const getGetTimeOverviewByEmployeeIdQueryKey = (ownerId: string,
    employeeId: string,) => {
    return [`/api/${ownerId}/times/timesOverview/employee/${employeeId}`] as const;
    }

    
export const useGetTimeOverviewByEmployeeIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError = ErrorPayload>(ownerId: string,
    employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimeOverviewByEmployeeIdQueryKey(ownerId,employeeId);

  const getTimeOverviewByEmployeeId =  useGetTimeOverviewByEmployeeIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>> = ({ signal }) => getTimeOverviewByEmployeeId(ownerId,employeeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && employeeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTimeOverviewByEmployeeIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>>
export type GetTimeOverviewByEmployeeIdQueryError = ErrorPayload


export function useGetTimeOverviewByEmployeeId<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    employeeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimeOverviewByEmployeeId<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimeOverviewByEmployeeId<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTimeOverviewByEmployeeId<TData = Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimeOverviewByEmployeeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTimeOverviewByEmployeeIdQueryOptions(ownerId,employeeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTimesOverviewHook = () => {
        const getTimesOverview = useCustomInstance<TimeOverviewPaginatedResponse>();

        return useCallback((
    ownerId: string,
    params?: GetTimesOverviewParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTimesOverview(
          {url: `/api/${ownerId}/times/timesOverview`, method: 'GET',
        params, signal
    },
          options);
        }, [getTimesOverview])
      }
    

export const getGetTimesOverviewQueryKey = (ownerId: string,
    params?: GetTimesOverviewParams,) => {
    return [`/api/${ownerId}/times/timesOverview`, ...(params ? [params]: [])] as const;
    }

    
export const useGetTimesOverviewInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, GetTimesOverviewParams['cursor']>, TError = ErrorPayload>(ownerId: string,
    params?: GetTimesOverviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, QueryKey, GetTimesOverviewParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimesOverviewQueryKey(ownerId,params);

  const getTimesOverview =  useGetTimesOverviewHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, QueryKey, GetTimesOverviewParams['cursor']> = ({ signal, pageParam }) => getTimesOverview(ownerId,{...params, cursor: pageParam || params?.['cursor']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId),  keepPreviousData: true,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, QueryKey, GetTimesOverviewParams['cursor']> & { queryKey: QueryKey }
}

export type GetTimesOverviewInfiniteQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>>
export type GetTimesOverviewInfiniteQueryError = ErrorPayload


export function useGetTimesOverviewInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, GetTimesOverviewParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetTimesOverviewParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, QueryKey, GetTimesOverviewParams['cursor']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>,
          TError,
          TData, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimesOverviewInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, GetTimesOverviewParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesOverviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, QueryKey, GetTimesOverviewParams['cursor']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>,
          TError,
          TData, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimesOverviewInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, GetTimesOverviewParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesOverviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, QueryKey, GetTimesOverviewParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTimesOverviewInfinite<TData = InfiniteData<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, GetTimesOverviewParams['cursor']>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesOverviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData, Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, QueryKey, GetTimesOverviewParams['cursor']>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTimesOverviewInfiniteQueryOptions(ownerId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useGetTimesOverviewQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetTimesOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimesOverviewQueryKey(ownerId,params);

  const getTimesOverview =  useGetTimesOverviewHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>> = ({ signal }) => getTimesOverview(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId),  keepPreviousData: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTimesOverviewQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>>
export type GetTimesOverviewQueryError = ErrorPayload


export function useGetTimesOverview<TData = Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetTimesOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimesOverview<TData = Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTimesOverview<TData = Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTimesOverview<TData = Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetTimesOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTimesOverviewHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTimesOverviewQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetUserRolesHook = () => {
        const getUserRoles = useCustomInstance<UserRoleWithRelations[]>();

        return useCallback((
    ownerId: string,
    userId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUserRoles(
          {url: `/api/${ownerId}/userRoles/${userId}`, method: 'GET', signal
    },
          options);
        }, [getUserRoles])
      }
    

export const getGetUserRolesQueryKey = (ownerId: string,
    userId: string,) => {
    return [`/api/${ownerId}/userRoles/${userId}`] as const;
    }

    
export const useGetUserRolesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorPayload>(ownerId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRolesQueryKey(ownerId,userId);

  const getUserRoles =  useGetUserRolesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>> = ({ signal }) => getUserRoles(ownerId,userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRolesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>>
export type GetUserRolesQueryError = ErrorPayload


export function useGetUserRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUserRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorPayload>(
 ownerId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUserRolesQueryOptions(ownerId,userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetUserBaseDataHook = () => {
        const getUserBaseData = useCustomInstance<UserBaseData>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUserBaseData(
          {url: `/api/${ownerId}/users/${id}`, method: 'GET', signal
    },
          options);
        }, [getUserBaseData])
      }
    

export const getGetUserBaseDataQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/users/${id}`] as const;
    }

    
export const useGetUserBaseDataQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBaseDataQueryKey(ownerId,id);

  const getUserBaseData =  useGetUserBaseDataHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>> = ({ signal }) => getUserBaseData(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserBaseDataQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>>
export type GetUserBaseDataQueryError = ErrorPayload


export function useGetUserBaseData<TData = Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserBaseData<TData = Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserBaseData<TData = Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUserBaseData<TData = Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserBaseDataHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUserBaseDataQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useDeleteWorkplaceByIdHook = () => {
        const deleteWorkplaceById = useCustomInstance<Workplace>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteWorkplaceById(
          {url: `/api/${ownerId}/workplaces/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteWorkplaceById])
      }
    


export const useDeleteWorkplaceByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteWorkplaceByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteWorkplaceByIdHook>>>, TError,{ownerId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteWorkplaceById =  useDeleteWorkplaceByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteWorkplaceByIdHook>>>, {ownerId: string;id: string}> = (props) => {
          const {ownerId,id} = props ?? {};

          return  deleteWorkplaceById(ownerId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkplaceByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteWorkplaceByIdHook>>>>
    
    export type DeleteWorkplaceByIdMutationError = ErrorPayload

    export const useDeleteWorkplaceById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteWorkplaceByIdHook>>>, TError,{ownerId: string;id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteWorkplaceByIdHook>>>,
        TError,
        {ownerId: string;id: string},
        TContext
      > => {

      const mutationOptions = useDeleteWorkplaceByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateWorkplaceByIdHook = () => {
        const updateWorkplaceById = useCustomInstance<Workplace>();

        return useCallback((
    ownerId: string,
    id: string,
    updateWorkplace: UpdateWorkplace,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateWorkplaceById(
          {url: `/api/${ownerId}/workplaces/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkplace
    },
          options);
        }, [updateWorkplaceById])
      }
    


export const useUpdateWorkplaceByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateWorkplaceByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateWorkplace}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateWorkplaceByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateWorkplace}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateWorkplaceById =  useUpdateWorkplaceByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateWorkplaceByIdHook>>>, {ownerId: string;id: string;data: UpdateWorkplace}> = (props) => {
          const {ownerId,id,data} = props ?? {};

          return  updateWorkplaceById(ownerId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkplaceByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateWorkplaceByIdHook>>>>
    export type UpdateWorkplaceByIdMutationBody = UpdateWorkplace
    export type UpdateWorkplaceByIdMutationError = ErrorPayload

    export const useUpdateWorkplaceById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateWorkplaceByIdHook>>>, TError,{ownerId: string;id: string;data: UpdateWorkplace}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateWorkplaceByIdHook>>>,
        TError,
        {ownerId: string;id: string;data: UpdateWorkplace},
        TContext
      > => {

      const mutationOptions = useUpdateWorkplaceByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetWorkplaceByIdHook = () => {
        const getWorkplaceById = useCustomInstance<WorkplaceWithRelations>();

        return useCallback((
    ownerId: string,
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getWorkplaceById(
          {url: `/api/${ownerId}/workplaces/${id}`, method: 'GET', signal
    },
          options);
        }, [getWorkplaceById])
      }
    

export const getGetWorkplaceByIdQueryKey = (ownerId: string,
    id: string,) => {
    return [`/api/${ownerId}/workplaces/${id}`] as const;
    }

    
export const useGetWorkplaceByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError = ErrorPayload>(ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkplaceByIdQueryKey(ownerId,id);

  const getWorkplaceById =  useGetWorkplaceByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>> = ({ signal }) => getWorkplaceById(ownerId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkplaceByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>>
export type GetWorkplaceByIdQueryError = ErrorPayload


export function useGetWorkplaceById<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWorkplaceById<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWorkplaceById<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetWorkplaceById<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError = ErrorPayload>(
 ownerId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplaceByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetWorkplaceByIdQueryOptions(ownerId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetNearestWorkplacesHook = () => {
        const getNearestWorkplaces = useCustomInstance<NearestCoordinatesResponse>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getNearestWorkplaces(
          {url: `/api/${ownerId}/workplaces/nearest`, method: 'GET', signal
    },
          options);
        }, [getNearestWorkplaces])
      }
    

export const getGetNearestWorkplacesQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/workplaces/nearest`] as const;
    }

    
export const useGetNearestWorkplacesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNearestWorkplacesQueryKey(ownerId);

  const getNearestWorkplaces =  useGetNearestWorkplacesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>> = ({ signal }) => getNearestWorkplaces(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNearestWorkplacesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>>
export type GetNearestWorkplacesQueryError = ErrorPayload


export function useGetNearestWorkplaces<TData = Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetNearestWorkplaces<TData = Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetNearestWorkplaces<TData = Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetNearestWorkplaces<TData = Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNearestWorkplacesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetNearestWorkplacesQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostWorkplaceHook = () => {
        const postWorkplace = useCustomInstance<Workplace>();

        return useCallback((
    ownerId: string,
    createWorkplace: CreateWorkplace,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postWorkplace(
          {url: `/api/${ownerId}/workplaces`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorkplace
    },
          options);
        }, [postWorkplace])
      }
    


export const usePostWorkplaceMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkplaceHook>>>, TError,{ownerId: string;data: CreateWorkplace}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkplaceHook>>>, TError,{ownerId: string;data: CreateWorkplace}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postWorkplace =  usePostWorkplaceHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostWorkplaceHook>>>, {ownerId: string;data: CreateWorkplace}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postWorkplace(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWorkplaceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostWorkplaceHook>>>>
    export type PostWorkplaceMutationBody = CreateWorkplace
    export type PostWorkplaceMutationError = ErrorPayload

    export const usePostWorkplace = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkplaceHook>>>, TError,{ownerId: string;data: CreateWorkplace}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostWorkplaceHook>>>,
        TError,
        {ownerId: string;data: CreateWorkplace},
        TContext
      > => {

      const mutationOptions = usePostWorkplaceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetWorkplacesHook = () => {
        const getWorkplaces = useCustomInstance<WorkplaceWithRelations[]>();

        return useCallback((
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getWorkplaces(
          {url: `/api/${ownerId}/workplaces`, method: 'GET', signal
    },
          options);
        }, [getWorkplaces])
      }
    

export const getGetWorkplacesQueryKey = (ownerId: string,) => {
    return [`/api/${ownerId}/workplaces`] as const;
    }

    
export const useGetWorkplacesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError = ErrorPayload>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkplacesQueryKey(ownerId);

  const getWorkplaces =  useGetWorkplacesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>> = ({ signal }) => getWorkplaces(ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkplacesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>>
export type GetWorkplacesQueryError = ErrorPayload


export function useGetWorkplaces<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError = ErrorPayload>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWorkplaces<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWorkplaces<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetWorkplaces<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError = ErrorPayload>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkplacesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetWorkplacesQueryOptions(ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetDataForWorkplaceTableHook = () => {
        const getDataForWorkplaceTable = useCustomInstance<WorkplaceTableResponse>();

        return useCallback((
    ownerId: string,
    params?: GetDataForWorkplaceTableParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getDataForWorkplaceTable(
          {url: `/api/${ownerId}/workplaces/table`, method: 'GET',
        params, signal
    },
          options);
        }, [getDataForWorkplaceTable])
      }
    

export const getGetDataForWorkplaceTableQueryKey = (ownerId: string,
    params?: GetDataForWorkplaceTableParams,) => {
    return [`/api/${ownerId}/workplaces/table`, ...(params ? [params]: [])] as const;
    }

    
export const useGetDataForWorkplaceTableQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError = ErrorPayload>(ownerId: string,
    params?: GetDataForWorkplaceTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataForWorkplaceTableQueryKey(ownerId,params);

  const getDataForWorkplaceTable =  useGetDataForWorkplaceTableHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>> = ({ signal }) => getDataForWorkplaceTable(ownerId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDataForWorkplaceTableQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>>
export type GetDataForWorkplaceTableQueryError = ErrorPayload


export function useGetDataForWorkplaceTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params: undefined |  GetDataForWorkplaceTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDataForWorkplaceTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetDataForWorkplaceTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetDataForWorkplaceTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetDataForWorkplaceTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetDataForWorkplaceTable<TData = Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError = ErrorPayload>(
 ownerId: string,
    params?: GetDataForWorkplaceTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDataForWorkplaceTableHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetDataForWorkplaceTableQueryOptions(ownerId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateAddressByIdHook = () => {
        const updateAddressById = useCustomInstance<Address>();

        return useCallback((
    id: string,
    updateAddress: UpdateAddress,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateAddressById(
          {url: `/api/addresses/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAddress
    },
          options);
        }, [updateAddressById])
      }
    


export const useUpdateAddressByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAddressByIdHook>>>, TError,{id: string;data: UpdateAddress}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAddressByIdHook>>>, TError,{id: string;data: UpdateAddress}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateAddressById =  useUpdateAddressByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateAddressByIdHook>>>, {id: string;data: UpdateAddress}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAddressById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAddressByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateAddressByIdHook>>>>
    export type UpdateAddressByIdMutationBody = UpdateAddress
    export type UpdateAddressByIdMutationError = ErrorPayload

    export const useUpdateAddressById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAddressByIdHook>>>, TError,{id: string;data: UpdateAddress}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateAddressByIdHook>>>,
        TError,
        {id: string;data: UpdateAddress},
        TContext
      > => {

      const mutationOptions = useUpdateAddressByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteAddressByIdHook = () => {
        const deleteAddressById = useCustomInstance<Address>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteAddressById(
          {url: `/api/addresses/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteAddressById])
      }
    


export const useDeleteAddressByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAddressByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAddressByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteAddressById =  useDeleteAddressByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAddressByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAddressById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddressByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAddressByIdHook>>>>
    
    export type DeleteAddressByIdMutationError = ErrorPayload

    export const useDeleteAddressById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAddressByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAddressByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteAddressByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetAddressByIdHook = () => {
        const getAddressById = useCustomInstance<Address>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getAddressById(
          {url: `/api/addresses/${id}`, method: 'GET', signal
    },
          options);
        }, [getAddressById])
      }
    

export const getGetAddressByIdQueryKey = (id: string,) => {
    return [`/api/addresses/${id}`] as const;
    }

    
export const useGetAddressByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressByIdQueryKey(id);

  const getAddressById =  useGetAddressByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>> = ({ signal }) => getAddressById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddressByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>>
export type GetAddressByIdQueryError = ErrorPayload


export function useGetAddressById<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAddressById<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAddressById<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetAddressById<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetAddressByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetAllowedAddressesTypesHook = () => {
        const getAllowedAddressesTypes = useCustomInstance<AllowedAddressesType[]>();

        return useCallback((
    params: GetAllowedAddressesTypesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getAllowedAddressesTypes(
          {url: `/api/addresses/allowedAddressTypes`, method: 'GET',
        params, signal
    },
          options);
        }, [getAllowedAddressesTypes])
      }
    

export const getGetAllowedAddressesTypesQueryKey = (params: GetAllowedAddressesTypesParams,) => {
    return [`/api/addresses/allowedAddressTypes`, ...(params ? [params]: [])] as const;
    }

    
export const useGetAllowedAddressesTypesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError = ErrorPayload>(params: GetAllowedAddressesTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowedAddressesTypesQueryKey(params);

  const getAllowedAddressesTypes =  useGetAllowedAddressesTypesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>> = ({ signal }) => getAllowedAddressesTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllowedAddressesTypesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>>
export type GetAllowedAddressesTypesQueryError = ErrorPayload


export function useGetAllowedAddressesTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError = ErrorPayload>(
 params: GetAllowedAddressesTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAllowedAddressesTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError = ErrorPayload>(
 params: GetAllowedAddressesTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAllowedAddressesTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError = ErrorPayload>(
 params: GetAllowedAddressesTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetAllowedAddressesTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError = ErrorPayload>(
 params: GetAllowedAddressesTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllowedAddressesTypesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetAllowedAddressesTypesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostAddressHook = () => {
        const postAddress = useCustomInstance<Address>();

        return useCallback((
    createAddress: CreateAddress,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postAddress(
          {url: `/api/addresses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAddress
    },
          options);
        }, [postAddress])
      }
    


export const usePostAddressMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAddressHook>>>, TError,{data: CreateAddress}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAddressHook>>>, TError,{data: CreateAddress}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postAddress =  usePostAddressHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostAddressHook>>>, {data: CreateAddress}> = (props) => {
          const {data} = props ?? {};

          return  postAddress(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddressMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostAddressHook>>>>
    export type PostAddressMutationBody = CreateAddress
    export type PostAddressMutationError = ErrorPayload

    export const usePostAddress = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAddressHook>>>, TError,{data: CreateAddress}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostAddressHook>>>,
        TError,
        {data: CreateAddress},
        TContext
      > => {

      const mutationOptions = usePostAddressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetAddressesHook = () => {
        const getAddresses = useCustomInstance<Address[]>();

        return useCallback((
    params?: GetAddressesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getAddresses(
          {url: `/api/addresses`, method: 'GET',
        params, signal
    },
          options);
        }, [getAddresses])
      }
    

export const getGetAddressesQueryKey = (params?: GetAddressesParams,) => {
    return [`/api/addresses`, ...(params ? [params]: [])] as const;
    }

    
export const useGetAddressesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError = ErrorPayload>(params?: GetAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesQueryKey(params);

  const getAddresses =  useGetAddressesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>> = ({ signal }) => getAddresses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddressesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>>
export type GetAddressesQueryError = ErrorPayload


export function useGetAddresses<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError = ErrorPayload>(
 params: undefined |  GetAddressesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAddresses<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError = ErrorPayload>(
 params?: GetAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAddresses<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError = ErrorPayload>(
 params?: GetAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetAddresses<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError = ErrorPayload>(
 params?: GetAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetAddressesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useCheckAdminAccessHook = () => {
        const checkAdminAccess = useCustomInstance<CheckAdminAccessResponse>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return checkAdminAccess(
          {url: `/api/admin/check-access`, method: 'GET', signal
    },
          options);
        }, [checkAdminAccess])
      }
    

export const getCheckAdminAccessQueryKey = () => {
    return [`/api/admin/check-access`] as const;
    }

    
export const useCheckAdminAccessQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckAdminAccessQueryKey();

  const checkAdminAccess =  useCheckAdminAccessHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>> = ({ signal }) => checkAdminAccess(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckAdminAccessQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>>
export type CheckAdminAccessQueryError = ErrorPayload


export function useCheckAdminAccess<TData = Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCheckAdminAccess<TData = Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCheckAdminAccess<TData = Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useCheckAdminAccess<TData = Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckAdminAccessHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useCheckAdminAccessQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUploadEcomailContactsHook = () => {
        const uploadEcomailContacts = useCustomInstance<EcomailUploadResponse>();

        return useCallback((
    ecomailUpload: EcomailUpload,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return uploadEcomailContacts(
          {url: `/api/admin/ecomail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ecomailUpload
    },
          options);
        }, [uploadEcomailContacts])
      }
    


export const useUploadEcomailContactsMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUploadEcomailContactsHook>>>, TError,{data: EcomailUpload}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUploadEcomailContactsHook>>>, TError,{data: EcomailUpload}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const uploadEcomailContacts =  useUploadEcomailContactsHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUploadEcomailContactsHook>>>, {data: EcomailUpload}> = (props) => {
          const {data} = props ?? {};

          return  uploadEcomailContacts(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadEcomailContactsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUploadEcomailContactsHook>>>>
    export type UploadEcomailContactsMutationBody = EcomailUpload
    export type UploadEcomailContactsMutationError = ErrorPayload

    export const useUploadEcomailContacts = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUploadEcomailContactsHook>>>, TError,{data: EcomailUpload}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUploadEcomailContactsHook>>>,
        TError,
        {data: EcomailUpload},
        TContext
      > => {

      const mutationOptions = useUploadEcomailContactsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateFeatureFlagsHook = () => {
        const updateFeatureFlags = useCustomInstance<FeatureFlagsResponse>();

        return useCallback((
    featureFlag: FeatureFlag,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateFeatureFlags(
          {url: `/api/admin/features`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: featureFlag
    },
          options);
        }, [updateFeatureFlags])
      }
    


export const useUpdateFeatureFlagsMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateFeatureFlagsHook>>>, TError,{data: FeatureFlag}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateFeatureFlagsHook>>>, TError,{data: FeatureFlag}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateFeatureFlags =  useUpdateFeatureFlagsHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateFeatureFlagsHook>>>, {data: FeatureFlag}> = (props) => {
          const {data} = props ?? {};

          return  updateFeatureFlags(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFeatureFlagsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateFeatureFlagsHook>>>>
    export type UpdateFeatureFlagsMutationBody = FeatureFlag
    export type UpdateFeatureFlagsMutationError = ErrorPayload

    export const useUpdateFeatureFlags = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateFeatureFlagsHook>>>, TError,{data: FeatureFlag}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateFeatureFlagsHook>>>,
        TError,
        {data: FeatureFlag},
        TContext
      > => {

      const mutationOptions = useUpdateFeatureFlagsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetFeatureFlagsHook = () => {
        const getFeatureFlags = useCustomInstance<FeatureFlagsResponse>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getFeatureFlags(
          {url: `/api/admin/features`, method: 'GET', signal
    },
          options);
        }, [getFeatureFlags])
      }
    

export const getGetFeatureFlagsQueryKey = () => {
    return [`/api/admin/features`] as const;
    }

    
export const useGetFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeatureFlagsQueryKey();

  const getFeatureFlags =  useGetFeatureFlagsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>> = ({ signal }) => getFeatureFlags(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>>
export type GetFeatureFlagsQueryError = ErrorPayload


export function useGetFeatureFlags<TData = Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetFeatureFlags<TData = Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetFeatureFlags<TData = Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetFeatureFlags<TData = Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFeatureFlagsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useCreateOrUpdateGlobalSettingHook = () => {
        const createOrUpdateGlobalSetting = useCustomInstance<AdminOperationResponse>();

        return useCallback((
    createGlobalSetting: CreateGlobalSetting,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return createOrUpdateGlobalSetting(
          {url: `/api/admin/global-settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGlobalSetting
    },
          options);
        }, [createOrUpdateGlobalSetting])
      }
    


export const useCreateOrUpdateGlobalSettingMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrUpdateGlobalSettingHook>>>, TError,{data: CreateGlobalSetting}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrUpdateGlobalSettingHook>>>, TError,{data: CreateGlobalSetting}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const createOrUpdateGlobalSetting =  useCreateOrUpdateGlobalSettingHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateOrUpdateGlobalSettingHook>>>, {data: CreateGlobalSetting}> = (props) => {
          const {data} = props ?? {};

          return  createOrUpdateGlobalSetting(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOrUpdateGlobalSettingMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateOrUpdateGlobalSettingHook>>>>
    export type CreateOrUpdateGlobalSettingMutationBody = CreateGlobalSetting
    export type CreateOrUpdateGlobalSettingMutationError = ErrorPayload

    export const useCreateOrUpdateGlobalSetting = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrUpdateGlobalSettingHook>>>, TError,{data: CreateGlobalSetting}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateOrUpdateGlobalSettingHook>>>,
        TError,
        {data: CreateGlobalSetting},
        TContext
      > => {

      const mutationOptions = useCreateOrUpdateGlobalSettingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetGlobalSettingsHook = () => {
        const getGlobalSettings = useCustomInstance<GlobalSetting[]>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getGlobalSettings(
          {url: `/api/globalSettings`, method: 'GET', signal
    },
          options);
        }, [getGlobalSettings])
      }
    

export const getGetGlobalSettingsQueryKey = () => {
    return [`/api/globalSettings`] as const;
    }

    
export const useGetGlobalSettingsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGlobalSettingsQueryKey();

  const getGlobalSettings =  useGetGlobalSettingsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>> = ({ signal }) => getGlobalSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGlobalSettingsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>>
export type GetGlobalSettingsQueryError = ErrorPayload


export function useGetGlobalSettings<TData = Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGlobalSettings<TData = Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGlobalSettings<TData = Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetGlobalSettings<TData = Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGlobalSettingsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetGlobalSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useDeleteGlobalSettingHook = () => {
        const deleteGlobalSetting = useCustomInstance<AdminOperationResponse>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteGlobalSetting(
          {url: `/api/admin/global-settings`, method: 'DELETE'
    },
          options);
        }, [deleteGlobalSetting])
      }
    


export const useDeleteGlobalSettingMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteGlobalSettingHook>>>, TError,void, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteGlobalSettingHook>>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteGlobalSetting =  useDeleteGlobalSettingHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteGlobalSettingHook>>>, void> = () => {
          

          return  deleteGlobalSetting(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGlobalSettingMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteGlobalSettingHook>>>>
    
    export type DeleteGlobalSettingMutationError = ErrorPayload

    export const useDeleteGlobalSetting = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteGlobalSettingHook>>>, TError,void, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteGlobalSettingHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = useDeleteGlobalSettingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateOwnerDataHook = () => {
        const updateOwnerData = useCustomInstance<AdminOperationResponse>();

        return useCallback((
    ownerUpdate: OwnerUpdate,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateOwnerData(
          {url: `/api/admin/owners`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ownerUpdate
    },
          options);
        }, [updateOwnerData])
      }
    


export const useUpdateOwnerDataMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerDataHook>>>, TError,{data: OwnerUpdate}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerDataHook>>>, TError,{data: OwnerUpdate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateOwnerData =  useUpdateOwnerDataHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerDataHook>>>, {data: OwnerUpdate}> = (props) => {
          const {data} = props ?? {};

          return  updateOwnerData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerDataMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerDataHook>>>>
    export type UpdateOwnerDataMutationBody = OwnerUpdate
    export type UpdateOwnerDataMutationError = ErrorPayload

    export const useUpdateOwnerData = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerDataHook>>>, TError,{data: OwnerUpdate}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateOwnerDataHook>>>,
        TError,
        {data: OwnerUpdate},
        TContext
      > => {

      const mutationOptions = useUpdateOwnerDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetOwnersHook = () => {
        const getOwners = useCustomInstance<AdminOperationResponse>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getOwners(
          {url: `/api/admin/owners`, method: 'GET', signal
    },
          options);
        }, [getOwners])
      }
    

export const getGetOwnersQueryKey = () => {
    return [`/api/admin/owners`] as const;
    }

    
export const useGetOwnersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnersQueryKey();

  const getOwners =  useGetOwnersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>> = ({ signal }) => getOwners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>>
export type GetOwnersQueryError = ErrorPayload


export function useGetOwners<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwners<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwners<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetOwners<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetOwnersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostAiChatHook = () => {
        const postAiChat = useCustomInstance<Payload>();

        return useCallback((
    ownerId: string,
    transformMessages: TransformMessages,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postAiChat(
          {url: `/api/ai/chat/${ownerId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transformMessages
    },
          options);
        }, [postAiChat])
      }
    


export const usePostAiChatMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAiChatHook>>>, TError,{ownerId: string;data: TransformMessages}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAiChatHook>>>, TError,{ownerId: string;data: TransformMessages}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postAiChat =  usePostAiChatHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostAiChatHook>>>, {ownerId: string;data: TransformMessages}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  postAiChat(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAiChatMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostAiChatHook>>>>
    export type PostAiChatMutationBody = TransformMessages
    export type PostAiChatMutationError = ErrorPayload

    export const usePostAiChat = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAiChatHook>>>, TError,{ownerId: string;data: TransformMessages}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostAiChatHook>>>,
        TError,
        {ownerId: string;data: TransformMessages},
        TContext
      > => {

      const mutationOptions = usePostAiChatMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostAresDataHook = () => {
        const postAresData = useCustomInstance<AresResponse>();

        return useCallback((
    icoRequest: IcoRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postAresData(
          {url: `/api/ares`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: icoRequest
    },
          options);
        }, [postAresData])
      }
    


export const usePostAresDataMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAresDataHook>>>, TError,{data: IcoRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAresDataHook>>>, TError,{data: IcoRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postAresData =  usePostAresDataHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostAresDataHook>>>, {data: IcoRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAresData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAresDataMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostAresDataHook>>>>
    export type PostAresDataMutationBody = IcoRequest
    export type PostAresDataMutationError = ErrorPayload

    export const usePostAresData = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAresDataHook>>>, TError,{data: IcoRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostAresDataHook>>>,
        TError,
        {data: IcoRequest},
        TContext
      > => {

      const mutationOptions = usePostAresDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteAttachmentHook = () => {
        const deleteAttachment = useCustomInstance<DeleteAttachmentResponse>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteAttachment(
          {url: `/api/attachments/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteAttachment])
      }
    


export const useDeleteAttachmentMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAttachmentHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAttachmentHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteAttachment =  useDeleteAttachmentHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAttachmentHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAttachment(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttachmentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAttachmentHook>>>>
    
    export type DeleteAttachmentMutationError = ErrorPayload

    export const useDeleteAttachment = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAttachmentHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAttachmentHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostAttachmentHook = () => {
        const postAttachment = useCustomInstance<CreateAttachmentResponse>();

        return useCallback((
    createAttachmentServer: CreateAttachmentServer,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postAttachment(
          {url: `/api/attachments`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: createAttachmentServer
    },
          options);
        }, [postAttachment])
      }
    


export const usePostAttachmentMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAttachmentHook>>>, TError,{data: CreateAttachmentServer}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAttachmentHook>>>, TError,{data: CreateAttachmentServer}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postAttachment =  usePostAttachmentHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostAttachmentHook>>>, {data: CreateAttachmentServer}> = (props) => {
          const {data} = props ?? {};

          return  postAttachment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAttachmentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostAttachmentHook>>>>
    export type PostAttachmentMutationBody = CreateAttachmentServer
    export type PostAttachmentMutationError = ErrorPayload

    export const usePostAttachment = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAttachmentHook>>>, TError,{data: CreateAttachmentServer}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostAttachmentHook>>>,
        TError,
        {data: CreateAttachmentServer},
        TContext
      > => {

      const mutationOptions = usePostAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostProfileAvatarHook = () => {
        const postProfileAvatar = useCustomInstance<UploadAvatarResponse>();

        return useCallback((
    uploadAvatar: UploadAvatar,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postProfileAvatar(
          {url: `/api/avatar/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: uploadAvatar
    },
          options);
        }, [postProfileAvatar])
      }
    


export const usePostProfileAvatarMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileAvatarHook>>>, TError,{data: UploadAvatar}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileAvatarHook>>>, TError,{data: UploadAvatar}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postProfileAvatar =  usePostProfileAvatarHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostProfileAvatarHook>>>, {data: UploadAvatar}> = (props) => {
          const {data} = props ?? {};

          return  postProfileAvatar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProfileAvatarMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostProfileAvatarHook>>>>
    export type PostProfileAvatarMutationBody = UploadAvatar
    export type PostProfileAvatarMutationError = ErrorPayload

    export const usePostProfileAvatar = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileAvatarHook>>>, TError,{data: UploadAvatar}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostProfileAvatarHook>>>,
        TError,
        {data: UploadAvatar},
        TContext
      > => {

      const mutationOptions = usePostProfileAvatarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateBankAccountByIdHook = () => {
        const updateBankAccountById = useCustomInstance<BankAccount>();

        return useCallback((
    id: string,
    updateBankAccount: UpdateBankAccount,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateBankAccountById(
          {url: `/api/bankAccount/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBankAccount
    },
          options);
        }, [updateBankAccountById])
      }
    


export const useUpdateBankAccountByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateBankAccountByIdHook>>>, TError,{id: string;data: UpdateBankAccount}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateBankAccountByIdHook>>>, TError,{id: string;data: UpdateBankAccount}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateBankAccountById =  useUpdateBankAccountByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateBankAccountByIdHook>>>, {id: string;data: UpdateBankAccount}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBankAccountById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBankAccountByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateBankAccountByIdHook>>>>
    export type UpdateBankAccountByIdMutationBody = UpdateBankAccount
    export type UpdateBankAccountByIdMutationError = ErrorPayload

    export const useUpdateBankAccountById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateBankAccountByIdHook>>>, TError,{id: string;data: UpdateBankAccount}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateBankAccountByIdHook>>>,
        TError,
        {id: string;data: UpdateBankAccount},
        TContext
      > => {

      const mutationOptions = useUpdateBankAccountByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteBankAccountByIdHook = () => {
        const deleteBankAccountById = useCustomInstance<BankAccount>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteBankAccountById(
          {url: `/api/bankAccount/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteBankAccountById])
      }
    


export const useDeleteBankAccountByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteBankAccountByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteBankAccountByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteBankAccountById =  useDeleteBankAccountByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteBankAccountByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBankAccountById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBankAccountByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteBankAccountByIdHook>>>>
    
    export type DeleteBankAccountByIdMutationError = ErrorPayload

    export const useDeleteBankAccountById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteBankAccountByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteBankAccountByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteBankAccountByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetbankAccountByIdHook = () => {
        const getbankAccountById = useCustomInstance<BankAccount>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getbankAccountById(
          {url: `/api/bankAccount/${id}`, method: 'GET', signal
    },
          options);
        }, [getbankAccountById])
      }
    

export const getGetbankAccountByIdQueryKey = (id: string,) => {
    return [`/api/bankAccount/${id}`] as const;
    }

    
export const useGetbankAccountByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetbankAccountByIdQueryKey(id);

  const getbankAccountById =  useGetbankAccountByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>> = ({ signal }) => getbankAccountById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetbankAccountByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>>
export type GetbankAccountByIdQueryError = ErrorPayload


export function useGetbankAccountById<TData = Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetbankAccountById<TData = Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetbankAccountById<TData = Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetbankAccountById<TData = Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetbankAccountByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetbankAccountByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostBankAccountHook = () => {
        const postBankAccount = useCustomInstance<BankAccount>();

        return useCallback((
    createBankAccount: CreateBankAccount,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postBankAccount(
          {url: `/api/bankAccount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBankAccount
    },
          options);
        }, [postBankAccount])
      }
    


export const usePostBankAccountMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostBankAccountHook>>>, TError,{data: CreateBankAccount}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostBankAccountHook>>>, TError,{data: CreateBankAccount}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postBankAccount =  usePostBankAccountHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostBankAccountHook>>>, {data: CreateBankAccount}> = (props) => {
          const {data} = props ?? {};

          return  postBankAccount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBankAccountMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostBankAccountHook>>>>
    export type PostBankAccountMutationBody = CreateBankAccount
    export type PostBankAccountMutationError = ErrorPayload

    export const usePostBankAccount = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostBankAccountHook>>>, TError,{data: CreateBankAccount}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostBankAccountHook>>>,
        TError,
        {data: CreateBankAccount},
        TContext
      > => {

      const mutationOptions = usePostBankAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetBankAccountsHook = () => {
        const getBankAccounts = useCustomInstance<BankAccount[]>();

        return useCallback((
    params: GetBankAccountsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getBankAccounts(
          {url: `/api/bankAccount`, method: 'GET',
        params, signal
    },
          options);
        }, [getBankAccounts])
      }
    

export const getGetBankAccountsQueryKey = (params: GetBankAccountsParams,) => {
    return [`/api/bankAccount`, ...(params ? [params]: [])] as const;
    }

    
export const useGetBankAccountsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError = ErrorPayload>(params: GetBankAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsQueryKey(params);

  const getBankAccounts =  useGetBankAccountsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>> = ({ signal }) => getBankAccounts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBankAccountsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>>
export type GetBankAccountsQueryError = ErrorPayload


export function useGetBankAccounts<TData = Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError = ErrorPayload>(
 params: GetBankAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetBankAccounts<TData = Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError = ErrorPayload>(
 params: GetBankAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetBankAccounts<TData = Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError = ErrorPayload>(
 params: GetBankAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetBankAccounts<TData = Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError = ErrorPayload>(
 params: GetBankAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBankAccountsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetBankAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateContactPersonByIdHook = () => {
        const updateContactPersonById = useCustomInstance<ContactPerson>();

        return useCallback((
    id: string,
    updateContactPerson: UpdateContactPerson,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateContactPersonById(
          {url: `/api/contactPerson/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateContactPerson
    },
          options);
        }, [updateContactPersonById])
      }
    


export const useUpdateContactPersonByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateContactPersonByIdHook>>>, TError,{id: string;data: UpdateContactPerson}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateContactPersonByIdHook>>>, TError,{id: string;data: UpdateContactPerson}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateContactPersonById =  useUpdateContactPersonByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateContactPersonByIdHook>>>, {id: string;data: UpdateContactPerson}> = (props) => {
          const {id,data} = props ?? {};

          return  updateContactPersonById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactPersonByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateContactPersonByIdHook>>>>
    export type UpdateContactPersonByIdMutationBody = UpdateContactPerson
    export type UpdateContactPersonByIdMutationError = ErrorPayload

    export const useUpdateContactPersonById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateContactPersonByIdHook>>>, TError,{id: string;data: UpdateContactPerson}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateContactPersonByIdHook>>>,
        TError,
        {id: string;data: UpdateContactPerson},
        TContext
      > => {

      const mutationOptions = useUpdateContactPersonByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteContactPersonByIdHook = () => {
        const deleteContactPersonById = useCustomInstance<ContactPerson>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteContactPersonById(
          {url: `/api/contactPerson/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteContactPersonById])
      }
    


export const useDeleteContactPersonByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteContactPersonByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteContactPersonByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteContactPersonById =  useDeleteContactPersonByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteContactPersonByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteContactPersonById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactPersonByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteContactPersonByIdHook>>>>
    
    export type DeleteContactPersonByIdMutationError = ErrorPayload

    export const useDeleteContactPersonById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteContactPersonByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteContactPersonByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteContactPersonByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetContactPersonByIdHook = () => {
        const getContactPersonById = useCustomInstance<ContactPerson>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getContactPersonById(
          {url: `/api/contactPerson/${id}`, method: 'GET', signal
    },
          options);
        }, [getContactPersonById])
      }
    

export const getGetContactPersonByIdQueryKey = (id: string,) => {
    return [`/api/contactPerson/${id}`] as const;
    }

    
export const useGetContactPersonByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactPersonByIdQueryKey(id);

  const getContactPersonById =  useGetContactPersonByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>> = ({ signal }) => getContactPersonById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetContactPersonByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>>
export type GetContactPersonByIdQueryError = ErrorPayload


export function useGetContactPersonById<TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetContactPersonById<TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetContactPersonById<TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetContactPersonById<TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetContactPersonByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostContactPersonHook = () => {
        const postContactPerson = useCustomInstance<ContactPerson>();

        return useCallback((
    createContactPerson: CreateContactPerson,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postContactPerson(
          {url: `/api/contactPerson`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContactPerson
    },
          options);
        }, [postContactPerson])
      }
    


export const usePostContactPersonMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostContactPersonHook>>>, TError,{data: CreateContactPerson}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostContactPersonHook>>>, TError,{data: CreateContactPerson}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postContactPerson =  usePostContactPersonHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostContactPersonHook>>>, {data: CreateContactPerson}> = (props) => {
          const {data} = props ?? {};

          return  postContactPerson(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactPersonMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostContactPersonHook>>>>
    export type PostContactPersonMutationBody = CreateContactPerson
    export type PostContactPersonMutationError = ErrorPayload

    export const usePostContactPerson = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostContactPersonHook>>>, TError,{data: CreateContactPerson}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostContactPersonHook>>>,
        TError,
        {data: CreateContactPerson},
        TContext
      > => {

      const mutationOptions = usePostContactPersonMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetContactPersonsHook = () => {
        const getContactPersons = useCustomInstance<ContactPerson[]>();

        return useCallback((
    params: GetContactPersonsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getContactPersons(
          {url: `/api/contactPerson`, method: 'GET',
        params, signal
    },
          options);
        }, [getContactPersons])
      }
    

export const getGetContactPersonsQueryKey = (params: GetContactPersonsParams,) => {
    return [`/api/contactPerson`, ...(params ? [params]: [])] as const;
    }

    
export const useGetContactPersonsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError = ErrorPayload>(params: GetContactPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactPersonsQueryKey(params);

  const getContactPersons =  useGetContactPersonsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>> = ({ signal }) => getContactPersons(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetContactPersonsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>>
export type GetContactPersonsQueryError = ErrorPayload


export function useGetContactPersons<TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError = ErrorPayload>(
 params: GetContactPersonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetContactPersons<TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError = ErrorPayload>(
 params: GetContactPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetContactPersons<TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError = ErrorPayload>(
 params: GetContactPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetContactPersons<TData = Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError = ErrorPayload>(
 params: GetContactPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetContactPersonsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetContactPersonsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useMarkAllGroupedNotificationsReadHook = () => {
        const markAllGroupedNotificationsRead = useCustomInstance<CountPayload>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return markAllGroupedNotificationsRead(
          {url: `/api/groupedNotifications/markAllRead`, method: 'GET', signal
    },
          options);
        }, [markAllGroupedNotificationsRead])
      }
    

export const getMarkAllGroupedNotificationsReadQueryKey = () => {
    return [`/api/groupedNotifications/markAllRead`] as const;
    }

    
export const useMarkAllGroupedNotificationsReadQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarkAllGroupedNotificationsReadQueryKey();

  const markAllGroupedNotificationsRead =  useMarkAllGroupedNotificationsReadHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>> = ({ signal }) => markAllGroupedNotificationsRead(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type MarkAllGroupedNotificationsReadQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>>
export type MarkAllGroupedNotificationsReadQueryError = ErrorPayload


export function useMarkAllGroupedNotificationsRead<TData = Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useMarkAllGroupedNotificationsRead<TData = Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useMarkAllGroupedNotificationsRead<TData = Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useMarkAllGroupedNotificationsRead<TData = Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMarkAllGroupedNotificationsReadHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useMarkAllGroupedNotificationsReadQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetGroupedNotificationsHook = () => {
        const getGroupedNotifications = useCustomInstance<GroupedNotifications>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getGroupedNotifications(
          {url: `/api/groupedNotifications`, method: 'GET', signal
    },
          options);
        }, [getGroupedNotifications])
      }
    

export const getGetGroupedNotificationsQueryKey = () => {
    return [`/api/groupedNotifications`] as const;
    }

    
export const useGetGroupedNotificationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupedNotificationsQueryKey();

  const getGroupedNotifications =  useGetGroupedNotificationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>> = ({ signal }) => getGroupedNotifications(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGroupedNotificationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>>
export type GetGroupedNotificationsQueryError = ErrorPayload


export function useGetGroupedNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupedNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupedNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetGroupedNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGroupedNotificationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetGroupedNotificationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useResendInvitationByIdHook = () => {
        const resendInvitationById = useCustomInstance<Invitation>();

        return useCallback((
    id: string,
    updateInvitation: UpdateInvitation,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return resendInvitationById(
          {url: `/api/invitations/${id}/resend`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateInvitation
    },
          options);
        }, [resendInvitationById])
      }
    


export const useResendInvitationByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useResendInvitationByIdHook>>>, TError,{id: string;data: UpdateInvitation}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useResendInvitationByIdHook>>>, TError,{id: string;data: UpdateInvitation}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const resendInvitationById =  useResendInvitationByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useResendInvitationByIdHook>>>, {id: string;data: UpdateInvitation}> = (props) => {
          const {id,data} = props ?? {};

          return  resendInvitationById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendInvitationByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useResendInvitationByIdHook>>>>
    export type ResendInvitationByIdMutationBody = UpdateInvitation
    export type ResendInvitationByIdMutationError = ErrorPayload

    export const useResendInvitationById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useResendInvitationByIdHook>>>, TError,{id: string;data: UpdateInvitation}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useResendInvitationByIdHook>>>,
        TError,
        {id: string;data: UpdateInvitation},
        TContext
      > => {

      const mutationOptions = useResendInvitationByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateInvitationByIdHook = () => {
        const updateInvitationById = useCustomInstance<Invitation>();

        return useCallback((
    id: string,
    updateInvitation: UpdateInvitation,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateInvitationById(
          {url: `/api/invitations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateInvitation
    },
          options);
        }, [updateInvitationById])
      }
    


export const useUpdateInvitationByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateInvitationByIdHook>>>, TError,{id: string;data: UpdateInvitation}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateInvitationByIdHook>>>, TError,{id: string;data: UpdateInvitation}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateInvitationById =  useUpdateInvitationByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateInvitationByIdHook>>>, {id: string;data: UpdateInvitation}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInvitationById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvitationByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateInvitationByIdHook>>>>
    export type UpdateInvitationByIdMutationBody = UpdateInvitation
    export type UpdateInvitationByIdMutationError = ErrorPayload

    export const useUpdateInvitationById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateInvitationByIdHook>>>, TError,{id: string;data: UpdateInvitation}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateInvitationByIdHook>>>,
        TError,
        {id: string;data: UpdateInvitation},
        TContext
      > => {

      const mutationOptions = useUpdateInvitationByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteInvitationByIdHook = () => {
        const deleteInvitationById = useCustomInstance<Invitation>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteInvitationById(
          {url: `/api/invitations/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteInvitationById])
      }
    


export const useDeleteInvitationByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteInvitationByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteInvitationByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteInvitationById =  useDeleteInvitationByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteInvitationByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInvitationById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvitationByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteInvitationByIdHook>>>>
    
    export type DeleteInvitationByIdMutationError = ErrorPayload

    export const useDeleteInvitationById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteInvitationByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteInvitationByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteInvitationByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetInvitationByIdHook = () => {
        const getInvitationById = useCustomInstance<Invitation>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getInvitationById(
          {url: `/api/invitations/${id}`, method: 'GET', signal
    },
          options);
        }, [getInvitationById])
      }
    

export const getGetInvitationByIdQueryKey = (id: string,) => {
    return [`/api/invitations/${id}`] as const;
    }

    
export const useGetInvitationByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationByIdQueryKey(id);

  const getInvitationById =  useGetInvitationByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>> = ({ signal }) => getInvitationById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvitationByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>>
export type GetInvitationByIdQueryError = ErrorPayload


export function useGetInvitationById<TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetInvitationById<TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetInvitationById<TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetInvitationById<TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetInvitationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetInvitationCardHook = () => {
        const getInvitationCard = useCustomInstance<Invitation[]>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getInvitationCard(
          {url: `/api/invitations/cardInvitation`, method: 'GET', signal
    },
          options);
        }, [getInvitationCard])
      }
    

export const getGetInvitationCardQueryKey = () => {
    return [`/api/invitations/cardInvitation`] as const;
    }

    
export const useGetInvitationCardQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationCardQueryKey();

  const getInvitationCard =  useGetInvitationCardHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>> = ({ signal }) => getInvitationCard(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvitationCardQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>>
export type GetInvitationCardQueryError = ErrorPayload


export function useGetInvitationCard<TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetInvitationCard<TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetInvitationCard<TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetInvitationCard<TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationCardHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetInvitationCardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostInvitationHook = () => {
        const postInvitation = useCustomInstance<Invitation>();

        return useCallback((
    createInvitation: CreateInvitation,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postInvitation(
          {url: `/api/invitations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInvitation
    },
          options);
        }, [postInvitation])
      }
    


export const usePostInvitationMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostInvitationHook>>>, TError,{data: CreateInvitation}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostInvitationHook>>>, TError,{data: CreateInvitation}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postInvitation =  usePostInvitationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostInvitationHook>>>, {data: CreateInvitation}> = (props) => {
          const {data} = props ?? {};

          return  postInvitation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvitationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostInvitationHook>>>>
    export type PostInvitationMutationBody = CreateInvitation
    export type PostInvitationMutationError = ErrorPayload

    export const usePostInvitation = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostInvitationHook>>>, TError,{data: CreateInvitation}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostInvitationHook>>>,
        TError,
        {data: CreateInvitation},
        TContext
      > => {

      const mutationOptions = usePostInvitationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetLoggedUserHook = () => {
        const getLoggedUser = useCustomInstance<User>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getLoggedUser(
          {url: `/api/loggedUser`, method: 'GET', signal
    },
          options);
        }, [getLoggedUser])
      }
    

export const getGetLoggedUserQueryKey = () => {
    return [`/api/loggedUser`] as const;
    }

    
export const useGetLoggedUserQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoggedUserQueryKey();

  const getLoggedUser =  useGetLoggedUserHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>> = ({ signal }) => getLoggedUser(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLoggedUserQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>>
export type GetLoggedUserQueryError = ErrorPayload


export function useGetLoggedUser<TData = Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetLoggedUser<TData = Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetLoggedUser<TData = Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetLoggedUser<TData = Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLoggedUserHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetLoggedUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateNotificationByIdHook = () => {
        const updateNotificationById = useCustomInstance<Notification>();

        return useCallback((
    id: string,
    updateNotification: UpdateNotification,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateNotificationById(
          {url: `/api/notifications/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateNotification
    },
          options);
        }, [updateNotificationById])
      }
    


export const useUpdateNotificationByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationByIdHook>>>, TError,{id: string;data: UpdateNotification}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationByIdHook>>>, TError,{id: string;data: UpdateNotification}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateNotificationById =  useUpdateNotificationByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationByIdHook>>>, {id: string;data: UpdateNotification}> = (props) => {
          const {id,data} = props ?? {};

          return  updateNotificationById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationByIdHook>>>>
    export type UpdateNotificationByIdMutationBody = UpdateNotification
    export type UpdateNotificationByIdMutationError = ErrorPayload

    export const useUpdateNotificationById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationByIdHook>>>, TError,{id: string;data: UpdateNotification}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateNotificationByIdHook>>>,
        TError,
        {id: string;data: UpdateNotification},
        TContext
      > => {

      const mutationOptions = useUpdateNotificationByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteNotificationByIdHook = () => {
        const deleteNotificationById = useCustomInstance<Notification>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteNotificationById(
          {url: `/api/notifications/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteNotificationById])
      }
    


export const useDeleteNotificationByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteNotificationByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteNotificationByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteNotificationById =  useDeleteNotificationByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteNotificationByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteNotificationById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteNotificationByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteNotificationByIdHook>>>>
    
    export type DeleteNotificationByIdMutationError = ErrorPayload

    export const useDeleteNotificationById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteNotificationByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteNotificationByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteNotificationByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetNotificationByIdHook = () => {
        const getNotificationById = useCustomInstance<Notification>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getNotificationById(
          {url: `/api/notifications/${id}`, method: 'GET', signal
    },
          options);
        }, [getNotificationById])
      }
    

export const getGetNotificationByIdQueryKey = (id: string,) => {
    return [`/api/notifications/${id}`] as const;
    }

    
export const useGetNotificationByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationByIdQueryKey(id);

  const getNotificationById =  useGetNotificationByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>> = ({ signal }) => getNotificationById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>>
export type GetNotificationByIdQueryError = ErrorPayload


export function useGetNotificationById<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetNotificationById<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetNotificationById<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetNotificationById<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetNotificationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostNotificationHook = () => {
        const postNotification = useCustomInstance<Notification>();

        return useCallback((
    createNotification: CreateNotification,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postNotification(
          {url: `/api/notifications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createNotification
    },
          options);
        }, [postNotification])
      }
    


export const usePostNotificationMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationHook>>>, TError,{data: CreateNotification}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationHook>>>, TError,{data: CreateNotification}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postNotification =  usePostNotificationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostNotificationHook>>>, {data: CreateNotification}> = (props) => {
          const {data} = props ?? {};

          return  postNotification(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostNotificationHook>>>>
    export type PostNotificationMutationBody = CreateNotification
    export type PostNotificationMutationError = ErrorPayload

    export const usePostNotification = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationHook>>>, TError,{data: CreateNotification}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostNotificationHook>>>,
        TError,
        {data: CreateNotification},
        TContext
      > => {

      const mutationOptions = usePostNotificationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetNotificationsHook = () => {
        const getNotifications = useCustomInstance<NotificationWithRelations[]>();

        return useCallback((
    params?: GetNotificationsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getNotifications(
          {url: `/api/notifications`, method: 'GET',
        params, signal
    },
          options);
        }, [getNotifications])
      }
    

export const getGetNotificationsQueryKey = (params?: GetNotificationsParams,) => {
    return [`/api/notifications`, ...(params ? [params]: [])] as const;
    }

    
export const useGetNotificationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError = ErrorPayload>(params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsQueryKey(params);

  const getNotifications =  useGetNotificationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>> = ({ signal }) => getNotifications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>>
export type GetNotificationsQueryError = ErrorPayload


export function useGetNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError = ErrorPayload>(
 params: undefined |  GetNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError = ErrorPayload>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError = ErrorPayload>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError = ErrorPayload>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateOwnerByIdHook = () => {
        const updateOwnerById = useCustomInstance<Owner>();

        return useCallback((
    id: string,
    updateOwner: UpdateOwner,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateOwnerById(
          {url: `/api/owners/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOwner
    },
          options);
        }, [updateOwnerById])
      }
    


export const useUpdateOwnerByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerByIdHook>>>, TError,{id: string;data: UpdateOwner}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerByIdHook>>>, TError,{id: string;data: UpdateOwner}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateOwnerById =  useUpdateOwnerByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerByIdHook>>>, {id: string;data: UpdateOwner}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOwnerById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerByIdHook>>>>
    export type UpdateOwnerByIdMutationBody = UpdateOwner
    export type UpdateOwnerByIdMutationError = ErrorPayload

    export const useUpdateOwnerById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOwnerByIdHook>>>, TError,{id: string;data: UpdateOwner}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateOwnerByIdHook>>>,
        TError,
        {id: string;data: UpdateOwner},
        TContext
      > => {

      const mutationOptions = useUpdateOwnerByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteOwnerByIdHook = () => {
        const deleteOwnerById = useCustomInstance<Owner>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteOwnerById(
          {url: `/api/owners/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteOwnerById])
      }
    


export const useDeleteOwnerByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOwnerByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOwnerByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteOwnerById =  useDeleteOwnerByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteOwnerByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOwnerById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOwnerByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteOwnerByIdHook>>>>
    
    export type DeleteOwnerByIdMutationError = ErrorPayload

    export const useDeleteOwnerById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOwnerByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteOwnerByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteOwnerByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetOwnerByIdHook = () => {
        const getOwnerById = useCustomInstance<Owner>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getOwnerById(
          {url: `/api/owners/${id}`, method: 'GET', signal
    },
          options);
        }, [getOwnerById])
      }
    

export const getGetOwnerByIdQueryKey = (id: string,) => {
    return [`/api/owners/${id}`] as const;
    }

    
export const useGetOwnerByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerByIdQueryKey(id);

  const getOwnerById =  useGetOwnerByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>> = ({ signal }) => getOwnerById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>>
export type GetOwnerByIdQueryError = ErrorPayload


export function useGetOwnerById<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwnerById<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwnerById<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetOwnerById<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnerByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetOwnerByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostOwnerHook = () => {
        const postOwner = useCustomInstance<Owner>();

        return useCallback((
    createOwner: CreateOwner,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postOwner(
          {url: `/api/owners`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOwner
    },
          options);
        }, [postOwner])
      }
    


export const usePostOwnerMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOwnerHook>>>, TError,{data: CreateOwner}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOwnerHook>>>, TError,{data: CreateOwner}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postOwner =  usePostOwnerHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostOwnerHook>>>, {data: CreateOwner}> = (props) => {
          const {data} = props ?? {};

          return  postOwner(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostOwnerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostOwnerHook>>>>
    export type PostOwnerMutationBody = CreateOwner
    export type PostOwnerMutationError = ErrorPayload

    export const usePostOwner = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOwnerHook>>>, TError,{data: CreateOwner}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostOwnerHook>>>,
        TError,
        {data: CreateOwner},
        TContext
      > => {

      const mutationOptions = usePostOwnerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetOwnersWithRoleByUserIdHook = () => {
        const getOwnersWithRoleByUserId = useCustomInstance<OwnerWithRoles[]>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getOwnersWithRoleByUserId(
          {url: `/api/owners`, method: 'GET', signal
    },
          options);
        }, [getOwnersWithRoleByUserId])
      }
    

export const getGetOwnersWithRoleByUserIdQueryKey = () => {
    return [`/api/owners`] as const;
    }

    
export const useGetOwnersWithRoleByUserIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnersWithRoleByUserIdQueryKey();

  const getOwnersWithRoleByUserId =  useGetOwnersWithRoleByUserIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>> = ({ signal }) => getOwnersWithRoleByUserId(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnersWithRoleByUserIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>>
export type GetOwnersWithRoleByUserIdQueryError = ErrorPayload


export function useGetOwnersWithRoleByUserId<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwnersWithRoleByUserId<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOwnersWithRoleByUserId<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetOwnersWithRoleByUserId<TData = Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOwnersWithRoleByUserIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetOwnersWithRoleByUserIdQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetQrCodeByIdAndOwnerHook = () => {
        const getQrCodeByIdAndOwner = useCustomInstance<QRCodeResponse>();

        return useCallback((
    qrId: string,
    ownerId: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getQrCodeByIdAndOwner(
          {url: `/api/qr/${qrId}/${ownerId}`, method: 'GET', signal
    },
          options);
        }, [getQrCodeByIdAndOwner])
      }
    

export const getGetQrCodeByIdAndOwnerQueryKey = (qrId: string,
    ownerId: string,) => {
    return [`/api/qr/${qrId}/${ownerId}`] as const;
    }

    
export const useGetQrCodeByIdAndOwnerQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError = ErrorPayload>(qrId: string,
    ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQrCodeByIdAndOwnerQueryKey(qrId,ownerId);

  const getQrCodeByIdAndOwner =  useGetQrCodeByIdAndOwnerHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>> = ({ signal }) => getQrCodeByIdAndOwner(qrId,ownerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(qrId && ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQrCodeByIdAndOwnerQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>>
export type GetQrCodeByIdAndOwnerQueryError = ErrorPayload


export function useGetQrCodeByIdAndOwner<TData = Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError = ErrorPayload>(
 qrId: string,
    ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetQrCodeByIdAndOwner<TData = Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError = ErrorPayload>(
 qrId: string,
    ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetQrCodeByIdAndOwner<TData = Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError = ErrorPayload>(
 qrId: string,
    ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetQrCodeByIdAndOwner<TData = Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError = ErrorPayload>(
 qrId: string,
    ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQrCodeByIdAndOwnerHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetQrCodeByIdAndOwnerQueryOptions(qrId,ownerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useConfirmQrScanHook = () => {
        const confirmQrScan = useCustomInstance<QRCodeResponse>();

        return useCallback((
    ownerId: string,
    confirmQrCodeScanRequest: ConfirmQrCodeScanRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return confirmQrScan(
          {url: `/api/qr/v2/${ownerId}/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmQrCodeScanRequest
    },
          options);
        }, [confirmQrScan])
      }
    


export const useConfirmQrScanMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useConfirmQrScanHook>>>, TError,{ownerId: string;data: ConfirmQrCodeScanRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useConfirmQrScanHook>>>, TError,{ownerId: string;data: ConfirmQrCodeScanRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const confirmQrScan =  useConfirmQrScanHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useConfirmQrScanHook>>>, {ownerId: string;data: ConfirmQrCodeScanRequest}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  confirmQrScan(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmQrScanMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useConfirmQrScanHook>>>>
    export type ConfirmQrScanMutationBody = ConfirmQrCodeScanRequest
    export type ConfirmQrScanMutationError = ErrorPayload

    export const useConfirmQrScan = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useConfirmQrScanHook>>>, TError,{ownerId: string;data: ConfirmQrCodeScanRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useConfirmQrScanHook>>>,
        TError,
        {ownerId: string;data: ConfirmQrCodeScanRequest},
        TContext
      > => {

      const mutationOptions = useConfirmQrScanMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useRegisterQrTransmitterHook = () => {
        const registerQrTransmitter = useCustomInstance<RegisterQrResponse>();

        return useCallback((
    ownerId: string,
    registerQrTransmitterRequest: RegisterQrTransmitterRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return registerQrTransmitter(
          {url: `/api/qr/v2/${ownerId}/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerQrTransmitterRequest
    },
          options);
        }, [registerQrTransmitter])
      }
    


export const useRegisterQrTransmitterMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRegisterQrTransmitterHook>>>, TError,{ownerId: string;data: RegisterQrTransmitterRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRegisterQrTransmitterHook>>>, TError,{ownerId: string;data: RegisterQrTransmitterRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const registerQrTransmitter =  useRegisterQrTransmitterHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useRegisterQrTransmitterHook>>>, {ownerId: string;data: RegisterQrTransmitterRequest}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  registerQrTransmitter(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterQrTransmitterMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRegisterQrTransmitterHook>>>>
    export type RegisterQrTransmitterMutationBody = RegisterQrTransmitterRequest
    export type RegisterQrTransmitterMutationError = ErrorPayload

    export const useRegisterQrTransmitter = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRegisterQrTransmitterHook>>>, TError,{ownerId: string;data: RegisterQrTransmitterRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useRegisterQrTransmitterHook>>>,
        TError,
        {ownerId: string;data: RegisterQrTransmitterRequest},
        TContext
      > => {

      const mutationOptions = useRegisterQrTransmitterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateRequestByIdHook = () => {
        const updateRequestById = useCustomInstance<Request>();

        return useCallback((
    id: string,
    updateRequest: UpdateRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateRequestById(
          {url: `/api/requests/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRequest
    },
          options);
        }, [updateRequestById])
      }
    


export const useUpdateRequestByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateRequestByIdHook>>>, TError,{id: string;data: UpdateRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateRequestByIdHook>>>, TError,{id: string;data: UpdateRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateRequestById =  useUpdateRequestByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateRequestByIdHook>>>, {id: string;data: UpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRequestById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRequestByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateRequestByIdHook>>>>
    export type UpdateRequestByIdMutationBody = UpdateRequest
    export type UpdateRequestByIdMutationError = ErrorPayload

    export const useUpdateRequestById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateRequestByIdHook>>>, TError,{id: string;data: UpdateRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateRequestByIdHook>>>,
        TError,
        {id: string;data: UpdateRequest},
        TContext
      > => {

      const mutationOptions = useUpdateRequestByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteRequestByIdHook = () => {
        const deleteRequestById = useCustomInstance<Request>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteRequestById(
          {url: `/api/requests/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteRequestById])
      }
    


export const useDeleteRequestByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteRequestByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteRequestByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteRequestById =  useDeleteRequestByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteRequestByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRequestById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRequestByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteRequestByIdHook>>>>
    
    export type DeleteRequestByIdMutationError = ErrorPayload

    export const useDeleteRequestById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteRequestByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteRequestByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteRequestByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetRequestByIdHook = () => {
        const getRequestById = useCustomInstance<Request>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getRequestById(
          {url: `/api/requests/${id}`, method: 'GET', signal
    },
          options);
        }, [getRequestById])
      }
    

export const getGetRequestByIdQueryKey = (id: string,) => {
    return [`/api/requests/${id}`] as const;
    }

    
export const useGetRequestByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestByIdQueryKey(id);

  const getRequestById =  useGetRequestByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>> = ({ signal }) => getRequestById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequestByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>>
export type GetRequestByIdQueryError = ErrorPayload


export function useGetRequestById<TData = Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetRequestById<TData = Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetRequestById<TData = Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetRequestById<TData = Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetRequestByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useChangeRequestStateByIdHook = () => {
        const changeRequestStateById = useCustomInstance<Payload>();

        return useCallback((
    id: string,
    changeRequestState: ChangeRequestState,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return changeRequestStateById(
          {url: `/api/requests/${id}/state`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeRequestState
    },
          options);
        }, [changeRequestStateById])
      }
    


export const useChangeRequestStateByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeRequestStateByIdHook>>>, TError,{id: string;data: ChangeRequestState}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeRequestStateByIdHook>>>, TError,{id: string;data: ChangeRequestState}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const changeRequestStateById =  useChangeRequestStateByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useChangeRequestStateByIdHook>>>, {id: string;data: ChangeRequestState}> = (props) => {
          const {id,data} = props ?? {};

          return  changeRequestStateById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeRequestStateByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useChangeRequestStateByIdHook>>>>
    export type ChangeRequestStateByIdMutationBody = ChangeRequestState
    export type ChangeRequestStateByIdMutationError = ErrorPayload

    export const useChangeRequestStateById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeRequestStateByIdHook>>>, TError,{id: string;data: ChangeRequestState}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useChangeRequestStateByIdHook>>>,
        TError,
        {id: string;data: ChangeRequestState},
        TContext
      > => {

      const mutationOptions = useChangeRequestStateByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostRequestHook = () => {
        const postRequest = useCustomInstance<Request>();

        return useCallback((
    createRequest: CreateRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postRequest(
          {url: `/api/requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRequest
    },
          options);
        }, [postRequest])
      }
    


export const usePostRequestMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostRequestHook>>>, TError,{data: CreateRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostRequestHook>>>, TError,{data: CreateRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postRequest =  usePostRequestHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostRequestHook>>>, {data: CreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  postRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRequestMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostRequestHook>>>>
    export type PostRequestMutationBody = CreateRequest
    export type PostRequestMutationError = ErrorPayload

    export const usePostRequest = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostRequestHook>>>, TError,{data: CreateRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostRequestHook>>>,
        TError,
        {data: CreateRequest},
        TContext
      > => {

      const mutationOptions = usePostRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetRequestsHook = () => {
        const getRequests = useCustomInstance<RequestWithRelations[]>();

        return useCallback((
    params?: GetRequestsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getRequests(
          {url: `/api/requests`, method: 'GET',
        params, signal
    },
          options);
        }, [getRequests])
      }
    

export const getGetRequestsQueryKey = (params?: GetRequestsParams,) => {
    return [`/api/requests`, ...(params ? [params]: [])] as const;
    }

    
export const useGetRequestsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError = ErrorPayload>(params?: GetRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsQueryKey(params);

  const getRequests =  useGetRequestsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>> = ({ signal }) => getRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequestsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>>
export type GetRequestsQueryError = ErrorPayload


export function useGetRequests<TData = Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError = ErrorPayload>(
 params: undefined |  GetRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetRequests<TData = Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError = ErrorPayload>(
 params?: GetRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetRequests<TData = Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError = ErrorPayload>(
 params?: GetRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetRequests<TData = Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError = ErrorPayload>(
 params?: GetRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRequestsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetSearchResultsHook = () => {
        const getSearchResults = useCustomInstance<Search[]>();

        return useCallback((
    params: GetSearchResultsParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getSearchResults(
          {url: `/api/search`, method: 'GET',
        params, signal
    },
          options);
        }, [getSearchResults])
      }
    

export const getGetSearchResultsQueryKey = (params: GetSearchResultsParams,) => {
    return [`/api/search`, ...(params ? [params]: [])] as const;
    }

    
export const useGetSearchResultsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError = ErrorPayload>(params: GetSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchResultsQueryKey(params);

  const getSearchResults =  useGetSearchResultsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>> = ({ signal }) => getSearchResults(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSearchResultsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>>
export type GetSearchResultsQueryError = ErrorPayload


export function useGetSearchResults<TData = Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError = ErrorPayload>(
 params: GetSearchResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetSearchResults<TData = Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError = ErrorPayload>(
 params: GetSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetSearchResults<TData = Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError = ErrorPayload>(
 params: GetSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetSearchResults<TData = Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError = ErrorPayload>(
 params: GetSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchResultsHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetSearchResultsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostSendEmailHook = () => {
        const postSendEmail = useCustomInstance<SendEmailResponse>();

        return useCallback((
    createEmail: CreateEmail,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postSendEmail(
          {url: `/api/sendEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEmail
    },
          options);
        }, [postSendEmail])
      }
    


export const usePostSendEmailMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSendEmailHook>>>, TError,{data: CreateEmail}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSendEmailHook>>>, TError,{data: CreateEmail}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postSendEmail =  usePostSendEmailHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostSendEmailHook>>>, {data: CreateEmail}> = (props) => {
          const {data} = props ?? {};

          return  postSendEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendEmailMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostSendEmailHook>>>>
    export type PostSendEmailMutationBody = CreateEmail
    export type PostSendEmailMutationError = ErrorPayload

    export const usePostSendEmail = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSendEmailHook>>>, TError,{data: CreateEmail}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostSendEmailHook>>>,
        TError,
        {data: CreateEmail},
        TContext
      > => {

      const mutationOptions = usePostSendEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostAddEmployeeToSubscriptionHook = () => {
        const postAddEmployeeToSubscription = useCustomInstance<StripeAddEmployeeResponse>();

        return useCallback((
    stripeAddEmployeeRequest: StripeAddEmployeeRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postAddEmployeeToSubscription(
          {url: `/api/stripe/addEmployeeToSubscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stripeAddEmployeeRequest
    },
          options);
        }, [postAddEmployeeToSubscription])
      }
    


export const usePostAddEmployeeToSubscriptionMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAddEmployeeToSubscriptionHook>>>, TError,{data: StripeAddEmployeeRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAddEmployeeToSubscriptionHook>>>, TError,{data: StripeAddEmployeeRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postAddEmployeeToSubscription =  usePostAddEmployeeToSubscriptionHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostAddEmployeeToSubscriptionHook>>>, {data: StripeAddEmployeeRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAddEmployeeToSubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddEmployeeToSubscriptionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostAddEmployeeToSubscriptionHook>>>>
    export type PostAddEmployeeToSubscriptionMutationBody = StripeAddEmployeeRequest
    export type PostAddEmployeeToSubscriptionMutationError = ErrorPayload

    export const usePostAddEmployeeToSubscription = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostAddEmployeeToSubscriptionHook>>>, TError,{data: StripeAddEmployeeRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostAddEmployeeToSubscriptionHook>>>,
        TError,
        {data: StripeAddEmployeeRequest},
        TContext
      > => {

      const mutationOptions = usePostAddEmployeeToSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostCreateCheckoutSessionHook = () => {
        const postCreateCheckoutSession = useCustomInstance<StripeCheckoutResponse>();

        return useCallback((
    stripeCheckoutRequest: StripeCheckoutRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postCreateCheckoutSession(
          {url: `/api/stripe/createCheckoutSession`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stripeCheckoutRequest
    },
          options);
        }, [postCreateCheckoutSession])
      }
    


export const usePostCreateCheckoutSessionMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCreateCheckoutSessionHook>>>, TError,{data: StripeCheckoutRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCreateCheckoutSessionHook>>>, TError,{data: StripeCheckoutRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postCreateCheckoutSession =  usePostCreateCheckoutSessionHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostCreateCheckoutSessionHook>>>, {data: StripeCheckoutRequest}> = (props) => {
          const {data} = props ?? {};

          return  postCreateCheckoutSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostCreateCheckoutSessionHook>>>>
    export type PostCreateCheckoutSessionMutationBody = StripeCheckoutRequest
    export type PostCreateCheckoutSessionMutationError = ErrorPayload

    export const usePostCreateCheckoutSession = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCreateCheckoutSessionHook>>>, TError,{data: StripeCheckoutRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostCreateCheckoutSessionHook>>>,
        TError,
        {data: StripeCheckoutRequest},
        TContext
      > => {

      const mutationOptions = usePostCreateCheckoutSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostCreateCustomerPortalSessionHook = () => {
        const postCreateCustomerPortalSession = useCustomInstance<StripePortalResponse>();

        return useCallback((
    stripePortalRequest: StripePortalRequest,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postCreateCustomerPortalSession(
          {url: `/api/stripe/createCustomerPortalSession`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stripePortalRequest
    },
          options);
        }, [postCreateCustomerPortalSession])
      }
    


export const usePostCreateCustomerPortalSessionMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCreateCustomerPortalSessionHook>>>, TError,{data: StripePortalRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCreateCustomerPortalSessionHook>>>, TError,{data: StripePortalRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postCreateCustomerPortalSession =  usePostCreateCustomerPortalSessionHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostCreateCustomerPortalSessionHook>>>, {data: StripePortalRequest}> = (props) => {
          const {data} = props ?? {};

          return  postCreateCustomerPortalSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateCustomerPortalSessionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostCreateCustomerPortalSessionHook>>>>
    export type PostCreateCustomerPortalSessionMutationBody = StripePortalRequest
    export type PostCreateCustomerPortalSessionMutationError = ErrorPayload

    export const usePostCreateCustomerPortalSession = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCreateCustomerPortalSessionHook>>>, TError,{data: StripePortalRequest}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostCreateCustomerPortalSessionHook>>>,
        TError,
        {data: StripePortalRequest},
        TContext
      > => {

      const mutationOptions = usePostCreateCustomerPortalSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateTaskByIdHook = () => {
        const updateTaskById = useCustomInstance<Task>();

        return useCallback((
    id: string,
    updateTask: UpdateTask,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateTaskById(
          {url: `/api/tasks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTask
    },
          options);
        }, [updateTaskById])
      }
    


export const useUpdateTaskByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTaskByIdHook>>>, TError,{id: string;data: UpdateTask}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTaskByIdHook>>>, TError,{id: string;data: UpdateTask}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateTaskById =  useUpdateTaskByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateTaskByIdHook>>>, {id: string;data: UpdateTask}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTaskById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateTaskByIdHook>>>>
    export type UpdateTaskByIdMutationBody = UpdateTask
    export type UpdateTaskByIdMutationError = ErrorPayload

    export const useUpdateTaskById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTaskByIdHook>>>, TError,{id: string;data: UpdateTask}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateTaskByIdHook>>>,
        TError,
        {id: string;data: UpdateTask},
        TContext
      > => {

      const mutationOptions = useUpdateTaskByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteTaskByIdHook = () => {
        const deleteTaskById = useCustomInstance<Task>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteTaskById(
          {url: `/api/tasks/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteTaskById])
      }
    


export const useDeleteTaskByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteTaskByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteTaskByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteTaskById =  useDeleteTaskByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteTaskByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTaskById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteTaskByIdHook>>>>
    
    export type DeleteTaskByIdMutationError = ErrorPayload

    export const useDeleteTaskById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteTaskByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteTaskByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteTaskByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetTaskByIdHook = () => {
        const getTaskById = useCustomInstance<Task>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTaskById(
          {url: `/api/tasks/${id}`, method: 'GET', signal
    },
          options);
        }, [getTaskById])
      }
    

export const getGetTaskByIdQueryKey = (id: string,) => {
    return [`/api/tasks/${id}`] as const;
    }

    
export const useGetTaskByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskByIdQueryKey(id);

  const getTaskById =  useGetTaskByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>> = ({ signal }) => getTaskById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>>
export type GetTaskByIdQueryError = ErrorPayload


export function useGetTaskById<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskById<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskById<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTaskById<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTaskByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostTasksBatchHook = () => {
        const postTasksBatch = useCustomInstance<Task[]>();

        return useCallback((
    updateTasksBatch: UpdateTasksBatch,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postTasksBatch(
          {url: `/api/tasks/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTasksBatch
    },
          options);
        }, [postTasksBatch])
      }
    


export const usePostTasksBatchMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTasksBatchHook>>>, TError,{data: UpdateTasksBatch}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTasksBatchHook>>>, TError,{data: UpdateTasksBatch}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postTasksBatch =  usePostTasksBatchHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTasksBatchHook>>>, {data: UpdateTasksBatch}> = (props) => {
          const {data} = props ?? {};

          return  postTasksBatch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTasksBatchMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTasksBatchHook>>>>
    export type PostTasksBatchMutationBody = UpdateTasksBatch
    export type PostTasksBatchMutationError = ErrorPayload

    export const usePostTasksBatch = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTasksBatchHook>>>, TError,{data: UpdateTasksBatch}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTasksBatchHook>>>,
        TError,
        {data: UpdateTasksBatch},
        TContext
      > => {

      const mutationOptions = usePostTasksBatchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetTaskByTimeIdHook = () => {
        const getTaskByTimeId = useCustomInstance<TaskWithRelations>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTaskByTimeId(
          {url: `/api/tasks/byTime/${id}`, method: 'GET', signal
    },
          options);
        }, [getTaskByTimeId])
      }
    

export const getGetTaskByTimeIdQueryKey = (id: string,) => {
    return [`/api/tasks/byTime/${id}`] as const;
    }

    
export const useGetTaskByTimeIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskByTimeIdQueryKey(id);

  const getTaskByTimeId =  useGetTaskByTimeIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>> = ({ signal }) => getTaskByTimeId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskByTimeIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>>
export type GetTaskByTimeIdQueryError = ErrorPayload


export function useGetTaskByTimeId<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskByTimeId<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTaskByTimeId<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTaskByTimeId<TData = Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaskByTimeIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTaskByTimeIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostTaskCopyByIdHook = () => {
        const postTaskCopyById = useCustomInstance<TaskId>();

        return useCallback((
    copyTask: CopyTask,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postTaskCopyById(
          {url: `/api/tasks/copy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: copyTask
    },
          options);
        }, [postTaskCopyById])
      }
    


export const usePostTaskCopyByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTaskCopyByIdHook>>>, TError,{data: CopyTask}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTaskCopyByIdHook>>>, TError,{data: CopyTask}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postTaskCopyById =  usePostTaskCopyByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTaskCopyByIdHook>>>, {data: CopyTask}> = (props) => {
          const {data} = props ?? {};

          return  postTaskCopyById(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTaskCopyByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTaskCopyByIdHook>>>>
    export type PostTaskCopyByIdMutationBody = CopyTask
    export type PostTaskCopyByIdMutationError = ErrorPayload

    export const usePostTaskCopyById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTaskCopyByIdHook>>>, TError,{data: CopyTask}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTaskCopyByIdHook>>>,
        TError,
        {data: CopyTask},
        TContext
      > => {

      const mutationOptions = usePostTaskCopyByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostTaskHook = () => {
        const postTask = useCustomInstance<Task>();

        return useCallback((
    createTask: CreateTask,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postTask(
          {url: `/api/tasks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTask
    },
          options);
        }, [postTask])
      }
    


export const usePostTaskMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTaskHook>>>, TError,{data: CreateTask}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTaskHook>>>, TError,{data: CreateTask}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postTask =  usePostTaskHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTaskHook>>>, {data: CreateTask}> = (props) => {
          const {data} = props ?? {};

          return  postTask(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTaskMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTaskHook>>>>
    export type PostTaskMutationBody = CreateTask
    export type PostTaskMutationError = ErrorPayload

    export const usePostTask = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTaskHook>>>, TError,{data: CreateTask}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTaskHook>>>,
        TError,
        {data: CreateTask},
        TContext
      > => {

      const mutationOptions = usePostTaskMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetTasksHook = () => {
        const getTasks = useCustomInstance<TaskWithRelations[]>();

        return useCallback((
    params?: GetTasksParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getTasks(
          {url: `/api/tasks`, method: 'GET',
        params, signal
    },
          options);
        }, [getTasks])
      }
    

export const getGetTasksQueryKey = (params?: GetTasksParams,) => {
    return [`/api/tasks`, ...(params ? [params]: [])] as const;
    }

    
export const useGetTasksQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError = ErrorPayload>(params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(params);

  const getTasks =  useGetTasksHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>> = ({ signal }) => getTasks(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTasksQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>>
export type GetTasksQueryError = ErrorPayload


export function useGetTasks<TData = Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError = ErrorPayload>(
 params: undefined |  GetTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTasks<TData = Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError = ErrorPayload>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTasks<TData = Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError = ErrorPayload>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetTasks<TData = Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError = ErrorPayload>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTasksHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetTasksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostTempNativeLogHook = () => {
        const postTempNativeLog = useCustomInstance<Payload>();

        return useCallback((
    createTempNativeLog: CreateTempNativeLog,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postTempNativeLog(
          {url: `/api/tempNativeLog`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTempNativeLog
    },
          options);
        }, [postTempNativeLog])
      }
    


export const usePostTempNativeLogMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTempNativeLogHook>>>, TError,{data: CreateTempNativeLog}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTempNativeLogHook>>>, TError,{data: CreateTempNativeLog}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postTempNativeLog =  usePostTempNativeLogHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTempNativeLogHook>>>, {data: CreateTempNativeLog}> = (props) => {
          const {data} = props ?? {};

          return  postTempNativeLog(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTempNativeLogMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTempNativeLogHook>>>>
    export type PostTempNativeLogMutationBody = CreateTempNativeLog
    export type PostTempNativeLogMutationError = ErrorPayload

    export const usePostTempNativeLog = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTempNativeLogHook>>>, TError,{data: CreateTempNativeLog}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTempNativeLogHook>>>,
        TError,
        {data: CreateTempNativeLog},
        TContext
      > => {

      const mutationOptions = usePostTempNativeLogMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useUpdateUserRoleByIdHook = () => {
        const updateUserRoleById = useCustomInstance<UserRole>();

        return useCallback((
    id: string,
    updateUserRole: UpdateUserRole,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateUserRoleById(
          {url: `/api/userRoles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRole
    },
          options);
        }, [updateUserRoleById])
      }
    


export const useUpdateUserRoleByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserRoleByIdHook>>>, TError,{id: string;data: UpdateUserRole}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserRoleByIdHook>>>, TError,{id: string;data: UpdateUserRole}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateUserRoleById =  useUpdateUserRoleByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUserRoleByIdHook>>>, {id: string;data: UpdateUserRole}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUserRoleById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserRoleByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserRoleByIdHook>>>>
    export type UpdateUserRoleByIdMutationBody = UpdateUserRole
    export type UpdateUserRoleByIdMutationError = ErrorPayload

    export const useUpdateUserRoleById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserRoleByIdHook>>>, TError,{id: string;data: UpdateUserRole}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserRoleByIdHook>>>,
        TError,
        {id: string;data: UpdateUserRole},
        TContext
      > => {

      const mutationOptions = useUpdateUserRoleByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteUserRoleByIdHook = () => {
        const deleteUserRoleById = useCustomInstance<UserRole>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteUserRoleById(
          {url: `/api/userRoles/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteUserRoleById])
      }
    


export const useDeleteUserRoleByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserRoleByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserRoleByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteUserRoleById =  useDeleteUserRoleByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteUserRoleByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserRoleById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserRoleByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteUserRoleByIdHook>>>>
    
    export type DeleteUserRoleByIdMutationError = ErrorPayload

    export const useDeleteUserRoleById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserRoleByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteUserRoleByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteUserRoleByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetUserRoleByIdHook = () => {
        const getUserRoleById = useCustomInstance<UserRole>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUserRoleById(
          {url: `/api/userRoles/${id}`, method: 'GET', signal
    },
          options);
        }, [getUserRoleById])
      }
    

export const getGetUserRoleByIdQueryKey = (id: string,) => {
    return [`/api/userRoles/${id}`] as const;
    }

    
export const useGetUserRoleByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRoleByIdQueryKey(id);

  const getUserRoleById =  useGetUserRoleByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>> = ({ signal }) => getUserRoleById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRoleByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>>
export type GetUserRoleByIdQueryError = ErrorPayload


export function useGetUserRoleById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRoleById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRoleById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUserRoleById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUserRoleByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateUiSettingsByIdHook = () => {
        const updateUiSettingsById = useCustomInstance<UiSettings>();

        return useCallback((
    id: string,
    updateUiSettings: UpdateUiSettings,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateUiSettingsById(
          {url: `/api/userRoles/${id}/uiSettings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUiSettings
    },
          options);
        }, [updateUiSettingsById])
      }
    


export const useUpdateUiSettingsByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUiSettingsByIdHook>>>, TError,{id: string;data: UpdateUiSettings}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUiSettingsByIdHook>>>, TError,{id: string;data: UpdateUiSettings}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateUiSettingsById =  useUpdateUiSettingsByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUiSettingsByIdHook>>>, {id: string;data: UpdateUiSettings}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUiSettingsById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUiSettingsByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUiSettingsByIdHook>>>>
    export type UpdateUiSettingsByIdMutationBody = UpdateUiSettings
    export type UpdateUiSettingsByIdMutationError = ErrorPayload

    export const useUpdateUiSettingsById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUiSettingsByIdHook>>>, TError,{id: string;data: UpdateUiSettings}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUiSettingsByIdHook>>>,
        TError,
        {id: string;data: UpdateUiSettings},
        TContext
      > => {

      const mutationOptions = useUpdateUiSettingsByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetUiSettingsByIdHook = () => {
        const getUiSettingsById = useCustomInstance<UiSettings>();

        return useCallback((
    id: string,
    params: GetUiSettingsByIdParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUiSettingsById(
          {url: `/api/userRoles/${id}/uiSettings`, method: 'GET',
        params, signal
    },
          options);
        }, [getUiSettingsById])
      }
    

export const getGetUiSettingsByIdQueryKey = (id: string,
    params: GetUiSettingsByIdParams,) => {
    return [`/api/userRoles/${id}/uiSettings`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUiSettingsByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError = ErrorPayload>(id: string,
    params: GetUiSettingsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUiSettingsByIdQueryKey(id,params);

  const getUiSettingsById =  useGetUiSettingsByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>> = ({ signal }) => getUiSettingsById(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUiSettingsByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>>
export type GetUiSettingsByIdQueryError = ErrorPayload


export function useGetUiSettingsById<TData = Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError = ErrorPayload>(
 id: string,
    params: GetUiSettingsByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUiSettingsById<TData = Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError = ErrorPayload>(
 id: string,
    params: GetUiSettingsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUiSettingsById<TData = Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError = ErrorPayload>(
 id: string,
    params: GetUiSettingsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUiSettingsById<TData = Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError = ErrorPayload>(
 id: string,
    params: GetUiSettingsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUiSettingsByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUiSettingsByIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useInviteUserHook = () => {
        const inviteUser = useCustomInstance<User>();

        return useCallback((
    createUserRole: CreateUserRole,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return inviteUser(
          {url: `/api/userRoles/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRole
    },
          options);
        }, [inviteUser])
      }
    


export const useInviteUserMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInviteUserHook>>>, TError,{data: CreateUserRole}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInviteUserHook>>>, TError,{data: CreateUserRole}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const inviteUser =  useInviteUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useInviteUserHook>>>, {data: CreateUserRole}> = (props) => {
          const {data} = props ?? {};

          return  inviteUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useInviteUserHook>>>>
    export type InviteUserMutationBody = CreateUserRole
    export type InviteUserMutationError = ErrorPayload

    export const useInviteUser = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInviteUserHook>>>, TError,{data: CreateUserRole}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useInviteUserHook>>>,
        TError,
        {data: CreateUserRole},
        TContext
      > => {

      const mutationOptions = useInviteUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const usePostUserRoleHook = () => {
        const postUserRole = useCustomInstance<UserRole>();

        return useCallback((
    createUserRole: CreateUserRole,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postUserRole(
          {url: `/api/userRoles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRole
    },
          options);
        }, [postUserRole])
      }
    


export const usePostUserRoleMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserRoleHook>>>, TError,{data: CreateUserRole}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserRoleHook>>>, TError,{data: CreateUserRole}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postUserRole =  usePostUserRoleHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserRoleHook>>>, {data: CreateUserRole}> = (props) => {
          const {data} = props ?? {};

          return  postUserRole(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserRoleMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserRoleHook>>>>
    export type PostUserRoleMutationBody = CreateUserRole
    export type PostUserRoleMutationError = ErrorPayload

    export const usePostUserRole = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserRoleHook>>>, TError,{data: CreateUserRole}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserRoleHook>>>,
        TError,
        {data: CreateUserRole},
        TContext
      > => {

      const mutationOptions = usePostUserRoleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetUserRolesByOwnerIdHook = () => {
        const getUserRolesByOwnerId = useCustomInstance<UserRoleWithRelations[]>();

        return useCallback((
    params?: GetUserRolesByOwnerIdParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUserRolesByOwnerId(
          {url: `/api/userRoles`, method: 'GET',
        params, signal
    },
          options);
        }, [getUserRolesByOwnerId])
      }
    

export const getGetUserRolesByOwnerIdQueryKey = (params?: GetUserRolesByOwnerIdParams,) => {
    return [`/api/userRoles`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserRolesByOwnerIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError = ErrorPayload>(params?: GetUserRolesByOwnerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRolesByOwnerIdQueryKey(params);

  const getUserRolesByOwnerId =  useGetUserRolesByOwnerIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>> = ({ signal }) => getUserRolesByOwnerId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRolesByOwnerIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>>
export type GetUserRolesByOwnerIdQueryError = ErrorPayload


export function useGetUserRolesByOwnerId<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError = ErrorPayload>(
 params: undefined |  GetUserRolesByOwnerIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRolesByOwnerId<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError = ErrorPayload>(
 params?: GetUserRolesByOwnerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRolesByOwnerId<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError = ErrorPayload>(
 params?: GetUserRolesByOwnerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUserRolesByOwnerId<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError = ErrorPayload>(
 params?: GetUserRolesByOwnerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesByOwnerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUserRolesByOwnerIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetUserRoleSettingsByOwnerIdHook = () => {
        const getUserRoleSettingsByOwnerId = useCustomInstance<UserRole[]>();

        return useCallback((
    params?: GetUserRoleSettingsByOwnerIdParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUserRoleSettingsByOwnerId(
          {url: `/api/userRoles/settings`, method: 'GET',
        params, signal
    },
          options);
        }, [getUserRoleSettingsByOwnerId])
      }
    

export const getGetUserRoleSettingsByOwnerIdQueryKey = (params?: GetUserRoleSettingsByOwnerIdParams,) => {
    return [`/api/userRoles/settings`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUserRoleSettingsByOwnerIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError = ErrorPayload>(params?: GetUserRoleSettingsByOwnerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRoleSettingsByOwnerIdQueryKey(params);

  const getUserRoleSettingsByOwnerId =  useGetUserRoleSettingsByOwnerIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>> = ({ signal }) => getUserRoleSettingsByOwnerId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRoleSettingsByOwnerIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>>
export type GetUserRoleSettingsByOwnerIdQueryError = ErrorPayload


export function useGetUserRoleSettingsByOwnerId<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError = ErrorPayload>(
 params: undefined |  GetUserRoleSettingsByOwnerIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRoleSettingsByOwnerId<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError = ErrorPayload>(
 params?: GetUserRoleSettingsByOwnerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserRoleSettingsByOwnerId<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError = ErrorPayload>(
 params?: GetUserRoleSettingsByOwnerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUserRoleSettingsByOwnerId<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError = ErrorPayload>(
 params?: GetUserRoleSettingsByOwnerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRoleSettingsByOwnerIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUserRoleSettingsByOwnerIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateUserByIdHook = () => {
        const updateUserById = useCustomInstance<User>();

        return useCallback((
    id: string,
    updateUser: UpdateUser,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateUserById(
          {url: `/api/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUser
    },
          options);
        }, [updateUserById])
      }
    


export const useUpdateUserByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserByIdHook>>>, TError,{id: string;data: UpdateUser}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserByIdHook>>>, TError,{id: string;data: UpdateUser}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateUserById =  useUpdateUserByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUserByIdHook>>>, {id: string;data: UpdateUser}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUserById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserByIdHook>>>>
    export type UpdateUserByIdMutationBody = UpdateUser
    export type UpdateUserByIdMutationError = ErrorPayload

    export const useUpdateUserById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserByIdHook>>>, TError,{id: string;data: UpdateUser}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserByIdHook>>>,
        TError,
        {id: string;data: UpdateUser},
        TContext
      > => {

      const mutationOptions = useUpdateUserByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeletedUserByIdHook = () => {
        const deletedUserById = useCustomInstance<User>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deletedUserById(
          {url: `/api/users/${id}`, method: 'DELETE'
    },
          options);
        }, [deletedUserById])
      }
    


export const useDeletedUserByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeletedUserByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeletedUserByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deletedUserById =  useDeletedUserByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeletedUserByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletedUserById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletedUserByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeletedUserByIdHook>>>>
    
    export type DeletedUserByIdMutationError = ErrorPayload

    export const useDeletedUserById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeletedUserByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeletedUserByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeletedUserByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetUserByIdHook = () => {
        const getUserById = useCustomInstance<User>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUserById(
          {url: `/api/users/${id}`, method: 'GET', signal
    },
          options);
        }, [getUserById])
      }
    

export const getGetUserByIdQueryKey = (id: string,) => {
    return [`/api/users/${id}`] as const;
    }

    
export const useGetUserByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserByIdQueryKey(id);

  const getUserById =  useGetUserByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>> = ({ signal }) => getUserById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>>
export type GetUserByIdQueryError = ErrorPayload


export function useGetUserById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUserById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUserByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useExportSubscribersToEcomailHook = () => {
        const exportSubscribersToEcomail = useCustomInstance<Payload>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return exportSubscribersToEcomail(
          {url: `/api/users/export/ecomail`, method: 'GET', signal
    },
          options);
        }, [exportSubscribersToEcomail])
      }
    

export const getExportSubscribersToEcomailQueryKey = () => {
    return [`/api/users/export/ecomail`] as const;
    }

    
export const useExportSubscribersToEcomailQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError = ErrorPayload>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportSubscribersToEcomailQueryKey();

  const exportSubscribersToEcomail =  useExportSubscribersToEcomailHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>> = ({ signal }) => exportSubscribersToEcomail(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportSubscribersToEcomailQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>>
export type ExportSubscribersToEcomailQueryError = ErrorPayload


export function useExportSubscribersToEcomail<TData = Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError = ErrorPayload>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useExportSubscribersToEcomail<TData = Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useExportSubscribersToEcomail<TData = Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useExportSubscribersToEcomail<TData = Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError = ErrorPayload>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportSubscribersToEcomailHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useExportSubscribersToEcomailQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostUserHook = () => {
        const postUser = useCustomInstance<User>();

        return useCallback((
    createUser: CreateUser,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postUser(
          {url: `/api/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUser
    },
          options);
        }, [postUser])
      }
    


export const usePostUserMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserHook>>>, TError,{data: CreateUser}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserHook>>>, TError,{data: CreateUser}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postUser =  usePostUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostUserHook>>>, {data: CreateUser}> = (props) => {
          const {data} = props ?? {};

          return  postUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostUserHook>>>>
    export type PostUserMutationBody = CreateUser
    export type PostUserMutationError = ErrorPayload

    export const usePostUser = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostUserHook>>>, TError,{data: CreateUser}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostUserHook>>>,
        TError,
        {data: CreateUser},
        TContext
      > => {

      const mutationOptions = usePostUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetUsersHook = () => {
        const getUsers = useCustomInstance<User[]>();

        return useCallback((
    params?: GetUsersParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getUsers(
          {url: `/api/users`, method: 'GET',
        params, signal
    },
          options);
        }, [getUsers])
      }
    

export const getGetUsersQueryKey = (params?: GetUsersParams,) => {
    return [`/api/users`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUsersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorPayload>(params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);

  const getUsers =  useGetUsersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>> = ({ signal }) => getUsers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>>
export type GetUsersQueryError = ErrorPayload


export function useGetUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorPayload>(
 params: undefined |  GetUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorPayload>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorPayload>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorPayload>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useDeletedActualLoggedUserHook = () => {
        const deletedActualLoggedUser = useCustomInstance<Payload>();

        return useCallback((
    
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deletedActualLoggedUser(
          {url: `/api/users`, method: 'DELETE'
    },
          options);
        }, [deletedActualLoggedUser])
      }
    


export const useDeletedActualLoggedUserMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeletedActualLoggedUserHook>>>, TError,void, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeletedActualLoggedUserHook>>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deletedActualLoggedUser =  useDeletedActualLoggedUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeletedActualLoggedUserHook>>>, void> = () => {
          

          return  deletedActualLoggedUser(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletedActualLoggedUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeletedActualLoggedUserHook>>>>
    
    export type DeletedActualLoggedUserMutationError = ErrorPayload

    export const useDeletedActualLoggedUser = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeletedActualLoggedUserHook>>>, TError,void, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeletedActualLoggedUserHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = useDeletedActualLoggedUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetWhisperAddressByCoordinatesHook = () => {
        const getWhisperAddressByCoordinates = useCustomInstance<WhisperAddress[]>();

        return useCallback((
    lat: string,
    lon: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getWhisperAddressByCoordinates(
          {url: `/api/whisperAddress/${lat}/${lon}`, method: 'GET', signal
    },
          options);
        }, [getWhisperAddressByCoordinates])
      }
    

export const getGetWhisperAddressByCoordinatesQueryKey = (lat: string,
    lon: string,) => {
    return [`/api/whisperAddress/${lat}/${lon}`] as const;
    }

    
export const useGetWhisperAddressByCoordinatesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError = ErrorPayload>(lat: string,
    lon: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhisperAddressByCoordinatesQueryKey(lat,lon);

  const getWhisperAddressByCoordinates =  useGetWhisperAddressByCoordinatesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>> = ({ signal }) => getWhisperAddressByCoordinates(lat,lon, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(lat && lon), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhisperAddressByCoordinatesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>>
export type GetWhisperAddressByCoordinatesQueryError = ErrorPayload


export function useGetWhisperAddressByCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError = ErrorPayload>(
 lat: string,
    lon: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWhisperAddressByCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError = ErrorPayload>(
 lat: string,
    lon: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWhisperAddressByCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError = ErrorPayload>(
 lat: string,
    lon: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetWhisperAddressByCoordinates<TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError = ErrorPayload>(
 lat: string,
    lon: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressByCoordinatesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetWhisperAddressByCoordinatesQueryOptions(lat,lon,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetWhisperAddressHook = () => {
        const getWhisperAddress = useCustomInstance<WhisperAddress[]>();

        return useCallback((
    params: GetWhisperAddressParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getWhisperAddress(
          {url: `/api/whisperAddress`, method: 'GET',
        params, signal
    },
          options);
        }, [getWhisperAddress])
      }
    

export const getGetWhisperAddressQueryKey = (params: GetWhisperAddressParams,) => {
    return [`/api/whisperAddress`, ...(params ? [params]: [])] as const;
    }

    
export const useGetWhisperAddressQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError = ErrorPayload>(params: GetWhisperAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhisperAddressQueryKey(params);

  const getWhisperAddress =  useGetWhisperAddressHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>> = ({ signal }) => getWhisperAddress(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhisperAddressQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>>
export type GetWhisperAddressQueryError = ErrorPayload


export function useGetWhisperAddress<TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError = ErrorPayload>(
 params: GetWhisperAddressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWhisperAddress<TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError = ErrorPayload>(
 params: GetWhisperAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWhisperAddress<TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError = ErrorPayload>(
 params: GetWhisperAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetWhisperAddress<TData = Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError = ErrorPayload>(
 params: GetWhisperAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhisperAddressHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetWhisperAddressQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateWorkScheduleByIdHook = () => {
        const updateWorkScheduleById = useCustomInstance<WorkSchedule>();

        return useCallback((
    id: string,
    updateWorkSchedule: UpdateWorkSchedule,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return updateWorkScheduleById(
          {url: `/api/workSchedules/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkSchedule
    },
          options);
        }, [updateWorkScheduleById])
      }
    


export const useUpdateWorkScheduleByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateWorkScheduleByIdHook>>>, TError,{id: string;data: UpdateWorkSchedule}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateWorkScheduleByIdHook>>>, TError,{id: string;data: UpdateWorkSchedule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const updateWorkScheduleById =  useUpdateWorkScheduleByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateWorkScheduleByIdHook>>>, {id: string;data: UpdateWorkSchedule}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorkScheduleById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkScheduleByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateWorkScheduleByIdHook>>>>
    export type UpdateWorkScheduleByIdMutationBody = UpdateWorkSchedule
    export type UpdateWorkScheduleByIdMutationError = ErrorPayload

    export const useUpdateWorkScheduleById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateWorkScheduleByIdHook>>>, TError,{id: string;data: UpdateWorkSchedule}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateWorkScheduleByIdHook>>>,
        TError,
        {id: string;data: UpdateWorkSchedule},
        TContext
      > => {

      const mutationOptions = useUpdateWorkScheduleByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useDeleteWorkScheduleByIdHook = () => {
        const deleteWorkScheduleById = useCustomInstance<WorkSchedule>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return deleteWorkScheduleById(
          {url: `/api/workSchedules/${id}`, method: 'DELETE'
    },
          options);
        }, [deleteWorkScheduleById])
      }
    


export const useDeleteWorkScheduleByIdMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteWorkScheduleByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteWorkScheduleByIdHook>>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const deleteWorkScheduleById =  useDeleteWorkScheduleByIdHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteWorkScheduleByIdHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWorkScheduleById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkScheduleByIdMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteWorkScheduleByIdHook>>>>
    
    export type DeleteWorkScheduleByIdMutationError = ErrorPayload

    export const useDeleteWorkScheduleById = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteWorkScheduleByIdHook>>>, TError,{id: string}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteWorkScheduleByIdHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteWorkScheduleByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetWorkScheduleByIdHook = () => {
        const getWorkScheduleById = useCustomInstance<WorkSchedule>();

        return useCallback((
    id: string,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getWorkScheduleById(
          {url: `/api/workSchedules/${id}`, method: 'GET', signal
    },
          options);
        }, [getWorkScheduleById])
      }
    

export const getGetWorkScheduleByIdQueryKey = (id: string,) => {
    return [`/api/workSchedules/${id}`] as const;
    }

    
export const useGetWorkScheduleByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError = ErrorPayload>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkScheduleByIdQueryKey(id);

  const getWorkScheduleById =  useGetWorkScheduleByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>> = ({ signal }) => getWorkScheduleById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkScheduleByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>>
export type GetWorkScheduleByIdQueryError = ErrorPayload


export function useGetWorkScheduleById<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError = ErrorPayload>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWorkScheduleById<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWorkScheduleById<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetWorkScheduleById<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError = ErrorPayload>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkScheduleByIdHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetWorkScheduleByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostWorkScheduleHook = () => {
        const postWorkSchedule = useCustomInstance<WorkSchedule>();

        return useCallback((
    createWorkSchedule: CreateWorkSchedule,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,) => {
        return postWorkSchedule(
          {url: `/api/workSchedules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorkSchedule
    },
          options);
        }, [postWorkSchedule])
      }
    


export const usePostWorkScheduleMutationOptions = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleHook>>>, TError,{data: CreateWorkSchedule}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleHook>>>, TError,{data: CreateWorkSchedule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      const postWorkSchedule =  usePostWorkScheduleHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleHook>>>, {data: CreateWorkSchedule}> = (props) => {
          const {data} = props ?? {};

          return  postWorkSchedule(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWorkScheduleMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleHook>>>>
    export type PostWorkScheduleMutationBody = CreateWorkSchedule
    export type PostWorkScheduleMutationError = ErrorPayload

    export const usePostWorkSchedule = <TError = ErrorPayload,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleHook>>>, TError,{data: CreateWorkSchedule}, TContext>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostWorkScheduleHook>>>,
        TError,
        {data: CreateWorkSchedule},
        TContext
      > => {

      const mutationOptions = usePostWorkScheduleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const useGetWorkSchedulesHook = () => {
        const getWorkSchedules = useCustomInstance<WorkSchedule[]>();

        return useCallback((
    params?: GetWorkSchedulesParams,
 options?: SecondParameter<ReturnType<typeof useCustomInstance>>,signal?: AbortSignal
) => {
        return getWorkSchedules(
          {url: `/api/workSchedules`, method: 'GET',
        params, signal
    },
          options);
        }, [getWorkSchedules])
      }
    

export const getGetWorkSchedulesQueryKey = (params?: GetWorkSchedulesParams,) => {
    return [`/api/workSchedules`, ...(params ? [params]: [])] as const;
    }

    
export const useGetWorkSchedulesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError = ErrorPayload>(params?: GetWorkSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkSchedulesQueryKey(params);

  const getWorkSchedules =  useGetWorkSchedulesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>> = ({ signal }) => getWorkSchedules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkSchedulesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>>
export type GetWorkSchedulesQueryError = ErrorPayload


export function useGetWorkSchedules<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError = ErrorPayload>(
 params: undefined |  GetWorkSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWorkSchedules<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError = ErrorPayload>(
 params?: GetWorkSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWorkSchedules<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError = ErrorPayload>(
 params?: GetWorkSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }

export function useGetWorkSchedules<TData = Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError = ErrorPayload>(
 params?: GetWorkSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkSchedulesHook>>>, TError, TData>>, request?: SecondParameter<ReturnType<typeof useCustomInstance>>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = useGetWorkSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




